/**
 * A function to create a log object for the 'gdprAutomationDeleteRequestEvents' event (evid: 4103)
 *
 * Event description: events revolving around user requesting gdpr deletion
 *
 * @param {gdprAutomationDeleteRequestEventsParams} params - The parameters for this event
 * @return {LogObject<gdprAutomationDeleteRequestEventsParams>} LogObject<gdprAutomationDeleteRequestEventsParams>
 */
export function gdprAutomationDeleteRequestEvents(params) {
    throw new Error('gdprAutomationDeleteRequestEvents cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'clickTheWasItHelpfulButtons' event (evid: 501)
 *
 * Event description: fired when a user votes helpful/unhelpful
 *
 * @param {clickTheWasItHelpfulButtonsParams} params - The parameters for this event
 * @return {LogObject<clickTheWasItHelpfulButtonsParams>} LogObject<clickTheWasItHelpfulButtonsParams>
 */
export function clickTheWasItHelpfulButtons(params) {
    throw new Error('clickTheWasItHelpfulButtons cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'wixContactSolutionView' event (evid: 573)
 *
 * Event description: A solution is presented to the user in "step 3"
 *
 * @param {wixContactSolutionViewParams} params - The parameters for this event
 * @return {LogObject<wixContactSolutionViewParams>} LogObject<wixContactSolutionViewParams>
 */
export function wixContactSolutionView(params) {
    throw new Error('wixContactSolutionView cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'pageView' event (evid: 531)
 *
 * Event description: Fired when the user enters a page in the KB
 *
 * @param {pageViewParams} params - The parameters for this event
 * @return {LogObject<pageViewParams>} LogObject<pageViewParams>
 */
export function pageView(params) {
    throw new Error('pageView cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'askingAQuestion' event (evid: 520)
 *
 * Event description: Fired when the user starts searching in the search bar
 *
 * @param {askingAQuestionParams} params - The parameters for this event
 * @return {LogObject<askingAQuestionParams>} LogObject<askingAQuestionParams>
 */
export function askingAQuestion(params) {
    throw new Error('askingAQuestion cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'gotNoAnswer' event (evid: 537)
 *
 * Event description: Fire when no results return after the user search in the help center
 *
 * @param {gotNoAnswerParams} params - The parameters for this event
 * @return {LogObject<gotNoAnswerParams>} LogObject<gotNoAnswerParams>
 */
export function gotNoAnswer(params) {
    throw new Error('gotNoAnswer cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'clickTheIHaveThisProblemBugButton' event (evid: 503)
 *
 * Event description: fired when a user votes for a known issue
 *
 * @param {clickTheIHaveThisProblemBugButtonParams} params - The parameters for this event
 * @return {LogObject<clickTheIHaveThisProblemBugButtonParams>} LogObject<clickTheIHaveThisProblemBugButtonParams>
 */
export function clickTheIHaveThisProblemBugButton(params) {
    throw new Error('clickTheIHaveThisProblemBugButton cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'clickTheFollowUnFollowButton' event (evid: 504)
 *
 * Event description: fired when users (wix users) click the top bar chackbox to follow/unfollow an article in the help center
 *
 * @param {clickTheFollowUnFollowButtonParams} params - The parameters for this event
 * @return {LogObject<clickTheFollowUnFollowButtonParams>} LogObject<clickTheFollowUnFollowButtonParams>
 */
export function clickTheFollowUnFollowButton(params) {
    throw new Error('clickTheFollowUnFollowButton cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'wixContactSubmitCallbackForm' event (evid: 579)
 *
 * Event description: Clicking the "Request Callback" button at the bottom of the callback form
 *
 * @param {wixContactSubmitCallbackFormParams} params - The parameters for this event
 * @return {LogObject<wixContactSubmitCallbackFormParams>} LogObject<wixContactSubmitCallbackFormParams>
 */
export function wixContactSubmitCallbackForm(params) {
    throw new Error('wixContactSubmitCallbackForm cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'clickOnAnswer' event (evid: 521)
 *
 * Event description: Fired when the user selects one of the search results
 *
 * @param {clickOnAnswerParams} params - The parameters for this event
 * @return {LogObject<clickOnAnswerParams>} LogObject<clickOnAnswerParams>
 */
export function clickOnAnswer(params) {
    throw new Error('clickOnAnswer cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'clickTheSeeAllResultsLink' event (evid: 522)
 *
 * Event description: Fired when the user clicks the option to see all search results
 *
 * @param {clickTheSeeAllResultsLinkParams} params - The parameters for this event
 * @return {LogObject<clickTheSeeAllResultsLinkParams>} LogObject<clickTheSeeAllResultsLinkParams>
 */
export function clickTheSeeAllResultsLink(params) {
    throw new Error('clickTheSeeAllResultsLink cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'wixContactClickOnChatLive' event (evid: 596)
 *
 * Event description: Clicking the "Chat LIve" button
 *
 * @param {wixContactClickOnChatLiveParams} params - The parameters for this event
 * @return {LogObject<wixContactClickOnChatLiveParams>} LogObject<wixContactClickOnChatLiveParams>
 */
export function wixContactClickOnChatLive(params) {
    throw new Error('wixContactClickOnChatLive cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'wixContactCallbackSuccess' event (evid: 580)
 *
 * Event description: User was able to schedule a callback
 *
 * @param {wixContactCallbackSuccessParams} params - The parameters for this event
 * @return {LogObject<wixContactCallbackSuccessParams>} LogObject<wixContactCallbackSuccessParams>
 */
export function wixContactCallbackSuccess(params) {
    throw new Error('wixContactCallbackSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'wixContactOpenWixContactSuccess' event (evid: 570)
 *
 * Event description: User opens "Wix Contact" from desktop. The Contact form finished loading.
 *
 * @param {wixContactOpenWixContactSuccessParams} params - The parameters for this event
 * @return {LogObject<wixContactOpenWixContactSuccessParams>} LogObject<wixContactOpenWixContactSuccessParams>
 */
export function wixContactOpenWixContactSuccess(params) {
    throw new Error('wixContactOpenWixContactSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'wixContactOpenChatSuccess' event (evid: 597)
 *
 * Event description: User was able to open a chat conversation
 *
 * @param {wixContactOpenChatSuccessParams} params - The parameters for this event
 * @return {LogObject<wixContactOpenChatSuccessParams>} LogObject<wixContactOpenChatSuccessParams>
 */
export function wixContactOpenChatSuccess(params) {
    throw new Error('wixContactOpenChatSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'wixContactClickOnRequestCallback' event (evid: 578)
 *
 * Event description: Clicking the "Request Callback" button
 *
 * @param {wixContactClickOnRequestCallbackParams} params - The parameters for this event
 * @return {LogObject<wixContactClickOnRequestCallbackParams>} LogObject<wixContactClickOnRequestCallbackParams>
 */
export function wixContactClickOnRequestCallback(params) {
    throw new Error('wixContactClickOnRequestCallback cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'clientLoadAttempt' event (evid: 558)
 *
 * Event description: Sent when the page is served and loaded, but the actual app was not fully rendered yet.
 *
 * @param {clientLoadAttemptParams} params - The parameters for this event
 * @return {LogObject<clientLoadAttemptParams>} LogObject<clientLoadAttemptParams>
 */
export function clientLoadAttempt(params) {
    throw new Error('clientLoadAttempt cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'voteUnVoteForWishList' event (evid: 502)
 *
 * Event description: fired when a user votes for a feature request
 *
 * @param {voteUnVoteForWishListParams} params - The parameters for this event
 * @return {LogObject<voteUnVoteForWishListParams>} LogObject<voteUnVoteForWishListParams>
 */
export function voteUnVoteForWishList(params) {
    throw new Error('voteUnVoteForWishList cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'unifiedChatAgentSendMessage' event (evid: 3007)
 *
 * Event description: The event is triggered whenever an agent clicks on send message (on answers side - not on the user UI side)
 *
 * @param {unifiedChatAgentSendMessageParams} params - The parameters for this event
 * @return {LogObject<unifiedChatAgentSendMessageParams>} LogObject<unifiedChatAgentSendMessageParams>
 */
export function unifiedChatAgentSendMessage(params) {
    throw new Error('unifiedChatAgentSendMessage cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'smsVerificationTooManyMessages' event (evid: 1084)
 *
 * Event description: The user has passed the limit for number of SMS messages sent
 *
 * @param {smsVerificationTooManyMessagesParams} params - The parameters for this event
 * @return {LogObject<smsVerificationTooManyMessagesParams>} LogObject<smsVerificationTooManyMessagesParams>
 */
export function smsVerificationTooManyMessages(params) {
    throw new Error('smsVerificationTooManyMessages cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'liveChatLoadChat' event (evid: 1103)
 *
 * Event description: When the user switches to live chat
 *
 * @param {liveChatLoadChatParams} params - The parameters for this event
 * @return {LogObject<liveChatLoadChatParams>} LogObject<liveChatLoadChatParams>
 */
export function liveChatLoadChat(params) {
    throw new Error('liveChatLoadChat cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotCloseWidget' event (evid: 1110)
 *
 * Event description: The chatbot widget is closed after being opened
 *
 * @param {chatbotCloseWidgetParams} params - The parameters for this event
 * @return {LogObject<chatbotCloseWidgetParams>} LogObject<chatbotCloseWidgetParams>
 */
export function chatbotCloseWidget(params) {
    throw new Error('chatbotCloseWidget cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotArticlePrediction' event (evid: 1093)
 *
 * Event description: Sent when a user is shown an article from the data science prediction model
 *
 * @param {chatbotArticlePredictionParams} params - The parameters for this event
 * @return {LogObject<chatbotArticlePredictionParams>} LogObject<chatbotArticlePredictionParams>
 */
export function chatbotArticlePrediction(params) {
    throw new Error('chatbotArticlePrediction cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotUserMessage' event (evid: 1052)
 *
 * Event description: The user clicks on any part of the chatbot
 *
 * @param {chatbotUserMessageParams} params - The parameters for this event
 * @return {LogObject<chatbotUserMessageParams>} LogObject<chatbotUserMessageParams>
 */
export function chatbotUserMessage(params) {
    throw new Error('chatbotUserMessage cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotChatbotMessage' event (evid: 1053)
 *
 * Event description: Sent every time the chatbot sends a batch of messages to the user
 *
 * @param {chatbotChatbotMessageParams} params - The parameters for this event
 * @return {LogObject<chatbotChatbotMessageParams>} LogObject<chatbotChatbotMessageParams>
 */
export function chatbotChatbotMessage(params) {
    throw new Error('chatbotChatbotMessage cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotLoadWidget' event (evid: 1111)
 *
 * Event description: The chatbot widget is loaded
 *
 * @param {chatbotLoadWidgetParams} params - The parameters for this event
 * @return {LogObject<chatbotLoadWidgetParams>} LogObject<chatbotLoadWidgetParams>
 */
export function chatbotLoadWidget(params) {
    throw new Error('chatbotLoadWidget cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotChatbotLoadFailure' event (evid: 1094)
 *
 * Event description: User fails to loads the chatbot
 *
 * @param {chatbotChatbotLoadFailureParams} params - The parameters for this event
 * @return {LogObject<chatbotChatbotLoadFailureParams>} LogObject<chatbotChatbotLoadFailureParams>
 */
export function chatbotChatbotLoadFailure(params) {
    throw new Error('chatbotChatbotLoadFailure cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'widgetPageEngagement' event (evid: 1121)
 *
 * Event description: Fires every 10 seconds to indicate the user is active on the page
 *
 * @param {widgetPageEngagementParams} params - The parameters for this event
 * @return {LogObject<widgetPageEngagementParams>} LogObject<widgetPageEngagementParams>
 */
export function widgetPageEngagement(params) {
    throw new Error('widgetPageEngagement cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotLoadWidgetAttempt' event (evid: 1113)
 *
 * Event description: The user attempts to load the chatbot widget
 *
 * @param {chatbotLoadWidgetAttemptParams} params - The parameters for this event
 * @return {LogObject<chatbotLoadWidgetAttemptParams>} LogObject<chatbotLoadWidgetAttemptParams>
 */
export function chatbotLoadWidgetAttempt(params) {
    throw new Error('chatbotLoadWidgetAttempt cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotClickOnSolution' event (evid: 1159)
 *
 * Event description: Fires every time a user clicks on a solution (e.g. article) in order to view the full solution
 *
 * @param {chatbotClickOnSolutionParams} params - The parameters for this event
 * @return {LogObject<chatbotClickOnSolutionParams>} LogObject<chatbotClickOnSolutionParams>
 */
export function chatbotClickOnSolution(params) {
    throw new Error('chatbotClickOnSolution cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotNotifications' event (evid: 1162)
 *
 * Event description: Fires when a new notification is fired from the Chabot while the chatbot is minimized
 *
 * @param {chatbotNotificationsParams} params - The parameters for this event
 * @return {LogObject<chatbotNotificationsParams>} LogObject<chatbotNotificationsParams>
 */
export function chatbotNotifications(params) {
    throw new Error('chatbotNotifications cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotFunctionFailure' event (evid: 1095)
 *
 * Event description: A chatbot function fails
 *
 * @param {chatbotFunctionFailureParams} params - The parameters for this event
 * @return {LogObject<chatbotFunctionFailureParams>} LogObject<chatbotFunctionFailureParams>
 */
export function chatbotFunctionFailure(params) {
    throw new Error('chatbotFunctionFailure cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'widgetEmptySearchResults' event (evid: 1160)
 *
 * Event description: Fires when an empty search result is presented to the user
 *
 * @param {widgetEmptySearchResultsParams} params - The parameters for this event
 * @return {LogObject<widgetEmptySearchResultsParams>} LogObject<widgetEmptySearchResultsParams>
 */
export function widgetEmptySearchResults(params) {
    throw new Error('widgetEmptySearchResults cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotLoadWidgetFailure' event (evid: 1114)
 *
 * Event description: The user fails to open the chatbot widget
 *
 * @param {chatbotLoadWidgetFailureParams} params - The parameters for this event
 * @return {LogObject<chatbotLoadWidgetFailureParams>} LogObject<chatbotLoadWidgetFailureParams>
 */
export function chatbotLoadWidgetFailure(params) {
    throw new Error('chatbotLoadWidgetFailure cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'liveChatAgentEntersLeavesChat' event (evid: 1102)
 *
 * Event description: Sent when the agent enters or leaves the chat
 *
 * @param {liveChatAgentEntersLeavesChatParams} params - The parameters for this event
 * @return {LogObject<liveChatAgentEntersLeavesChatParams>} LogObject<liveChatAgentEntersLeavesChatParams>
 */
export function liveChatAgentEntersLeavesChat(params) {
    throw new Error('liveChatAgentEntersLeavesChat cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'liveChatAgentMessage' event (evid: 1100)
 *
 * Event description: Sent every time a Wix agent sends a message to the user
 *
 * @param {liveChatAgentMessageParams} params - The parameters for this event
 * @return {LogObject<liveChatAgentMessageParams>} LogObject<liveChatAgentMessageParams>
 */
export function liveChatAgentMessage(params) {
    throw new Error('liveChatAgentMessage cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotOpenWidget' event (evid: 1109)
 *
 * Event description: The chatbot widget is opened after being minimized
 *
 * @param {chatbotOpenWidgetParams} params - The parameters for this event
 * @return {LogObject<chatbotOpenWidgetParams>} LogObject<chatbotOpenWidgetParams>
 */
export function chatbotOpenWidget(params) {
    throw new Error('chatbotOpenWidget cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotIntentMatched' event (evid: 1057)
 *
 * Event description: Sent when the chatbot tries to understand a user's free text message.
 *
 * @param {chatbotIntentMatchedParams} params - The parameters for this event
 * @return {LogObject<chatbotIntentMatchedParams>} LogObject<chatbotIntentMatchedParams>
 */
export function chatbotIntentMatched(params) {
    throw new Error('chatbotIntentMatched cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'widgetPresentedContent' event (evid: 1119)
 *
 * Event description: Fires when suggested solutions are presented to the user
 *
 * @param {widgetPresentedContentParams} params - The parameters for this event
 * @return {LogObject<widgetPresentedContentParams>} LogObject<widgetPresentedContentParams>
 */
export function widgetPresentedContent(params) {
    throw new Error('widgetPresentedContent cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotLoadChatbot' event (evid: 1051)
 *
 * Event description: User successfully loads the chatbot
 *
 * @param {chatbotLoadChatbotParams} params - The parameters for this event
 * @return {LogObject<chatbotLoadChatbotParams>} LogObject<chatbotLoadChatbotParams>
 */
export function chatbotLoadChatbot(params) {
    throw new Error('chatbotLoadChatbot cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'widgetContentInteraction' event (evid: 1120)
 *
 * Event description: Fires with a click on one of the content items or buttons in the help center widget
 *
 * @param {widgetContentInteractionParams} params - The parameters for this event
 * @return {LogObject<widgetContentInteractionParams>} LogObject<widgetContentInteractionParams>
 */
export function widgetContentInteraction(params) {
    throw new Error('widgetContentInteraction cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'liveChatCloseChat' event (evid: 1101)
 *
 * Event description: The user or agent closes the chat
 *
 * @param {liveChatCloseChatParams} params - The parameters for this event
 * @return {LogObject<liveChatCloseChatParams>} LogObject<liveChatCloseChatParams>
 */
export function liveChatCloseChat(params) {
    throw new Error('liveChatCloseChat cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'liveChatChatStatus' event (evid: 1104)
 *
 * Event description: Returns whether or not live chat is available to the user
 *
 * @param {liveChatChatStatusParams} params - The parameters for this event
 * @return {LogObject<liveChatChatStatusParams>} LogObject<liveChatChatStatusParams>
 */
export function liveChatChatStatus(params) {
    throw new Error('liveChatChatStatus cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'pageEngagement' event (evid: 8202)
 *
 * Event description: Fired every 10 seconds and indicates if within that timeframe the user performed one of the following actions: scroll, scroll all the way to the bottom of the screen, moved mouse, clicked.
 *
 * @param {pageEngagementParams} params - The parameters for this event
 * @return {LogObject<pageEngagementParams>} LogObject<pageEngagementParams>
 */
export function pageEngagement(params) {
    throw new Error('pageEngagement cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'potentialSurveyAnswersWebhookTriggered' event (evid: 4203)
 *
 * Event description: Fired when a potential survey's ticket or call received from Answers
 *
 * @param {potentialSurveyAnswersWebhookTriggeredParams} params - The parameters for this event
 * @return {LogObject<potentialSurveyAnswersWebhookTriggeredParams>} LogObject<potentialSurveyAnswersWebhookTriggeredParams>
 */
export function potentialSurveyAnswersWebhookTriggered(params) {
    throw new Error('potentialSurveyAnswersWebhookTriggered cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'surveyFilteredOutByLogic' event (evid: 4204)
 *
 * Event description: Fired when a potential survey's ticket from Answers got filtered by the logic. This event reflecting the reason why the ticket was filtered.
 *
 * @param {surveyFilteredOutByLogicParams} params - The parameters for this event
 * @return {LogObject<surveyFilteredOutByLogicParams>} LogObject<surveyFilteredOutByLogicParams>
 */
export function surveyFilteredOutByLogic(params) {
    throw new Error('surveyFilteredOutByLogic cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotConversationExpired' event (evid: 1124)
 *
 * Event description: Fires every time the conversation expired
 *
 * @param {chatbotConversationExpiredParams} params - The parameters for this event
 * @return {LogObject<chatbotConversationExpiredParams>} LogObject<chatbotConversationExpiredParams>
 */
export function chatbotConversationExpired(params) {
    throw new Error('chatbotConversationExpired cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotVersionUnDeployment' event (evid: 1126)
 *
 * Event description: Fired when a chatbot version is being deployed/undeployed
 *
 * @param {chatbotVersionUnDeploymentParams} params - The parameters for this event
 * @return {LogObject<chatbotVersionUnDeploymentParams>} LogObject<chatbotVersionUnDeploymentParams>
 */
export function chatbotVersionUnDeployment(params) {
    throw new Error('chatbotVersionUnDeployment cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'accountsEntryPointTicketCreatedViaApiSuccess' event (evid: 7200)
 *
 * @param {accountsEntryPointTicketCreatedViaApiSuccessParams} params - The parameters for this event
 * @return {LogObject<accountsEntryPointTicketCreatedViaApiSuccessParams>} LogObject<accountsEntryPointTicketCreatedViaApiSuccessParams>
 */
export function accountsEntryPointTicketCreatedViaApiSuccess(params) {
    throw new Error('accountsEntryPointTicketCreatedViaApiSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'accountsEntryPointCreateTicketViaApiFailed' event (evid: 7201)
 *
 * Event description: When the API fails to create a ticket/requestCallback/etc on behalf of the user.
 *
 * @param {accountsEntryPointCreateTicketViaApiFailedParams} params - The parameters for this event
 * @return {LogObject<accountsEntryPointCreateTicketViaApiFailedParams>} LogObject<accountsEntryPointCreateTicketViaApiFailedParams>
 */
export function accountsEntryPointCreateTicketViaApiFailed(params) {
    throw new Error('accountsEntryPointCreateTicketViaApiFailed cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'accountsEntryPointCreateTicketViaApiAttempt' event (evid: 7202)
 *
 * @param {accountsEntryPointCreateTicketViaApiAttemptParams} params - The parameters for this event
 * @return {LogObject<accountsEntryPointCreateTicketViaApiAttemptParams>} LogObject<accountsEntryPointCreateTicketViaApiAttemptParams>
 */
export function accountsEntryPointCreateTicketViaApiAttempt(params) {
    throw new Error('accountsEntryPointCreateTicketViaApiAttempt cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'chatbotChatFilterSave' event (evid: 1130)
 *
 * Event description: Fires when clicking on the “Save” button in the Chat Filter settings
 *
 * @param {chatbotChatFilterSaveParams} params - The parameters for this event
 * @return {LogObject<chatbotChatFilterSaveParams>} LogObject<chatbotChatFilterSaveParams>
 */
export function chatbotChatFilterSave(params) {
    throw new Error('chatbotChatFilterSave cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'widgetSessionExpired' event (evid: 8901)
 *
 * Event description: Fires when widget session is expired
 *
 * @param {widgetSessionExpiredParams} params - The parameters for this event
 * @return {LogObject<widgetSessionExpiredParams>} LogObject<widgetSessionExpiredParams>
 */
export function widgetSessionExpired(params) {
    throw new Error('widgetSessionExpired cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'newUserManagerBackendEvents' event (evid: 3200)
 *
 * Event description: Client requests/alters data from User Manager server.      Important; some events are triggered from other platforms that are using the same services - use the 'source' field to filter
 *
 * @param {newUserManagerBackendEventsParams} params - The parameters for this event
 * @return {LogObject<newUserManagerBackendEventsParams>} LogObject<newUserManagerBackendEventsParams>
 */
export function newUserManagerBackendEvents(params) {
    throw new Error('newUserManagerBackendEvents cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'newUserManagerImpersonateEvents' event (evid: 3300)
 *
 * Event description: Client impersonated a Wix user through the User Manager.     Important; some events are triggered from other platforms that are using the same services - use the 'source' field to filter
 *
 * @param {newUserManagerImpersonateEventsParams} params - The parameters for this event
 * @return {LogObject<newUserManagerImpersonateEventsParams>} LogObject<newUserManagerImpersonateEventsParams>
 */
export function newUserManagerImpersonateEvents(params) {
    throw new Error('newUserManagerImpersonateEvents cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appGeneralPageLoadAttempt' event (evid: 1950)
 *
 * Event description: General event - like "page view". This event is sent after the app is already loaded, and the specific page/module is starting to load
 *
 * @param {appGeneralPageLoadAttemptParams} params - The parameters for this event
 * @return {LogObject<appGeneralPageLoadAttemptParams>} LogObject<appGeneralPageLoadAttemptParams>
 */
export function appGeneralPageLoadAttempt(params) {
    throw new Error('appGeneralPageLoadAttempt cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicClickTheSeeAllResultsLink' event (evid: 2007)
 *
 * Event description: click the (see all results) link (similar to evid 522 in src 4)
 *
 * @param {publicClickTheSeeAllResultsLinkParams} params - The parameters for this event
 * @return {LogObject<publicClickTheSeeAllResultsLinkParams>} LogObject<publicClickTheSeeAllResultsLinkParams>
 */
export function publicClickTheSeeAllResultsLink(params) {
    throw new Error('publicClickTheSeeAllResultsLink cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appGeneralPageLoadFail' event (evid: 1952)
 *
 * Event description: General event - like "page view"
 *
 * @param {appGeneralPageLoadFailParams} params - The parameters for this event
 * @return {LogObject<appGeneralPageLoadFailParams>} LogObject<appGeneralPageLoadFailParams>
 */
export function appGeneralPageLoadFail(params) {
    throw new Error('appGeneralPageLoadFail cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'answersBannerView' event (evid: 4908)
 *
 * Event description: Fired when the user enters a page that has a banner
 *
 * @param {answersBannerViewParams} params - The parameters for this event
 * @return {LogObject<answersBannerViewParams>} LogObject<answersBannerViewParams>
 */
export function answersBannerView(params) {
    throw new Error('answersBannerView cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicSubmitTicketValidationError' event (evid: 2511)
 *
 * Event description: Public - "Submit Ticket" - validation error
 *
 * @param {publicSubmitTicketValidationErrorParams} params - The parameters for this event
 * @return {LogObject<publicSubmitTicketValidationErrorParams>} LogObject<publicSubmitTicketValidationErrorParams>
 */
export function publicSubmitTicketValidationError(params) {
    throw new Error('publicSubmitTicketValidationError cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteAReplyClick' event (evid: 1012)
 *
 * Event description: Click Delete a reply from a ticket. event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteAReplyClickParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxDeleteAReplyClickParams>} LogObject<appTicketsOneInboxDeleteAReplyClickParams>
 */
export function appTicketsOneInboxDeleteAReplyClick(params) {
    throw new Error('appTicketsOneInboxDeleteAReplyClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'aiSummaryErrors' event (evid: 4918)
 *
 * Event description: There are a few possible reasons why the AI summary fails such as: API failed , Realtime Event Not Received, Saved Reply Not Found
 *
 * @param {aiSummaryErrorsParams} params - The parameters for this event
 * @return {LogObject<aiSummaryErrorsParams>} LogObject<aiSummaryErrorsParams>
 */
export function aiSummaryErrors(params) {
    throw new Error('aiSummaryErrors cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appSettingsChangeSuccess' event (evid: 1451)
 *
 * Event description: Change event attempt: save/toggle in the setting section
 *
 * @param {appSettingsChangeSuccessParams} params - The parameters for this event
 * @return {LogObject<appSettingsChangeSuccessParams>} LogObject<appSettingsChangeSuccessParams>
 */
export function appSettingsChangeSuccess(params) {
    throw new Error('appSettingsChangeSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'callTheAiSummary' event (evid: 4916)
 *
 * Event description: The event that marks when the summary was requested to be generated when Call the Ai summary
 *
 * @param {callTheAiSummaryParams} params - The parameters for this event
 * @return {LogObject<callTheAiSummaryParams>} LogObject<callTheAiSummaryParams>
 */
export function callTheAiSummary(params) {
    throw new Error('callTheAiSummary cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'devGeneralTwilioEvent' event (evid: 99)
 *
 * Event description: This is a general event for data we get from Twilio. We use for QA and debug.
 *
 * @param {devGeneralTwilioEventParams} params - The parameters for this event
 * @return {LogObject<devGeneralTwilioEventParams>} LogObject<devGeneralTwilioEventParams>
 */
export function devGeneralTwilioEvent(params) {
    throw new Error('devGeneralTwilioEvent cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'channelAvailabilityTransfers' event (evid: 4925)
 *
 * Event description: before offering the expert to make the transfer and the relevant transfer type,  the API checks if there are experts not offline, and the queue in business hours
 *
 * @param {channelAvailabilityTransfersParams} params - The parameters for this event
 * @return {LogObject<channelAvailabilityTransfersParams>} LogObject<channelAvailabilityTransfersParams>
 */
export function channelAvailabilityTransfers(params) {
    throw new Error('channelAvailabilityTransfers cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicSelectSearchResult' event (evid: 2006)
 *
 * Event description: click on answer (similar to evid 521 in src 4)
 *
 * @param {publicSelectSearchResultParams} params - The parameters for this event
 * @return {LogObject<publicSelectSearchResultParams>} LogObject<publicSelectSearchResultParams>
 */
export function publicSelectSearchResult(params) {
    throw new Error('publicSelectSearchResult cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicPageViewArticle' event (evid: 1997)
 *
 * Event description: Article - page view
 *
 * @param {publicPageViewArticleParams} params - The parameters for this event
 * @return {LogObject<publicPageViewArticleParams>} LogObject<publicPageViewArticleParams>
 */
export function publicPageViewArticle(params) {
    throw new Error('publicPageViewArticle cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'aiSummaryAppearsInTheInternalNote' event (evid: 4917)
 *
 * Event description: It tracks the time between asking the AI for a summary and when it appears in the user's inbox.
 *
 * @param {aiSummaryAppearsInTheInternalNoteParams} params - The parameters for this event
 * @return {LogObject<aiSummaryAppearsInTheInternalNoteParams>} LogObject<aiSummaryAppearsInTheInternalNoteParams>
 */
export function aiSummaryAppearsInTheInternalNote(params) {
    throw new Error('aiSummaryAppearsInTheInternalNote cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'agentDeclinesCallSrc77Evid4906' event (evid: 4906)
 *
 * Event description: Triggers when an agent delines a call, returns Call Id and Tenant ID,
 * Agent ID as implicit UUID field.
 *
 * @param {agentDeclinesCallSrc77Evid4906Params} params - The parameters for this event
 * @return {LogObject<agentDeclinesCallSrc77Evid4906Params>} LogObject<agentDeclinesCallSrc77Evid4906Params>
 */
export function agentDeclinesCallSrc77Evid4906(params) {
    throw new Error('agentDeclinesCallSrc77Evid4906 cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsAddReplyAttempt' event (evid: 1023)
 *
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note"
 *
 * @param {appTicketsAddReplyAttemptParams} params - The parameters for this event
 * @return {LogObject<appTicketsAddReplyAttemptParams>} LogObject<appTicketsAddReplyAttemptParams>
 */
export function appTicketsAddReplyAttempt(params) {
    throw new Error('appTicketsAddReplyAttempt cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxLinkArticleToATicket' event (evid: 1001)
 *
 * Event description: Linking an article to a ticket.event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxLinkArticleToATicketParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxLinkArticleToATicketParams>} LogObject<appTicketsOneInboxLinkArticleToATicketParams>
 */
export function appTicketsOneInboxLinkArticleToATicket(params) {
    throw new Error('appTicketsOneInboxLinkArticleToATicket cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbCategoriesDeleteCategoryClick' event (evid: 1114)
 *
 * Event description: Click Delete category from the category menu
 *
 * @param {appKbCategoriesDeleteCategoryClickParams} params - The parameters for this event
 * @return {LogObject<appKbCategoriesDeleteCategoryClickParams>} LogObject<appKbCategoriesDeleteCategoryClickParams>
 */
export function appKbCategoriesDeleteCategoryClick(params) {
    throw new Error('appKbCategoriesDeleteCategoryClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxAttachmentAddedToReply' event (evid: 1016)
 *
 * Event description: Add attachment to reply. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxAttachmentAddedToReplyParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxAttachmentAddedToReplyParams>} LogObject<appTicketsOneInboxAttachmentAddedToReplyParams>
 */
export function appTicketsOneInboxAttachmentAddedToReply(params) {
    throw new Error('appTicketsOneInboxAttachmentAddedToReply cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicPageViewError' event (evid: 2009)
 *
 * Event description: page view error
 *
 * @param {publicPageViewErrorParams} params - The parameters for this event
 * @return {LogObject<publicPageViewErrorParams>} LogObject<publicPageViewErrorParams>
 */
export function publicPageViewError(params) {
    throw new Error('publicPageViewError cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbMoveAssignSubcategory' event (evid: 1122)
 *
 * Event description: Assign a subcategory to a different category or make it its own category
 *
 * @param {appKbMoveAssignSubcategoryParams} params - The parameters for this event
 * @return {LogObject<appKbMoveAssignSubcategoryParams>} LogObject<appKbMoveAssignSubcategoryParams>
 */
export function appKbMoveAssignSubcategory(params) {
    throw new Error('appKbMoveAssignSubcategory cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsAddReplyFail' event (evid: 1024)
 *
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note"
 *
 * @param {appTicketsAddReplyFailParams} params - The parameters for this event
 * @return {LogObject<appTicketsAddReplyFailParams>} LogObject<appTicketsAddReplyFailParams>
 */
export function appTicketsAddReplyFail(params) {
    throw new Error('appTicketsAddReplyFail cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxClickOnAnIcon' event (evid: 1015)
 *
 * Event description: Click on one of the icons in the reply. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxClickOnAnIconParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxClickOnAnIconParams>} LogObject<appTicketsOneInboxClickOnAnIconParams>
 */
export function appTicketsOneInboxClickOnAnIcon(params) {
    throw new Error('appTicketsOneInboxClickOnAnIcon cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTeamAddMembersToGroupClick' event (evid: 1207)
 *
 * Event description: Click on the button "Add members to Group" (blue button or from empty group state)
 *
 * @param {appTeamAddMembersToGroupClickParams} params - The parameters for this event
 * @return {LogObject<appTeamAddMembersToGroupClickParams>} LogObject<appTeamAddMembersToGroupClickParams>
 */
export function appTeamAddMembersToGroupClick(params) {
    throw new Error('appTeamAddMembersToGroupClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbArticlesListClickOnAnArticle' event (evid: 1110)
 *
 * Event description: Click on an article from the screen
 *
 * @param {appKbArticlesListClickOnAnArticleParams} params - The parameters for this event
 * @return {LogObject<appKbArticlesListClickOnAnArticleParams>} LogObject<appKbArticlesListClickOnAnArticleParams>
 */
export function appKbArticlesListClickOnAnArticle(params) {
    throw new Error('appKbArticlesListClickOnAnArticle cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxRemoveLabelFromATicket' event (evid: 1022)
 *
 * Event description: Click a label in order to remove it from the ticket. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxRemoveLabelFromATicketParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxRemoveLabelFromATicketParams>} LogObject<appTicketsOneInboxRemoveLabelFromATicketParams>
 */
export function appTicketsOneInboxRemoveLabelFromATicket(params) {
    throw new Error('appTicketsOneInboxRemoveLabelFromATicket cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxSavedReplyAdded' event (evid: 1018)
 *
 * Event description: click "add to reply" after selecting the reply content
 *
 * @param {appTicketsOneInboxSavedReplyAddedParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxSavedReplyAddedParams>} LogObject<appTicketsOneInboxSavedReplyAddedParams>
 */
export function appTicketsOneInboxSavedReplyAdded(params) {
    throw new Error('appTicketsOneInboxSavedReplyAdded cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxLabelAddedToTicket' event (evid: 1021)
 *
 * Event description: Click the + button in order to add a label. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxLabelAddedToTicketParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxLabelAddedToTicketParams>} LogObject<appTicketsOneInboxLabelAddedToTicketParams>
 */
export function appTicketsOneInboxLabelAddedToTicket(params) {
    throw new Error('appTicketsOneInboxLabelAddedToTicket cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appOneInboxTicketPagePageLoadSuccess' event (evid: 1028)
 *
 * Event description: This Event is triggered every time the Ticket page is Loaded Successfully in One Inbox
 *
 * @param {appOneInboxTicketPagePageLoadSuccessParams} params - The parameters for this event
 * @return {LogObject<appOneInboxTicketPagePageLoadSuccessParams>} LogObject<appOneInboxTicketPagePageLoadSuccessParams>
 */
export function appOneInboxTicketPagePageLoadSuccess(params) {
    throw new Error('appOneInboxTicketPagePageLoadSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxEmojiAddedToReply' event (evid: 1017)
 *
 * Event description: Select and click on the emoji itself. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxEmojiAddedToReplyParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxEmojiAddedToReplyParams>} LogObject<appTicketsOneInboxEmojiAddedToReplyParams>
 */
export function appTicketsOneInboxEmojiAddedToReply(params) {
    throw new Error('appTicketsOneInboxEmojiAddedToReply cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbClickPublishButton' event (evid: 1104)
 *
 * Event description: Click "Publish" button
 *
 * @param {appKbClickPublishButtonParams} params - The parameters for this event
 * @return {LogObject<appKbClickPublishButtonParams>} LogObject<appKbClickPublishButtonParams>
 */
export function appKbClickPublishButton(params) {
    throw new Error('appKbClickPublishButton cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbCategoriesCreateCategorySubcategoryClick' event (evid: 1112)
 *
 * Event description: Create the category after inserting the name
 *
 * @param {appKbCategoriesCreateCategorySubcategoryClickParams} params - The parameters for this event
 * @return {LogObject<appKbCategoriesCreateCategorySubcategoryClickParams>} LogObject<appKbCategoriesCreateCategorySubcategoryClickParams>
 */
export function appKbCategoriesCreateCategorySubcategoryClick(params) {
    throw new Error('appKbCategoriesCreateCategorySubcategoryClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appOnboardingGeneralGuideEvent' event (evid: 901)
 *
 * Event description: This is a general onboarding event. At first phase of the Onboarding dev process, this event will be used for reporting all actions in the "Guide" screen
 *
 * @param {appOnboardingGeneralGuideEventParams} params - The parameters for this event
 * @return {LogObject<appOnboardingGeneralGuideEventParams>} LogObject<appOnboardingGeneralGuideEventParams>
 */
export function appOnboardingGeneralGuideEvent(params) {
    throw new Error('appOnboardingGeneralGuideEvent cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicSubmitATicketCancel' event (evid: 2520)
 *
 * Event description: Cancel the ticket submission
 *
 * @param {publicSubmitATicketCancelParams} params - The parameters for this event
 * @return {LogObject<publicSubmitATicketCancelParams>} LogObject<publicSubmitATicketCancelParams>
 */
export function publicSubmitATicketCancel(params) {
    throw new Error('publicSubmitATicketCancel cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicUserArticleEngagementPing' event (evid: 2533)
 *
 * Event description: When a user visits an article page he will get a "ping" every 15 seconds if he made one or more activity actions : scroll, mouse move and click within those 15 secs. The activity doesn’t have to be continuous, whenever the user shows activity he'll get a ping.
 * when the page view originated in email article recommendation, the ticket id recommended for will be provided.
 *
 * @param {publicUserArticleEngagementPingParams} params - The parameters for this event
 * @return {LogObject<publicUserArticleEngagementPingParams>} LogObject<publicUserArticleEngagementPingParams>
 */
export function publicUserArticleEngagementPing(params) {
    throw new Error('publicUserArticleEngagementPing cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxAssignATicket' event (evid: 1025)
 *
 * Event description: Assign a ticket to a Group or to an Agent. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxAssignATicketParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxAssignATicketParams>} LogObject<appTicketsOneInboxAssignATicketParams>
 */
export function appTicketsOneInboxAssignATicket(params) {
    throw new Error('appTicketsOneInboxAssignATicket cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbDeleteAnArticleClick' event (evid: 1102)
 *
 * Event description: Click "Delete" from the top bar
 *
 * @param {appKbDeleteAnArticleClickParams} params - The parameters for this event
 * @return {LogObject<appKbDeleteAnArticleClickParams>} LogObject<appKbDeleteAnArticleClickParams>
 */
export function appKbDeleteAnArticleClick(params) {
    throw new Error('appKbDeleteAnArticleClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiTileLoadStart' event (evid: 1322)
 *
 * Event description: This event is fired when a tile in a dashboard starts loading or querying for data.
 *
 * @param {appInsightsAdvancedReportsWasabiTileLoadStartParams} params - The parameters for this event
 * @return {LogObject<appInsightsAdvancedReportsWasabiTileLoadStartParams>} LogObject<appInsightsAdvancedReportsWasabiTileLoadStartParams>
 */
export function appInsightsAdvancedReportsWasabiTileLoadStart(params) {
    throw new Error('appInsightsAdvancedReportsWasabiTileLoadStart cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbPublishMyArticleNowClick' event (evid: 1105)
 *
 * Event description: Click "Publish my article now" after being asked:
 * "Ready to publish your article?"
 *
 * @param {appKbPublishMyArticleNowClickParams} params - The parameters for this event
 * @return {LogObject<appKbPublishMyArticleNowClickParams>} LogObject<appKbPublishMyArticleNowClickParams>
 */
export function appKbPublishMyArticleNowClick(params) {
    throw new Error('appKbPublishMyArticleNowClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicPageView' event (evid: 2001)
 *
 * Event description: page view (similar to evid 531 in src 4)
 *
 * @param {publicPageViewParams} params - The parameters for this event
 * @return {LogObject<publicPageViewParams>} LogObject<publicPageViewParams>
 */
export function publicPageView(params) {
    throw new Error('publicPageView cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbConfirmDeleteClick' event (evid: 1103)
 *
 * Event description: Click "Delete" after "Are you sure?" massage
 *
 * @param {appKbConfirmDeleteClickParams} params - The parameters for this event
 * @return {LogObject<appKbConfirmDeleteClickParams>} LogObject<appKbConfirmDeleteClickParams>
 */
export function appKbConfirmDeleteClick(params) {
    throw new Error('appKbConfirmDeleteClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicSearch' event (evid: 2005)
 *
 * Event description: asking a question (similar to evid 520 in src 4)
 *
 * @param {publicSearchParams} params - The parameters for this event
 * @return {LogObject<publicSearchParams>} LogObject<publicSearchParams>
 */
export function publicSearch(params) {
    throw new Error('publicSearch cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicSubmitTicketSuccess' event (evid: 2512)
 *
 * Event description: Ticket submission success
 *
 * @param {publicSubmitTicketSuccessParams} params - The parameters for this event
 * @return {LogObject<publicSubmitTicketSuccessParams>} LogObject<publicSubmitTicketSuccessParams>
 */
export function publicSubmitTicketSuccess(params) {
    throw new Error('publicSubmitTicketSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbUnpublishArticle' event (evid: 1106)
 *
 * Event description: Click "Unpublish article" from the top bar
 *
 * @param {appKbUnpublishArticleParams} params - The parameters for this event
 * @return {LogObject<appKbUnpublishArticleParams>} LogObject<appKbUnpublishArticleParams>
 */
export function appKbUnpublishArticle(params) {
    throw new Error('appKbUnpublishArticle cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicWidgetWidgetLauncherLoadedClient' event (evid: 2014)
 *
 * Event description: The event is trigger when a launcher is loaded
 *
 * @param {publicWidgetWidgetLauncherLoadedClientParams} params - The parameters for this event
 * @return {LogObject<publicWidgetWidgetLauncherLoadedClientParams>} LogObject<publicWidgetWidgetLauncherLoadedClientParams>
 */
export function publicWidgetWidgetLauncherLoadedClient(params) {
    throw new Error('publicWidgetWidgetLauncherLoadedClient cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicClickOnACategoryOrSubcategory' event (evid: 2010)
 *
 * Event description: Clicking on a category or a subcategory from the main screen (similar to event 519 in source 4)
 *
 * @param {publicClickOnACategoryOrSubcategoryParams} params - The parameters for this event
 * @return {LogObject<publicClickOnACategoryOrSubcategoryParams>} LogObject<publicClickOnACategoryOrSubcategoryParams>
 */
export function publicClickOnACategoryOrSubcategory(params) {
    throw new Error('publicClickOnACategoryOrSubcategory cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxChangeTicketStatus' event (evid: 1008)
 *
 * Event description: Ticket top bar - Status changed (click on button after selecting a new status). event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxChangeTicketStatusParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxChangeTicketStatusParams>} LogObject<appTicketsOneInboxChangeTicketStatusParams>
 */
export function appTicketsOneInboxChangeTicketStatus(params) {
    throw new Error('appTicketsOneInboxChangeTicketStatus cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appSettingsAgentClickRolesInTheSettingsMenu' event (evid: 1453)
 *
 * Event description: An agent click "roles" in the settings menu of Answers App
 *
 * @param {appSettingsAgentClickRolesInTheSettingsMenuParams} params - The parameters for this event
 * @return {LogObject<appSettingsAgentClickRolesInTheSettingsMenuParams>} LogObject<appSettingsAgentClickRolesInTheSettingsMenuParams>
 */
export function appSettingsAgentClickRolesInTheSettingsMenu(params) {
    throw new Error('appSettingsAgentClickRolesInTheSettingsMenu cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsAddALabelClick' event (evid: 1020)
 *
 * Event description: Click the + button from inside a ticket in order to add a label
 *
 * @param {appTicketsAddALabelClickParams} params - The parameters for this event
 * @return {LogObject<appTicketsAddALabelClickParams>} LogObject<appTicketsAddALabelClickParams>
 */
export function appTicketsAddALabelClick(params) {
    throw new Error('appTicketsAddALabelClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbChangeCategorysIcon' event (evid: 1124)
 *
 * Event description: Change the category's icon for display
 *
 * @param {appKbChangeCategorysIconParams} params - The parameters for this event
 * @return {LogObject<appKbChangeCategorysIconParams>} LogObject<appKbChangeCategorysIconParams>
 */
export function appKbChangeCategorysIcon(params) {
    throw new Error('appKbChangeCategorysIcon cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appOneInboxTicketListPageLoadSuccess' event (evid: 1027)
 *
 * Event description: This Event is triggered every time the Ticket List Page is Loaded Successfully in One Inbox.
 * (please remember to create position columns for all existed columns of table layout and let me know their names afterwards and I will add them to the event)
 *
 * @param {appOneInboxTicketListPageLoadSuccessParams} params - The parameters for this event
 * @return {LogObject<appOneInboxTicketListPageLoadSuccessParams>} LogObject<appOneInboxTicketListPageLoadSuccessParams>
 */
export function appOneInboxTicketListPageLoadSuccess(params) {
    throw new Error('appOneInboxTicketListPageLoadSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'answersSidePanelViewEvent' event (evid: 4924)
 *
 * Event description: Fires when a side bar tab is opened.
 *
 * @param {answersSidePanelViewEventParams} params - The parameters for this event
 * @return {LogObject<answersSidePanelViewEventParams>} LogObject<answersSidePanelViewEventParams>
 */
export function answersSidePanelViewEvent(params) {
    throw new Error('answersSidePanelViewEvent cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appGeneralFtueVideoLightboxClose' event (evid: 1949)
 *
 * Event description: First Time User Experience (FTUE) Video Lightbox of a certain feature was closed by the user
 *
 * @param {appGeneralFtueVideoLightboxCloseParams} params - The parameters for this event
 * @return {LogObject<appGeneralFtueVideoLightboxCloseParams>} LogObject<appGeneralFtueVideoLightboxCloseParams>
 */
export function appGeneralFtueVideoLightboxClose(params) {
    throw new Error('appGeneralFtueVideoLightboxClose cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appSettingsRolesAgentClickEditRole' event (evid: 1455)
 *
 * Event description: An agent click "Edit" in the right corner menu (3 dots) in the roles section within Answers Settings.
 *
 * @param {appSettingsRolesAgentClickEditRoleParams} params - The parameters for this event
 * @return {LogObject<appSettingsRolesAgentClickEditRoleParams>} LogObject<appSettingsRolesAgentClickEditRoleParams>
 */
export function appSettingsRolesAgentClickEditRole(params) {
    throw new Error('appSettingsRolesAgentClickEditRole cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicVoteForKnownIssueButton' event (evid: 2004)
 *
 * Event description: Click the (I have this problem (bug)) (similar to evid 503 in src 4)
 *
 * @param {publicVoteForKnownIssueButtonParams} params - The parameters for this event
 * @return {LogObject<publicVoteForKnownIssueButtonParams>} LogObject<publicVoteForKnownIssueButtonParams>
 */
export function publicVoteForKnownIssueButton(params) {
    throw new Error('publicVoteForKnownIssueButton cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appOneInboxAMemberClientEngagement' event (evid: 1026)
 *
 * Event description: A generic event for member's clicks/engagements related to One Inbox different components: Views Panel, Tickets List, Ticket Item, Ticket Header, Ticket Actions (footer), Reply Box, Info Panel, App header and Bulk Actions
 *
 * @param {appOneInboxAMemberClientEngagementParams} params - The parameters for this event
 * @return {LogObject<appOneInboxAMemberClientEngagementParams>} LogObject<appOneInboxAMemberClientEngagementParams>
 */
export function appOneInboxAMemberClientEngagement(params) {
    throw new Error('appOneInboxAMemberClientEngagement cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicWidgetToggleModule' event (evid: 2230)
 *
 * Event description: Click on the top icon to switch between "contact" and "help"
 *
 * @param {publicWidgetToggleModuleParams} params - The parameters for this event
 * @return {LogObject<publicWidgetToggleModuleParams>} LogObject<publicWidgetToggleModuleParams>
 */
export function publicWidgetToggleModule(params) {
    throw new Error('publicWidgetToggleModule cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appWasabiAdvancedReportsClickOn3Dots' event (evid: 1330)
 *
 * Event description: User Click on 3 dots (more option per report)
 * after selecting an action - View / Duplicate / Delete
 *
 * @param {appWasabiAdvancedReportsClickOn3DotsParams} params - The parameters for this event
 * @return {LogObject<appWasabiAdvancedReportsClickOn3DotsParams>} LogObject<appWasabiAdvancedReportsClickOn3DotsParams>
 */
export function appWasabiAdvancedReportsClickOn3Dots(params) {
    throw new Error('appWasabiAdvancedReportsClickOn3Dots cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicSuggestedArticlesClick' event (evid: 2530)
 *
 * Event description: Clicking on one of the suggested articles from inside a ticket submission.
 *
 * @param {publicSuggestedArticlesClickParams} params - The parameters for this event
 * @return {LogObject<publicSuggestedArticlesClickParams>} LogObject<publicSuggestedArticlesClickParams>
 */
export function publicSuggestedArticlesClick(params) {
    throw new Error('publicSuggestedArticlesClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'answersCallFlowUiEvents' event (evid: 4928)
 *
 * Event description: triggers when a user interacts with call elements in Answers
 *
 * @param {answersCallFlowUiEventsParams} params - The parameters for this event
 * @return {LogObject<answersCallFlowUiEventsParams>} LogObject<answersCallFlowUiEventsParams>
 */
export function answersCallFlowUiEvents(params) {
    throw new Error('answersCallFlowUiEvents cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteAReplyConfirm' event (evid: 1013)
 *
 * Event description: Click "OK" after being asked "Are you sure?". event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteAReplyConfirmParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxDeleteAReplyConfirmParams>} LogObject<appTicketsOneInboxDeleteAReplyConfirmParams>
 */
export function appTicketsOneInboxDeleteAReplyConfirm(params) {
    throw new Error('appTicketsOneInboxDeleteAReplyConfirm cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTeamCreateANewGroupClick' event (evid: 1205)
 *
 * Event description: Clicking the "Create Team" button after inserting group name
 *
 * @param {appTeamCreateANewGroupClickParams} params - The parameters for this event
 * @return {LogObject<appTeamCreateANewGroupClickParams>} LogObject<appTeamCreateANewGroupClickParams>
 */
export function appTeamCreateANewGroupClick(params) {
    throw new Error('appTeamCreateANewGroupClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicGotNoAnswer' event (evid: 2008)
 *
 * Event description: got no answer (similar to evid 537 in src 4)
 *
 * @param {publicGotNoAnswerParams} params - The parameters for this event
 * @return {LogObject<publicGotNoAnswerParams>} LogObject<publicGotNoAnswerParams>
 */
export function publicGotNoAnswer(params) {
    throw new Error('publicGotNoAnswer cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicChatbotTicketCreatedFromTheChatbot' event (evid: 2261)
 *
 * @param {publicChatbotTicketCreatedFromTheChatbotParams} params - The parameters for this event
 * @return {LogObject<publicChatbotTicketCreatedFromTheChatbotParams>} LogObject<publicChatbotTicketCreatedFromTheChatbotParams>
 */
export function publicChatbotTicketCreatedFromTheChatbot(params) {
    throw new Error('publicChatbotTicketCreatedFromTheChatbot cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicPageViewTicket' event (evid: 1998)
 *
 * Event description: Ticket - page view
 *
 * @param {publicPageViewTicketParams} params - The parameters for this event
 * @return {LogObject<publicPageViewTicketParams>} LogObject<publicPageViewTicketParams>
 */
export function publicPageViewTicket(params) {
    throw new Error('publicPageViewTicket cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteATicketClick' event (evid: 1009)
 *
 * Event description: click "delete" option from the bottom bar. event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteATicketClickParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxDeleteATicketClickParams>} LogObject<appTicketsOneInboxDeleteATicketClickParams>
 */
export function appTicketsOneInboxDeleteATicketClick(params) {
    throw new Error('appTicketsOneInboxDeleteATicketClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxAddEmailReplySuccess' event (evid: 1011)
 *
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note"
 *
 * @param {appTicketsOneInboxAddEmailReplySuccessParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxAddEmailReplySuccessParams>} LogObject<appTicketsOneInboxAddEmailReplySuccessParams>
 */
export function appTicketsOneInboxAddEmailReplySuccess(params) {
    throw new Error('appTicketsOneInboxAddEmailReplySuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbAssignArticleToCategorySubcategory' event (evid: 1107)
 *
 * Event description: Choose a category for an article
 *
 * @param {appKbAssignArticleToCategorySubcategoryParams} params - The parameters for this event
 * @return {LogObject<appKbAssignArticleToCategorySubcategoryParams>} LogObject<appKbAssignArticleToCategorySubcategoryParams>
 */
export function appKbAssignArticleToCategorySubcategory(params) {
    throw new Error('appKbAssignArticleToCategorySubcategory cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicPageViewCategory' event (evid: 1999)
 *
 * Event description: Category/subcategory - page view
 *
 * @param {publicPageViewCategoryParams} params - The parameters for this event
 * @return {LogObject<publicPageViewCategoryParams>} LogObject<publicPageViewCategoryParams>
 */
export function publicPageViewCategory(params) {
    throw new Error('publicPageViewCategory cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appGeneralPageLoadSuccess' event (evid: 1951)
 *
 * Event description: General event - like "page view"
 *
 * @param {appGeneralPageLoadSuccessParams} params - The parameters for this event
 * @return {LogObject<appGeneralPageLoadSuccessParams>} LogObject<appGeneralPageLoadSuccessParams>
 */
export function appGeneralPageLoadSuccess(params) {
    throw new Error('appGeneralPageLoadSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appSettingsChangeFail' event (evid: 1452)
 *
 * Event description: Change event attempt: save/toggle in the setting section
 *
 * @param {appSettingsChangeFailParams} params - The parameters for this event
 * @return {LogObject<appSettingsChangeFailParams>} LogObject<appSettingsChangeFailParams>
 */
export function appSettingsChangeFail(params) {
    throw new Error('appSettingsChangeFail cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbCreateNewArticleClick' event (evid: 1109)
 *
 * Event description: Click on the button to "Create new article"
 *
 * @param {appKbCreateNewArticleClickParams} params - The parameters for this event
 * @return {LogObject<appKbCreateNewArticleClickParams>} LogObject<appKbCreateNewArticleClickParams>
 */
export function appKbCreateNewArticleClick(params) {
    throw new Error('appKbCreateNewArticleClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'wrapUpSessionEndedAutomatically' event (evid: 4921)
 *
 * Event description: In the end of the wrap up by the timer, the session will be ended automatically, and this event will be sanded.
 *
 * @param {wrapUpSessionEndedAutomaticallyParams} params - The parameters for this event
 * @return {LogObject<wrapUpSessionEndedAutomaticallyParams>} LogObject<wrapUpSessionEndedAutomaticallyParams>
 */
export function wrapUpSessionEndedAutomatically(params) {
    throw new Error('wrapUpSessionEndedAutomatically cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appSettingsRolesAgentClickAddCustomRole' event (evid: 1454)
 *
 * Event description: An agent clicks "Add custom role" inside "roles" section of Answers Settings
 *
 * @param {appSettingsRolesAgentClickAddCustomRoleParams} params - The parameters for this event
 * @return {LogObject<appSettingsRolesAgentClickAddCustomRoleParams>} LogObject<appSettingsRolesAgentClickAddCustomRoleParams>
 */
export function appSettingsRolesAgentClickAddCustomRole(params) {
    throw new Error('appSettingsRolesAgentClickAddCustomRole cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteATicketConfirm' event (evid: 1010)
 *
 * Event description: Delete a ticket from the action bar confirm - click the red button. event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteATicketConfirmParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxDeleteATicketConfirmParams>} LogObject<appTicketsOneInboxDeleteATicketConfirmParams>
 */
export function appTicketsOneInboxDeleteATicketConfirm(params) {
    throw new Error('appTicketsOneInboxDeleteATicketConfirm cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'wrapUpIsTheExpertBackToTheTicket' event (evid: 4922)
 *
 * Event description: In the end of the wrap up by the timer, the session will be ended automatically, if the expert open back the same ticket this event will be sanded
 *
 * @param {wrapUpIsTheExpertBackToTheTicketParams} params - The parameters for this event
 * @return {LogObject<wrapUpIsTheExpertBackToTheTicketParams>} LogObject<wrapUpIsTheExpertBackToTheTicketParams>
 */
export function wrapUpIsTheExpertBackToTheTicket(params) {
    throw new Error('wrapUpIsTheExpertBackToTheTicket cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxClickOnATicket' event (evid: 1007)
 *
 * Event description: Click on a ticket from the list. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxClickOnATicketParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxClickOnATicketParams>} LogObject<appTicketsOneInboxClickOnATicketParams>
 */
export function appTicketsOneInboxClickOnATicket(params) {
    throw new Error('appTicketsOneInboxClickOnATicket cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'devBindingAnswersAndWixIdentifiers' event (evid: 50)
 *
 * Event description: Event is fired every time that: 1. A user loads the Answers Marketing site or the Answers App  2. A wixCIDX and/or wixUIDX cookie was detected
 *
 * @param {devBindingAnswersAndWixIdentifiersParams} params - The parameters for this event
 * @return {LogObject<devBindingAnswersAndWixIdentifiersParams>} LogObject<devBindingAnswersAndWixIdentifiersParams>
 */
export function devBindingAnswersAndWixIdentifiers(params) {
    throw new Error('devBindingAnswersAndWixIdentifiers cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'statusPageBannerLoaded' event (evid: 45)
 *
 * Event description: Status Page Banner loaded
 *
 * @param {statusPageBannerLoadedParams} params - The parameters for this event
 * @return {LogObject<statusPageBannerLoadedParams>} LogObject<statusPageBannerLoadedParams>
 */
export function statusPageBannerLoaded(params) {
    throw new Error('statusPageBannerLoaded cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appOneInboxTicketSnoozeStartOrUpdate' event (evid: 1029)
 *
 * Event description: A ticket has been snoozed by an Answers member.
 *
 * @param {appOneInboxTicketSnoozeStartOrUpdateParams} params - The parameters for this event
 * @return {LogObject<appOneInboxTicketSnoozeStartOrUpdateParams>} LogObject<appOneInboxTicketSnoozeStartOrUpdateParams>
 */
export function appOneInboxTicketSnoozeStartOrUpdate(params) {
    throw new Error('appOneInboxTicketSnoozeStartOrUpdate cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsRemoveRelatedArticleFromATicket' event (evid: 1002)
 *
 * Event description: Remove a related article from a ticket
 *
 * @param {appTicketsRemoveRelatedArticleFromATicketParams} params - The parameters for this event
 * @return {LogObject<appTicketsRemoveRelatedArticleFromATicketParams>} LogObject<appTicketsRemoveRelatedArticleFromATicketParams>
 */
export function appTicketsRemoveRelatedArticleFromATicket(params) {
    throw new Error('appTicketsRemoveRelatedArticleFromATicket cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appSettingsChangeAttempt' event (evid: 1450)
 *
 * Event description: Change event attempt: save/toggle in the setting section
 *
 * @param {appSettingsChangeAttemptParams} params - The parameters for this event
 * @return {LogObject<appSettingsChangeAttemptParams>} LogObject<appSettingsChangeAttemptParams>
 */
export function appSettingsChangeAttempt(params) {
    throw new Error('appSettingsChangeAttempt cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicCustomerPortalViewerClientEngagement' event (evid: 2400)
 *
 * @param {publicCustomerPortalViewerClientEngagementParams} params - The parameters for this event
 * @return {LogObject<publicCustomerPortalViewerClientEngagementParams>} LogObject<publicCustomerPortalViewerClientEngagementParams>
 */
export function publicCustomerPortalViewerClientEngagement(params) {
    throw new Error('publicCustomerPortalViewerClientEngagement cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'clickOnEscalateToVistaButton' event (evid: 4914)
 *
 * Event description: Button appears to experts only for Vista Users threads. The experts clicks on this button if he wants to request a callback from Vista CC to the user.
 *
 * @param {clickOnEscalateToVistaButtonParams} params - The parameters for this event
 * @return {LogObject<clickOnEscalateToVistaButtonParams>} LogObject<clickOnEscalateToVistaButtonParams>
 */
export function clickOnEscalateToVistaButton(params) {
    throw new Error('clickOnEscalateToVistaButton cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appControlRoomAMemberClientEngagement' event (evid: 2600)
 *
 * Event description: A generic event covering the following member's Client engagements:
 * (1) Click on agent from main table
 * (2) Assign members to channels - data = {multi channel (True/False), multi members (True/False)}
 * (3) Click unassign members  from all channels - data = { multi members (True/False)}
 * (4) Set members workloads - data = {multi channel (True/False), multi members (True/False)}
 * (5) reset members workloads to account settings - data {multi members (True/False)}
 * (6) Update members groups - data = {multi add (True/False), multi remove (True/False), multi members (True/False)}
 * (7) Click on manage groups
 * Update members queues - data = {multi add (True/False), multi remove (True/False), multi members (True/False)}
 * (8) Click on manage queues
 * (9) Click on search bar
 * (10) Start typing in search bar. for more details: https://docs.google.com/document/d/1IT8vPXK0mDTTVnI3TSF3__Ti_dXvB8E2SVZnCwe7AFs/edit
 *
 * @param {appControlRoomAMemberClientEngagementParams} params - The parameters for this event
 * @return {LogObject<appControlRoomAMemberClientEngagementParams>} LogObject<appControlRoomAMemberClientEngagementParams>
 */
export function appControlRoomAMemberClientEngagement(params) {
    throw new Error('appControlRoomAMemberClientEngagement cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsSearchForATicket' event (evid: 1004)
 *
 * Event description: Search for a ticket in the search line
 *
 * @param {appTicketsSearchForATicketParams} params - The parameters for this event
 * @return {LogObject<appTicketsSearchForATicketParams>} LogObject<appTicketsSearchForATicketParams>
 */
export function appTicketsSearchForATicket(params) {
    throw new Error('appTicketsSearchForATicket cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbArticlesListSearchArticle' event (evid: 1108)
 *
 * Event description: When the user searches for an article
 *
 * @param {appKbArticlesListSearchArticleParams} params - The parameters for this event
 * @return {LogObject<appKbArticlesListSearchArticleParams>} LogObject<appKbArticlesListSearchArticleParams>
 */
export function appKbArticlesListSearchArticle(params) {
    throw new Error('appKbArticlesListSearchArticle cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbCategoriesAddCategorySubcategoryClick' event (evid: 1111)
 *
 * Event description: Click on the button "+ Add category"
 *
 * @param {appKbCategoriesAddCategorySubcategoryClickParams} params - The parameters for this event
 * @return {LogObject<appKbCategoriesAddCategorySubcategoryClickParams>} LogObject<appKbCategoriesAddCategorySubcategoryClickParams>
 */
export function appKbCategoriesAddCategorySubcategoryClick(params) {
    throw new Error('appKbCategoriesAddCategorySubcategoryClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appGeneralFtueVideoLightboxPlayVideo' event (evid: 1948)
 *
 * Event description: User clicks the "Play" button of the video in the First Time User Experience (FTUE) Video Lightbox of a certain feature
 *
 * @param {appGeneralFtueVideoLightboxPlayVideoParams} params - The parameters for this event
 * @return {LogObject<appGeneralFtueVideoLightboxPlayVideoParams>} LogObject<appGeneralFtueVideoLightboxPlayVideoParams>
 */
export function appGeneralFtueVideoLightboxPlayVideo(params) {
    throw new Error('appGeneralFtueVideoLightboxPlayVideo cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiDashboardLoadStart' event (evid: 1320)
 *
 * Event description: This event is fired when a dashboard has begun loading, when its tiles will start loading and querying for data.
 *
 * @param {appInsightsAdvancedReportsWasabiDashboardLoadStartParams} params - The parameters for this event
 * @return {LogObject<appInsightsAdvancedReportsWasabiDashboardLoadStartParams>} LogObject<appInsightsAdvancedReportsWasabiDashboardLoadStartParams>
 */
export function appInsightsAdvancedReportsWasabiDashboardLoadStart(params) {
    throw new Error('appInsightsAdvancedReportsWasabiDashboardLoadStart cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbRenameCategorySubcategory' event (evid: 1123)
 *
 * Event description: Rename a category or a subcategory
 *
 * @param {appKbRenameCategorySubcategoryParams} params - The parameters for this event
 * @return {LogObject<appKbRenameCategorySubcategoryParams>} LogObject<appKbRenameCategorySubcategoryParams>
 */
export function appKbRenameCategorySubcategory(params) {
    throw new Error('appKbRenameCategorySubcategory cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiDashboardLoadComplete' event (evid: 1321)
 *
 * Event description: This event is fired when a dashboard has finished running and all tiles have finished loading and querying. This event is fired whether or not all tiles load successfully.
 *
 * @param {appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams} params - The parameters for this event
 * @return {LogObject<appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams>} LogObject<appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams>
 */
export function appInsightsAdvancedReportsWasabiDashboardLoadComplete(params) {
    throw new Error('appInsightsAdvancedReportsWasabiDashboardLoadComplete cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsSwitchReplyType' event (evid: 1019)
 *
 * Event description: Team Note - Switch reply type
 *
 * @param {appTicketsSwitchReplyTypeParams} params - The parameters for this event
 * @return {LogObject<appTicketsSwitchReplyTypeParams>} LogObject<appTicketsSwitchReplyTypeParams>
 */
export function appTicketsSwitchReplyType(params) {
    throw new Error('appTicketsSwitchReplyType cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'answersSidePanelClickEvent' event (evid: 4923)
 *
 * Event description: triggers when a user (expert) clicks a tab or one of the elements within the tabs in the side bar
 *
 * @param {answersSidePanelClickEventParams} params - The parameters for this event
 * @return {LogObject<answersSidePanelClickEventParams>} LogObject<answersSidePanelClickEventParams>
 */
export function answersSidePanelClickEvent(params) {
    throw new Error('answersSidePanelClickEvent cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appControlRoomPageLoadSuccess' event (evid: 2601)
 *
 * @param {appControlRoomPageLoadSuccessParams} params - The parameters for this event
 * @return {LogObject<appControlRoomPageLoadSuccessParams>} LogObject<appControlRoomPageLoadSuccessParams>
 */
export function appControlRoomPageLoadSuccess(params) {
    throw new Error('appControlRoomPageLoadSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbEditArticleSaveAttempt' event (evid: 1100)
 *
 * Event description: start save process after clicking "Save"
 *
 * @param {appKbEditArticleSaveAttemptParams} params - The parameters for this event
 * @return {LogObject<appKbEditArticleSaveAttemptParams>} LogObject<appKbEditArticleSaveAttemptParams>
 */
export function appKbEditArticleSaveAttempt(params) {
    throw new Error('appKbEditArticleSaveAttempt cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiTileLoadComplete' event (evid: 1323)
 *
 * Event description: This event is fired when a tile in a dashboard starts loading or querying for data.
 *
 * @param {appInsightsAdvancedReportsWasabiTileLoadCompleteParams} params - The parameters for this event
 * @return {LogObject<appInsightsAdvancedReportsWasabiTileLoadCompleteParams>} LogObject<appInsightsAdvancedReportsWasabiTileLoadCompleteParams>
 */
export function appInsightsAdvancedReportsWasabiTileLoadComplete(params) {
    throw new Error('appInsightsAdvancedReportsWasabiTileLoadComplete cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'answersPageEngagement' event (evid: 4927)
 *
 * Event description: Fired every 10 seconds and indicates if within that timeframe the user performed one of the following actions: scroll, mouse move, click.
 *
 * @param {answersPageEngagementParams} params - The parameters for this event
 * @return {LogObject<answersPageEngagementParams>} LogObject<answersPageEngagementParams>
 */
export function answersPageEngagement(params) {
    throw new Error('answersPageEngagement cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'devGeneralAnswersFedEvent' event (evid: 42)
 *
 * Event description: This is a general event that serves as "event candidate". Relevant events will be later developed as standalone events.
 *
 * @param {devGeneralAnswersFedEventParams} params - The parameters for this event
 * @return {LogObject<devGeneralAnswersFedEventParams>} LogObject<devGeneralAnswersFedEventParams>
 */
export function devGeneralAnswersFedEvent(params) {
    throw new Error('devGeneralAnswersFedEvent cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appOneInboxStartActiveSession' event (evid: 1031)
 *
 * Event description: This Event is triggered every time a member is starting an active session by clicking the "Take Ticket"/"Join Active session" button or by start typing in the reply box.
 *
 * @param {appOneInboxStartActiveSessionParams} params - The parameters for this event
 * @return {LogObject<appOneInboxStartActiveSessionParams>} LogObject<appOneInboxStartActiveSessionParams>
 */
export function appOneInboxStartActiveSession(params) {
    throw new Error('appOneInboxStartActiveSession cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicClickOnContactUs' event (evid: 2500)
 *
 * Event description: Click on "Contact Us"
 *
 * @param {publicClickOnContactUsParams} params - The parameters for this event
 * @return {LogObject<publicClickOnContactUsParams>} LogObject<publicClickOnContactUsParams>
 */
export function publicClickOnContactUs(params) {
    throw new Error('publicClickOnContactUs cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbEditArticleSaveSuccess' event (evid: 1101)
 *
 * Event description: Finish save process
 *
 * @param {appKbEditArticleSaveSuccessParams} params - The parameters for this event
 * @return {LogObject<appKbEditArticleSaveSuccessParams>} LogObject<appKbEditArticleSaveSuccessParams>
 */
export function appKbEditArticleSaveSuccess(params) {
    throw new Error('appKbEditArticleSaveSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'callbackWidgetTicketCreation' event (evid: 4907)
 *
 * Event description: Triggers whenever a new ticket is created via the callback request widget
 *
 * @param {callbackWidgetTicketCreationParams} params - The parameters for this event
 * @return {LogObject<callbackWidgetTicketCreationParams>} LogObject<callbackWidgetTicketCreationParams>
 */
export function callbackWidgetTicketCreation(params) {
    throw new Error('callbackWidgetTicketCreation cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appPremiumBlocksPremiumIncentiveView' event (evid: 1851)
 *
 * Event description: An user views a premium incentive of a blocked premium feature
 *
 * @param {appPremiumBlocksPremiumIncentiveViewParams} params - The parameters for this event
 * @return {LogObject<appPremiumBlocksPremiumIncentiveViewParams>} LogObject<appPremiumBlocksPremiumIncentiveViewParams>
 */
export function appPremiumBlocksPremiumIncentiveView(params) {
    throw new Error('appPremiumBlocksPremiumIncentiveView cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appPremiumBlocksPremiumIncentiveCtaClick' event (evid: 1852)
 *
 * Event description: A user clicks on a CTA in a premium incentive of a blocked premium feature
 *
 * @param {appPremiumBlocksPremiumIncentiveCtaClickParams} params - The parameters for this event
 * @return {LogObject<appPremiumBlocksPremiumIncentiveCtaClickParams>} LogObject<appPremiumBlocksPremiumIncentiveCtaClickParams>
 */
export function appPremiumBlocksPremiumIncentiveCtaClick(params) {
    throw new Error('appPremiumBlocksPremiumIncentiveCtaClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicVoteForFeatureRequest' event (evid: 2003)
 *
 * Event description: Vote/un-vote for wish list (similar to evid 502 in src 4)
 *
 * @param {publicVoteForFeatureRequestParams} params - The parameters for this event
 * @return {LogObject<publicVoteForFeatureRequestParams>} LogObject<publicVoteForFeatureRequestParams>
 */
export function publicVoteForFeatureRequest(params) {
    throw new Error('publicVoteForFeatureRequest cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbPublishSuccess' event (evid: 1121)
 *
 * Event description: Successfully publishing an article
 *
 * @param {appKbPublishSuccessParams} params - The parameters for this event
 * @return {LogObject<appKbPublishSuccessParams>} LogObject<appKbPublishSuccessParams>
 */
export function appKbPublishSuccess(params) {
    throw new Error('appKbPublishSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appKbCategoriesCreateCategoryCancelClick' event (evid: 1113)
 *
 * Event description: Create category --> click cancel
 *
 * @param {appKbCategoriesCreateCategoryCancelClickParams} params - The parameters for this event
 * @return {LogObject<appKbCategoriesCreateCategoryCancelClickParams>} LogObject<appKbCategoriesCreateCategoryCancelClickParams>
 */
export function appKbCategoriesCreateCategoryCancelClick(params) {
    throw new Error('appKbCategoriesCreateCategoryCancelClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicSubmitTicketAttempt' event (evid: 2510)
 *
 * Event description: Clicking on "Submit ticket" button at the bottom of the ticket form
 * (similar to event 577 in source 4)
 *
 * @param {publicSubmitTicketAttemptParams} params - The parameters for this event
 * @return {LogObject<publicSubmitTicketAttemptParams>} LogObject<publicSubmitTicketAttemptParams>
 */
export function publicSubmitTicketAttempt(params) {
    throw new Error('publicSubmitTicketAttempt cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appGeneralInAppNotificationsClientEngagement' event (evid: 4902)
 *
 * Event description: A generic event for the following clicks/engagements related to In-app notifications: (1) click on main notifications button to open the notification list, (2) click on notification (3) create announcement click,  (4) Send announcement click
 *
 * @param {appGeneralInAppNotificationsClientEngagementParams} params - The parameters for this event
 * @return {LogObject<appGeneralInAppNotificationsClientEngagementParams>} LogObject<appGeneralInAppNotificationsClientEngagementParams>
 */
export function appGeneralInAppNotificationsClientEngagement(params) {
    throw new Error('appGeneralInAppNotificationsClientEngagement cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteAReplyCancel' event (evid: 1014)
 *
 * Event description: Click "Cancel" after being asked "Are you sure?". event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteAReplyCancelParams} params - The parameters for this event
 * @return {LogObject<appTicketsOneInboxDeleteAReplyCancelParams>} LogObject<appTicketsOneInboxDeleteAReplyCancelParams>
 */
export function appTicketsOneInboxDeleteAReplyCancel(params) {
    throw new Error('appTicketsOneInboxDeleteAReplyCancel cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicCustomerPortalViewerPageLoadSuccess' event (evid: 2401)
 *
 * Event description: This Event is triggered every time Customer Portal viewer page is Loaded Successfully
 *
 * @param {publicCustomerPortalViewerPageLoadSuccessParams} params - The parameters for this event
 * @return {LogObject<publicCustomerPortalViewerPageLoadSuccessParams>} LogObject<publicCustomerPortalViewerPageLoadSuccessParams>
 */
export function publicCustomerPortalViewerPageLoadSuccess(params) {
    throw new Error('publicCustomerPortalViewerPageLoadSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicVoteForAnArticle' event (evid: 2002)
 *
 * Event description: Click on "Thumbs up/down" (similar to evid 501 in src 4)
 *
 * @param {publicVoteForAnArticleParams} params - The parameters for this event
 * @return {LogObject<publicVoteForAnArticleParams>} LogObject<publicVoteForAnArticleParams>
 */
export function publicVoteForAnArticle(params) {
    throw new Error('publicVoteForAnArticle cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appGeneralFtueVideoLightboxView' event (evid: 1947)
 *
 * Event description: First Time User Experience (FTUE) Video Lightbox of a certain feature was viewed by the user
 *
 * @param {appGeneralFtueVideoLightboxViewParams} params - The parameters for this event
 * @return {LogObject<appGeneralFtueVideoLightboxViewParams>} LogObject<appGeneralFtueVideoLightboxViewParams>
 */
export function appGeneralFtueVideoLightboxView(params) {
    throw new Error('appGeneralFtueVideoLightboxView cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'answersBannerClick' event (evid: 4909)
 *
 * Event description: Fired when a user clicks a banner in Answers
 *
 * @param {answersBannerClickParams} params - The parameters for this event
 * @return {LogObject<answersBannerClickParams>} LogObject<answersBannerClickParams>
 */
export function answersBannerClick(params) {
    throw new Error('answersBannerClick cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicWismoChatbotStepReached' event (evid: 2260)
 *
 * @param {publicWismoChatbotStepReachedParams} params - The parameters for this event
 * @return {LogObject<publicWismoChatbotStepReachedParams>} LogObject<publicWismoChatbotStepReachedParams>
 */
export function publicWismoChatbotStepReached(params) {
    throw new Error('publicWismoChatbotStepReached cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appInboxAgentsGlobalStatusWasChanged' event (evid: 4050)
 *
 * Event description: The event is fired whenever an agent's global status (including going in-and-out of an active session) or assigned channels are changed (Also referred to as "State change").
 * The change might be triggered by the user herself or an admin.
 * The UUID always belongs to the agent.
 * The data in the event is about the status that just ended.
 *
 * @param {appInboxAgentsGlobalStatusWasChangedParams} params - The parameters for this event
 * @return {LogObject<appInboxAgentsGlobalStatusWasChangedParams>} LogObject<appInboxAgentsGlobalStatusWasChangedParams>
 */
export function appInboxAgentsGlobalStatusWasChanged(params) {
    throw new Error('appInboxAgentsGlobalStatusWasChanged cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appChatsMessageFail' event (evid: 4603)
 *
 * Event description: Answers Member or System failed to send a chat message to Widget / SMS or Whatsapp
 *
 * @param {appChatsMessageFailParams} params - The parameters for this event
 * @return {LogObject<appChatsMessageFailParams>} LogObject<appChatsMessageFailParams>
 */
export function appChatsMessageFail(params) {
    throw new Error('appChatsMessageFail cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicReplyCreationSuccess' event (evid: 5009)
 *
 * Event description: A new reply for a ticket was successfully created in Answers DB.
 *
 * @param {publicReplyCreationSuccessParams} params - The parameters for this event
 * @return {LogObject<publicReplyCreationSuccessParams>} LogObject<publicReplyCreationSuccessParams>
 */
export function publicReplyCreationSuccess(params) {
    throw new Error('publicReplyCreationSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appChatsMessageAttempt' event (evid: 4601)
 *
 * Event description: Answers (Member or System) attempted to send a Chat message to Widget, SMS or Whatsapp
 *
 * @param {appChatsMessageAttemptParams} params - The parameters for this event
 * @return {LogObject<appChatsMessageAttemptParams>} LogObject<appChatsMessageAttemptParams>
 */
export function appChatsMessageAttempt(params) {
    throw new Error('appChatsMessageAttempt cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appTicketsActionTriggeredByMultiActionExecutor' event (evid: 4012)
 *
 * Event description: Will be triggered on by each Action that was Triggered Automatically by multi action executor (Can be triggered from Automatic actions or Macros)
 *
 * @param {appTicketsActionTriggeredByMultiActionExecutorParams} params - The parameters for this event
 * @return {LogObject<appTicketsActionTriggeredByMultiActionExecutorParams>} LogObject<appTicketsActionTriggeredByMultiActionExecutorParams>
 */
export function appTicketsActionTriggeredByMultiActionExecutor(params) {
    throw new Error('appTicketsActionTriggeredByMultiActionExecutor cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appChatsMessageSuccess' event (evid: 4602)
 *
 * Event description: Answers Member or System user successfully sent a chat message to Widget / SMS number or Whatsapp
 *
 * @param {appChatsMessageSuccessParams} params - The parameters for this event
 * @return {LogObject<appChatsMessageSuccessParams>} LogObject<appChatsMessageSuccessParams>
 */
export function appChatsMessageSuccess(params) {
    throw new Error('appChatsMessageSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'appOneInboxTicketSnoozeEnd' event (evid: 4009)
 *
 * Event description: A ticket snooze has been ended by a member or by the system, it can happen naturally if ticket's snooze time ended or by a specific action that ended it before like: another user reply in the ticket, a member unsnooze the ticket etc.
 *
 * @param {appOneInboxTicketSnoozeEndParams} params - The parameters for this event
 * @return {LogObject<appOneInboxTicketSnoozeEndParams>} LogObject<appOneInboxTicketSnoozeEndParams>
 */
export function appOneInboxTicketSnoozeEnd(params) {
    throw new Error('appOneInboxTicketSnoozeEnd cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'integratorsGeneralWebhookCalledSuccess' event (evid: 9517)
 *
 * Event description: The integration successfully called a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsGeneralWebhookCalledSuccessParams} params - The parameters for this event
 * @return {LogObject<integratorsGeneralWebhookCalledSuccessParams>} LogObject<integratorsGeneralWebhookCalledSuccessParams>
 */
export function integratorsGeneralWebhookCalledSuccess(params) {
    throw new Error('integratorsGeneralWebhookCalledSuccess cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'publicWidgetWidgetLauncherRequestedServer' event (evid: 6001)
 *
 * Event description: The event is trigger when the server gets a request from the page to load the launcher.
 *
 * @param {publicWidgetWidgetLauncherRequestedServerParams} params - The parameters for this event
 * @return {LogObject<publicWidgetWidgetLauncherRequestedServerParams>} LogObject<publicWidgetWidgetLauncherRequestedServerParams>
 */
export function publicWidgetWidgetLauncherRequestedServer(params) {
    throw new Error('publicWidgetWidgetLauncherRequestedServer cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'userFrustrationScore' event (evid: 724)
 *
 * Event description: Includes the Customer Care's User Frustration Score for each user based on his recent activity with Customer Care and Wix.
 *
 * @param {userFrustrationScoreParams} params - The parameters for this event
 * @return {LogObject<userFrustrationScoreParams>} LogObject<userFrustrationScoreParams>
 */
export function userFrustrationScore(params) {
    throw new Error('userFrustrationScore cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'lastUserSatisfactionSurveyScore' event (evid: 723)
 *
 * Event description: Last user satisfaction survey score (Customer Care survey)
 *
 * @param {lastUserSatisfactionSurveyScoreParams} params - The parameters for this event
 * @return {LogObject<lastUserSatisfactionSurveyScoreParams>} LogObject<lastUserSatisfactionSurveyScoreParams>
 */
export function lastUserSatisfactionSurveyScore(params) {
    throw new Error('lastUserSatisfactionSurveyScore cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'kbTrendingArticlesPerUser' event (evid: 729)
 *
 * Event description: Includes for each user the trending articles the user should see on the Help Center homepage. Generated by a data model.
 *
 * @param {kbTrendingArticlesPerUserParams} params - The parameters for this event
 * @return {LogObject<kbTrendingArticlesPerUserParams>} LogObject<kbTrendingArticlesPerUserParams>
 */
export function kbTrendingArticlesPerUser(params) {
    throw new Error('kbTrendingArticlesPerUser cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'partnersAccounts' event (evid: 719)
 *
 * Event description: Includes all Wix Confirmed Partners accounts and their partner tier
 *
 * @param {partnersAccountsParams} params - The parameters for this event
 * @return {LogObject<partnersAccountsParams>} LogObject<partnersAccountsParams>
 */
export function partnersAccounts(params) {
    throw new Error('partnersAccounts cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'userPreferredCommunicationMethod' event (evid: 725)
 *
 * Event description: Includes the user's Preferred communication method with Customer Care based on the user's activity history
 *
 * @param {userPreferredCommunicationMethodParams} params - The parameters for this event
 * @return {LogObject<userPreferredCommunicationMethodParams>} LogObject<userPreferredCommunicationMethodParams>
 */
export function userPreferredCommunicationMethod(params) {
    throw new Error('userPreferredCommunicationMethod cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'topVerticalsAccounts' event (evid: 720)
 *
 * Event description: Include all top verticals accounts
 *
 * @param {topVerticalsAccountsParams} params - The parameters for this event
 * @return {LogObject<topVerticalsAccountsParams>} LogObject<topVerticalsAccountsParams>
 */
export function topVerticalsAccounts(params) {
    throw new Error('topVerticalsAccounts cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'accountNamespaceType' event (evid: 721)
 *
 * Event description: List of all accounts that have only Headless or Anywhere sites
 *
 * @param {accountNamespaceTypeParams} params - The parameters for this event
 * @return {LogObject<accountNamespaceTypeParams>} LogObject<accountNamespaceTypeParams>
 */
export function accountNamespaceType(params) {
    throw new Error('accountNamespaceType cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'managedAccounts' event (evid: 718)
 *
 * Event description: Includes all Wix Managed accounts and their account manager name
 *
 * @param {managedAccountsParams} params - The parameters for this event
 * @return {LogObject<managedAccountsParams>} LogObject<managedAccountsParams>
 */
export function managedAccounts(params) {
    throw new Error('managedAccounts cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'b2BAccounts' event (evid: 717)
 *
 * Event description: Includes all Wix B2B accounts and their B2B type and name
 *
 * @param {b2BAccountsParams} params - The parameters for this event
 * @return {LogObject<b2BAccountsParams>} LogObject<b2BAccountsParams>
 */
export function b2BAccounts(params) {
    throw new Error('b2BAccounts cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'usersValueScore' event (evid: 716)
 *
 * Event description: Includes value score of each premium user at Wix based on the Customer Care model
 *
 * @param {usersValueScoreParams} params - The parameters for this event
 * @return {LogObject<usersValueScoreParams>} LogObject<usersValueScoreParams>
 */
export function usersValueScore(params) {
    throw new Error('usersValueScore cannot be used, reason: Event is not active in catalog v2');
}
/**
 * A function to create a log object for the 'deleteMe' event (evid: 9)
 *
 * Event description: pp
 *
 * @param {deleteMeParams} params - The parameters for this event
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<deleteMeParams>} LogObject<deleteMeParams>
 */
export function deleteMe(params) {
    return { evid: 9, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickingOnSubCategoryOnHomePage' event (evid: 11)
 *
 * Event description: clicking on sub- category on home page.
 *
 * @param {clickingOnSubCategoryOnHomePageParams} params - The parameters for this event
 * @property {string} forum - product
 * @property {string} question - question
 * @property {string} sub_category - sub_category
 * @property {GUID} __cookies_prefix__s_session_id - session
 * @property {string} __cookies_prefix__WixYoutube_ab - ablabel
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} product - product
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickingOnSubCategoryOnHomePageParams>} LogObject<clickingOnSubCategoryOnHomePageParams>
 */
export function clickingOnSubCategoryOnHomePage(params) {
    return { evid: 11, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeLanguage' event (evid: 25)
 *
 * Event description: change language.
 *
 * @param {changeLanguageParams} params - The parameters for this event
 * @property {string} forum - product
 * @property {string} question - question
 * @property {string} sub_category - sub_category
 * @property {string} url - url
 * @property {string} to_language - to_language
 * @property {string} target_url - target_url
 * @property {GUID} __cookies_prefix__s_session_id - session
 * @property {string} __cookies_prefix__WixYoutube_ab - ablabel
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} from_language - from_language
 * @property {string} product - product
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<changeLanguageParams>} LogObject<changeLanguageParams>
 */
export function changeLanguage(params) {
    return { evid: 25, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickTheForumLink' event (evid: 514)
 *
 * Event description: click the forum link.
 *
 * @param {clickTheForumLinkParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} referral_name - referral_name
 * @property {string} item_name - item_name
 * @property {string} source_name - source_name
 * @property {string} lang - lng
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickTheForumLinkParams>} LogObject<clickTheForumLinkParams>
 */
export function clickTheForumLink(params) {
    return { evid: 514, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickAContent' event (evid: 517)
 *
 * Event description: click a content.
 *
 * @param {clickAContentParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} source_url - source_url
 * @property {string} sub_category - sub_category
 * @property {string} referral_name - referral_name
 * @property {boolean} from_search - from_search
 * @property {string} item_name - item_name
 * @property {string} source_name - source_name
 * @property {string} order - order
 * @property {string} category - category
 * @property {string} kb_lang - kb_lang
 * @property {string} lang - lng
 * @property {string} type - type
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickAContentParams>} LogObject<clickAContentParams>
 */
export function clickAContent(params) {
    return { evid: 517, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chooseACategoryAndSubcategory' event (evid: 519)
 *
 * Event description: choose a category and subcategory.
 *
 * @param {chooseACategoryAndSubcategoryParams} params - The parameters for this event
 * @property {string} source_url - source_url
 * @property {string} sub_category - sub_category
 * @property {string} referral_name - referral_name
 * @property {string} source_name - source_name
 * @property {string} category - category
 * @property {string} kb_lang - kb_lang
 * @property {string} lang - lng
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<chooseACategoryAndSubcategoryParams>} LogObject<chooseACategoryAndSubcategoryParams>
 */
export function chooseACategoryAndSubcategory(params) {
    return { evid: 519, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickedOutsideBox' event (evid: 536)
 *
 * Event description: clicked outside box.
 *
 * @param {clickedOutsideBoxParams} params - The parameters for this event
 * @property {string} question - question
 * @property {string} source_url - source_url
 * @property {string} referral_name - referral_name
 * @property {string} first_answer - first_answer
 * @property {string} source_name - source_name
 * @property {string} lang - lng
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickedOutsideBoxParams>} LogObject<clickedOutsideBoxParams>
 */
export function clickedOutsideBox(params) {
    return { evid: 536, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientLoadSuccess' event (evid: 559)
 *
 * Event description: Sent when the client app was fully rendered (all ajax requests completed, etc).
 *
 * @param {clientLoadSuccessParams} params - The parameters for this event
 * @property {string} referral_name - referral_name
 * @property {number} ts - ts
 * @property {string} client_name - client_name
 * @property {string} source_name - source_name
 * @property {string} lang - lang
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clientLoadSuccessParams>} LogObject<clientLoadSuccessParams>
 */
export function clientLoadSuccess(params) {
    return { evid: 559, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wasItHelpfulSubmitFeedbackForm' event (evid: 569)
 *
 * Event description: Click submit feedback form after marking an article as unhelpful (evid 501, thumbs_down false)
 *
 * @param {wasItHelpfulSubmitFeedbackFormParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {GUID} item_id - item_id
 * @property {string} selectedCompType - origin_component
 * @property {string} feedback - feedback
 * @property {string} item_name - item_name
 * @property {string} source_name - source_name
 * @property {string} lang - lang
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wasItHelpfulSubmitFeedbackFormParams>} LogObject<wasItHelpfulSubmitFeedbackFormParams>
 */
export function wasItHelpfulSubmitFeedbackForm(params) {
    return { evid: 569, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactClickOnTheActionButton' event (evid: 574)
 *
 * Event description: User click on the action button next to the solution content
 *
 * @param {wixContactClickOnTheActionButtonParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} provider - provider
 * @property {Url} referral_url - referral_url
 * @property {string} chatbot_view - chatbot_view
 * @property {string} widget_view_mode - widget_view_mode
 * @property {string} sub_option_name - sub_option_name
 * @property {string} call_center_status - call_center_status
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} sub_option_id - sub_option_id
 * @property {Url} action_url - action_url
 * @property {string} user_experience - user_experience
 * @property {number} solution_time - solution_time
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - estimated_wait_time
 * @property {string} lang - lang
 * @property {string} solution_title - solution_title
 * @property {string} ticketing_status - ticketing_status
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wixContactClickOnTheActionButtonParams>} LogObject<wixContactClickOnTheActionButtonParams>
 */
export function wixContactClickOnTheActionButton(params) {
    return { evid: 574, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactClickOnALinkInsideASolution' event (evid: 575)
 *
 * Event description: User click on a link inside the solution content
 *
 * @param {wixContactClickOnALinkInsideASolutionParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - session_id
 * @property {string} provider - provider
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - widget_view_mode
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - call_center_status
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} referral_info - referral_info
 * @property {string} link_name - link_name
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - action_url
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - solution_time
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {Url} link_url - link_url
 * @property {number} estimated_wait_time - estimated_wait_time
 * @property {string} lang - lang
 * @property {string} solution_title - solution_title
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - ticketing_status
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactClickOnALinkInsideASolutionParams>} LogObject<wixContactClickOnALinkInsideASolutionParams>
 */
export function wixContactClickOnALinkInsideASolution(params) {
    return { evid: 575, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactSubmitTicketForm' event (evid: 577)
 *
 * Event description: Clicking the "Submit a ticket" button at the bottom of the ticket form
 *
 * @param {wixContactSubmitTicketFormParams} params - The parameters for this event
 * @property {string} chat_status - chat_status
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - session_id
 * @property {string} provider - provider
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - context
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - widget_view_mode
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - call_center_status
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - action_url
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - solution_time
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - estimated_wait_time
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} platform - platform
 * @property {string} solution_title - solution_title
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - ticketing_status
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactSubmitTicketFormParams>} LogObject<wixContactSubmitTicketFormParams>
 */
export function wixContactSubmitTicketForm(params) {
    return { evid: 577, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactCallbackFailedClient' event (evid: 581)
 *
 * Event description: User was not able to schedule a callback
 *
 * @param {wixContactCallbackFailedClientParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - session_id
 * @property {string} provider - provider
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - context
 * @property {string} node_id - node_id
 * @property {string} server_error - server_error
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - call_center_status
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} reason - reason
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - action_url
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - solution_time
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - estimated_wait_time
 * @property {boolean} view_recaptcha - view_recaptcha
 * @property {string} lang - lang
 * @property {string} platform - platform
 * @property {string} solution_title - solution_title
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - ticketing_status
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactCallbackFailedClientParams>} LogObject<wixContactCallbackFailedClientParams>
 */
export function wixContactCallbackFailedClient(params) {
    return { evid: 581, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactTicketSubmissionSuccess' event (evid: 582)
 *
 * Event description: User was able to submit a ticket through "Wix Contact"
 *
 * @param {wixContactTicketSubmissionSuccessParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - session_id
 * @property {string} provider - provider
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - context
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - call_center_status
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} announcement_text - announcement_text
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - solution_time
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} ticket_url - ticket_url
 * @property {number} estimated_wait_time - estimated_wait_time
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} solution_title - solution_title
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - ticketing_status
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactTicketSubmissionSuccessParams>} LogObject<wixContactTicketSubmissionSuccessParams>
 */
export function wixContactTicketSubmissionSuccess(params) {
    return { evid: 582, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactTicketSubmissionFailedClient' event (evid: 584)
 *
 * Event description: User was not able to submit a ticket through "Wix Contact"
 *
 * @param {wixContactTicketSubmissionFailedClientParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - session_id
 * @property {string} provider - provider
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} node_id - node_id
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - call_center_status
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} reason - reason
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - solution_time
 * @property {string} main_option_name - main_option_name
 * @property {number} estimated_wait_time - estimated_wait_time
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} solution_title - solution_title
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - ticketing_status
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactTicketSubmissionFailedClientParams>} LogObject<wixContactTicketSubmissionFailedClientParams>
 */
export function wixContactTicketSubmissionFailedClient(params) {
    return { evid: 584, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'articleClickActionButton' event (evid: 588)
 *
 * Event description: click an action button inside an article
 *
 * @param {articleClickActionButtonParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} selectedCompType - origin_component
 * @property {Url} action_url - action_url
 * @property {string} item_name - item_name
 * @property {string} source_name - source_name
 * @property {number} solution_time - solution_time
 * @property {string} kb_lang - kb_lang
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} action_text - action_text
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<articleClickActionButtonParams>} LogObject<articleClickActionButtonParams>
 */
export function articleClickActionButton(params) {
    return { evid: 588, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactOpenWixContactAttempt' event (evid: 592)
 *
 * Event description: User opens "Wix Contact" from desktop. The Contact form has started to load.
 *
 * @param {wixContactOpenWixContactAttemptParams} params - The parameters for this event
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} context - context
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} user_experience - user_experience
 * @property {string} lang - lang
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wixContactOpenWixContactAttemptParams>} LogObject<wixContactOpenWixContactAttemptParams>
 */
export function wixContactOpenWixContactAttempt(params) {
    return { evid: 592, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'articleClickOnBanner' event (evid: 594)
 *
 * Event description: click on a banner inside an article
 *
 * @param {articleClickOnBannerParams} params - The parameters for this event
 * @property {string} banner_text - action_text
 * @property {GUID} item_id - item_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} selectedCompType - origin_component
 * @property {string} item_name - item_name
 * @property {string} source_name - source_name
 * @property {Url} banner_url - banner_url
 * @property {string} lang - lang
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<articleClickOnBannerParams>} LogObject<articleClickOnBannerParams>
 */
export function articleClickOnBanner(params) {
    return { evid: 594, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerSubmitScheduledCallbackRequest' event (evid: 604)
 *
 * Event description: Clicking the "Schedule a Callback" button at the bottom of the Call Scheduler
 *
 * @param {callSchedulerSubmitScheduledCallbackRequestParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerSubmitScheduledCallbackRequestParams>} LogObject<callSchedulerSubmitScheduledCallbackRequestParams>
 */
export function callSchedulerSubmitScheduledCallbackRequest(params) {
    return { evid: 604, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerScheduledCallbackSuccess' event (evid: 605)
 *
 * Event description: User was able to schedule a callback
 *
 * @param {callSchedulerScheduledCallbackSuccessParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {GUID} queue_id - queue_id
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerScheduledCallbackSuccessParams>} LogObject<callSchedulerScheduledCallbackSuccessParams>
 */
export function callSchedulerScheduledCallbackSuccess(params) {
    return { evid: 605, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerClickRescheduleOrCancelCall' event (evid: 606)
 *
 * Event description: User clicks the "Reschedule or cancel call" button after scheduling a call
 *
 * @param {callSchedulerClickRescheduleOrCancelCallParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerClickRescheduleOrCancelCallParams>} LogObject<callSchedulerClickRescheduleOrCancelCallParams>
 */
export function callSchedulerClickRescheduleOrCancelCall(params) {
    return { evid: 606, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerClickCancel' event (evid: 607)
 *
 * Event description: User clicks the "Cancel" button on the My Scheduled Callbacks page.
 *
 * @param {callSchedulerClickCancelParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerClickCancelParams>} LogObject<callSchedulerClickCancelParams>
 */
export function callSchedulerClickCancel(params) {
    return { evid: 607, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerClickReschedule' event (evid: 608)
 *
 * Event description: User clicks the "Reschedule" button on the My Scheduled Callbacks page.
 *
 * @param {callSchedulerClickRescheduleParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerClickRescheduleParams>} LogObject<callSchedulerClickRescheduleParams>
 */
export function callSchedulerClickReschedule(params) {
    return { evid: 608, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerOpenMyScheduledCallsPage' event (evid: 609)
 *
 * Event description: User opens the My Scheduled Calls page
 *
 * @param {callSchedulerOpenMyScheduledCallsPageParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} button_name - button_name
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerOpenMyScheduledCallsPageParams>} LogObject<callSchedulerOpenMyScheduledCallsPageParams>
 */
export function callSchedulerOpenMyScheduledCallsPage(params) {
    return { evid: 609, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerCancelCallbackRequest' event (evid: 610)
 *
 * Event description: User cancels their callback request
 *
 * @param {callSchedulerCancelCallbackRequestParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {GUID} queue_id - queue_id
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerCancelCallbackRequestParams>} LogObject<callSchedulerCancelCallbackRequestParams>
 */
export function callSchedulerCancelCallbackRequest(params) {
    return { evid: 610, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerKeepCallbackScheduled' event (evid: 611)
 *
 * Event description: User decides not to cancel their callback request by pressing "No, Keep It Scheduled" or by exiting out of the cancel window.
 *
 * @param {callSchedulerKeepCallbackScheduledParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerKeepCallbackScheduledParams>} LogObject<callSchedulerKeepCallbackScheduledParams>
 */
export function callSchedulerKeepCallbackScheduled(params) {
    return { evid: 611, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerAddToYourCalendar' event (evid: 612)
 *
 * Event description: User clicks the button to add the scheduled callback to their calendar.
 *
 * @param {callSchedulerAddToYourCalendarParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerAddToYourCalendarParams>} LogObject<callSchedulerAddToYourCalendarParams>
 */
export function callSchedulerAddToYourCalendar(params) {
    return { evid: 612, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerScheduledCallbackFailure' event (evid: 621)
 *
 * Event description: User failed to schedule a callback
 *
 * @param {callSchedulerScheduledCallbackFailureParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerScheduledCallbackFailureParams>} LogObject<callSchedulerScheduledCallbackFailureParams>
 */
export function callSchedulerScheduledCallbackFailure(params) {
    return { evid: 621, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerLoadScheduleACallbackPage' event (evid: 622)
 *
 * Event description: Loading the “Schedule a Callback" page
 *
 * @param {callSchedulerLoadScheduleACallbackPageParams} params - The parameters for this event
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerLoadScheduleACallbackPageParams>} LogObject<callSchedulerLoadScheduleACallbackPageParams>
 */
export function callSchedulerLoadScheduleACallbackPage(params) {
    return { evid: 622, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnFeaturedArticleInHeaderHelpWidget' event (evid: 623)
 *
 * Event description: Events when clicking an article from the Featured Article section in 'my site' help widget .
 *
 * @param {clickOnFeaturedArticleInHeaderHelpWidgetParams} params - The parameters for this event
 * @property {string} item_id - item_id
 * @property {number} feature_article_position - feature_article_position
 * @property {string} source_name - source_name
 * @property {string} lang - lang
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickOnFeaturedArticleInHeaderHelpWidgetParams>} LogObject<clickOnFeaturedArticleInHeaderHelpWidgetParams>
 */
export function clickOnFeaturedArticleInHeaderHelpWidget(params) {
    return { evid: 623, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewFeaturedArticlesInHeaderHelpWidget' event (evid: 624)
 *
 * Event description: View event when opening the 'my site' help widget .
 *
 * @param {viewFeaturedArticlesInHeaderHelpWidgetParams} params - The parameters for this event
 * @property {string} source_name - source_name
 * @property {string} featured_articles_item_ids - featured_articles_item_ids
 * @property {string} featured_articles_lang - featured_articles_lang
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<viewFeaturedArticlesInHeaderHelpWidgetParams>} LogObject<viewFeaturedArticlesInHeaderHelpWidgetParams>
 */
export function viewFeaturedArticlesInHeaderHelpWidget(params) {
    return { evid: 624, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotUpdateBiProfileField' event (evid: 625)
 *
 * Event description: Save user information from Chatbot to BI Profile
 *
 * @param {chatbotUpdateBiProfileFieldParams} params - The parameters for this event
 * @property {string} node_name - node_name
 * @property {string} node_id - node_id
 * @property {string} key - key
 * @property {string} conversation_id - conversation_id
 * @property {string} value - value
 * @property {string} action - action
 * @return {LogObject<chatbotUpdateBiProfileFieldParams>} LogObject<chatbotUpdateBiProfileFieldParams>
 */
export function chatbotUpdateBiProfileField(params) {
    return { evid: 625, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixWidgetOpenAWidgetClient' event (evid: 662)
 *
 * Event description: The event is trigger when a widget is opened
 *
 * @param {wixWidgetOpenAWidgetClientParams} params - The parameters for this event
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} parent_name - parent_name
 * @property {string} current_platform - current_platform
 * @property {string} source_name - source_name
 * @property {string} module_name - module_name
 * @property {string} lang - lang
 * @property {string} open_method - open_method
 * @property {string} parent_url - parent_url
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wixWidgetOpenAWidgetClientParams>} LogObject<wixWidgetOpenAWidgetClientParams>
 */
export function wixWidgetOpenAWidgetClient(params) {
    return { evid: 662, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appListenToRecordedCall' event (evid: 702)
 *
 * Event description: recorded call is being listened to by a user in Answers
 *
 * @param {appListenToRecordedCallParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {GUID} uuid - uuid
 * @property {GUID} answers_uuid - answers_uuid
 * @property {string} lang - lang
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<appListenToRecordedCallParams>} LogObject<appListenToRecordedCallParams>
 */
export function appListenToRecordedCall(params) {
    return { evid: 702, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appClickOnScreenshareFromACallTicket' event (evid: 703)
 *
 * Event description: Agent clicks on the link inside the ticket's custom fields in order to record the user's screen realtime during a call
 *
 * @param {appClickOnScreenshareFromACallTicketParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {GUID} customer_uuid - customer_uuid
 * @property {GUID} callid - callid
 * @property {string} lang - lang
 * @property {GUID} agent_uuid - uuid
 * @property {GUID} agent_id - agent_id
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<appClickOnScreenshareFromACallTicketParams>} LogObject<appClickOnScreenshareFromACallTicketParams>
 */
export function appClickOnScreenshareFromACallTicket(params) {
    return { evid: 703, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'labelEventScreenshareLinkWasEnabledOrDisabledForACall' event (evid: 704)
 *
 * Event description: Screenshare link option is enabled or disabled for a specific call --> meaning - this call is assigned to an AB test group A or B
 *
 * @param {labelEventScreenshareLinkWasEnabledOrDisabledForACallParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {string} label_name - label_name
 * @property {GUID} customer_uuid - customer_uuid
 * @property {GUID} callid - callid
 * @property {string} lang - lang
 * @property {GUID} agent_id - agent_id
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<labelEventScreenshareLinkWasEnabledOrDisabledForACallParams>} LogObject<labelEventScreenshareLinkWasEnabledOrDisabledForACallParams>
 */
export function labelEventScreenshareLinkWasEnabledOrDisabledForACall(params) {
    return { evid: 704, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'abTestConductionCheckEvent' event (evid: 705)
 *
 * Event description: Checking perti conduction value assigned to the user
 *
 * @param {abTestConductionCheckEventParams} params - The parameters for this event
 * @property {string} petri_conduciton_value - petri_conduciton_value
 * @property {boolean} is_b - is_b
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<abTestConductionCheckEventParams>} LogObject<abTestConductionCheckEventParams>
 */
export function abTestConductionCheckEvent(params) {
    return { evid: 705, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'agentDeclinesCall' event (evid: 706)
 *
 * Event description: Agent clicks the decline button of a call reserve attempt
 *
 * @param {agentDeclinesCallParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} call_id - call__id
 * @property {GUID} agent_id - uuid
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<agentDeclinesCallParams>} LogObject<agentDeclinesCallParams>
 */
export function agentDeclinesCall(params) {
    return { evid: 706, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainTroubleshooterSubmit' event (evid: 800)
 *
 * Event description: The user clicked on 'Submit' in the domain troubleshooter
 *
 * @param {domainTroubleshooterSubmitParams} params - The parameters for this event
 * @property {string} domainName - domain_name
 * @return {LogObject<domainTroubleshooterSubmitParams>} LogObject<domainTroubleshooterSubmitParams>
 */
export function domainTroubleshooterSubmit(params) {
    return { evid: 800, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'godaddyConnectResponse' event (evid: 851)
 *
 * Event description: Result from Godaddy Connect Response
 *
 * @param {godaddyConnectResponseParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} connectAttemptResult - connect_attempt_result
 * @property {string} domainName - domain_name
 * @return {LogObject<godaddyConnectResponseParams>} LogObject<godaddyConnectResponseParams>
 */
export function godaddyConnectResponse(params) {
    return { evid: 851, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainHelperChoosingSiteFromListSrc4Evid1000' event (evid: 1000)
 *
 * Event description: Domain Helper - Choosing site from list.
 *
 * @param {domainHelperChoosingSiteFromListSrc4Evid1000Params} params - The parameters for this event
 * @return {LogObject<domainHelperChoosingSiteFromListSrc4Evid1000Params>} LogObject<domainHelperChoosingSiteFromListSrc4Evid1000Params>
 */
export function domainHelperChoosingSiteFromListSrc4Evid1000(params) {
    return { evid: 1000, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotStartOver' event (evid: 1054)
 *
 * Event description: The user clicks the Start Over button to restart the chat
 *
 * @param {chatbotStartOverParams} params - The parameters for this event
 * @property {string} node_name - node_name
 * @property {string} main_option_id - main_option_id
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - mapping_url
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - widget_view_mode
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} previous_node_name - previous_node_name
 * @property {string} mapping_product - mapping_product
 * @property {GUID} bot_id - bot_id
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {number} previous_node - previous_node
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - placement
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} ab_test_version - ab_test_version
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotStartOverParams>} LogObject<chatbotStartOverParams>
 */
export function chatbotStartOver(params) {
    return { evid: 1054, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotContactSupport' event (evid: 1056)
 *
 * Event description: The user responds “Yes” to the question “Do you still need to talk to support?”
 *
 * @param {chatbotContactSupportParams} params - The parameters for this event
 * @property {string} node_name - node_name
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} node_id - node_id
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} previous_node_name - previous_node_name
 * @property {GUID} bot_id - bot_id
 * @property {number} previous_node - previous_node
 * @property {string} user_experience - user_experience
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - user_intent
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @return {LogObject<chatbotContactSupportParams>} LogObject<chatbotContactSupportParams>
 */
export function chatbotContactSupport(params) {
    return { evid: 1056, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smsVerificationMessageSent' event (evid: 1080)
 *
 * Event description: The verification message is sent to the phone number entered by the user.
 *
 * @param {smsVerificationMessageSentParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {string} session_id - session_id
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} phone_number_error - phone_number_error
 * @property {string} referral_info - referral_info
 * @property {string} user_experience - user_experience
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @return {LogObject<smsVerificationMessageSentParams>} LogObject<smsVerificationMessageSentParams>
 */
export function smsVerificationMessageSent(params) {
    return { evid: 1080, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smsVerificationCodeSubmitted' event (evid: 1082)
 *
 * Event description: The user successfully submits the code sent to their phone
 *
 * @param {smsVerificationCodeSubmittedParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {string} session_id - session_id
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} referral_info - referral_info
 * @property {string} user_experience - user_experience
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @return {LogObject<smsVerificationCodeSubmittedParams>} LogObject<smsVerificationCodeSubmittedParams>
 */
export function smsVerificationCodeSubmitted(params) {
    return { evid: 1082, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smsVerificationCodeSubmissionError' event (evid: 1083)
 *
 * Event description: The user submits an incorrect code
 *
 * @param {smsVerificationCodeSubmissionErrorParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} referral_info - referral_info
 * @property {string} user_experience - user_experience
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @return {LogObject<smsVerificationCodeSubmissionErrorParams>} LogObject<smsVerificationCodeSubmissionErrorParams>
 */
export function smsVerificationCodeSubmissionError(params) {
    return { evid: 1083, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotClickLink' event (evid: 1088)
 *
 * Event description: The user clicks on a link from the chatbot
 *
 * @param {chatbotClickLinkParams} params - The parameters for this event
 * @property {string} node_id - previous_node_id
 * @property {string} node_name - previous_node_name
 * @property {string} main_option_id - main_option_id
 * @property {string} linkUrl - link_url
 * @property {string} button_type - button_type
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - mapping_url
 * @property {string} widget_view_mode - widget_view_mode
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} referral_info - referral_info
 * @property {string} mapping_product - mapping_product
 * @property {GUID} bot_id - bot_id
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotClickLinkParams>} LogObject<chatbotClickLinkParams>
 */
export function chatbotClickLink(params) {
    return { evid: 1088, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotToggleSwitch' event (evid: 1097)
 *
 * Event description: A switch on the chatbot's setting page (https://www.wix.com/support/conversations/settings?botId=717b0e2d-a564-4ef7-b965-481b1983133b) is toggle on or off
 *
 * @param {chatbotToggleSwitchParams} params - The parameters for this event
 * @property {number} chats_per_agent - chats_per_agent
 * @property {boolean} toggle_state - toggle_state
 * @property {string} toggleName - toggle_name
 * @property {string} wait_time - wait_time
 * @property {string} button_text - button_text
 * @property {GUID} bot_id - bot_id
 * @property {string} announcement_text - announcement_text
 * @property {string} lang - lang
 * @property {number} num_agents - num_agents
 * @property {Url} button_link - button_link
 * @return {LogObject<chatbotToggleSwitchParams>} LogObject<chatbotToggleSwitchParams>
 */
export function chatbotToggleSwitch(params) {
    return { evid: 1097, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'triggerTrialChurnModelFromSupportRequest' event (evid: 1099)
 *
 * Event description: right after chatbot triggers the model it sends a monitor event
 *
 * @param {triggerTrialChurnModelFromSupportRequestParams} params - The parameters for this event
 * @property {string} node_name - node_name
 * @property {string} context - context
 * @property {string} node_id - node_id
 * @property {GUID} bot_id - bot_id
 * @property {string} subscription_id - subscription_id
 * @property {string} interaction_type_name - interaction_type_name
 * @property {string} conversation_id - conversation_id
 * @return {LogObject<triggerTrialChurnModelFromSupportRequestParams>} LogObject<triggerTrialChurnModelFromSupportRequestParams>
 */
export function triggerTrialChurnModelFromSupportRequest(params) {
    return { evid: 1099, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotDisplayWarning' event (evid: 1106)
 *
 * Event description: A Warning message (note) should be displayed to the user if it takes to the chatbot to respond more than 5 seconds (Just a moment..) or 10 seconds (We're still working on it...) since user message.
 *
 * @param {chatbotDisplayWarningParams} params - The parameters for this event
 * @property {number} num_of_messages - num_of_messages
 * @property {string} ticket_id - ticket_id
 * @property {number} time_waited - time_waited
 * @property {string} node_name - node_name
 * @property {string} selected_account - selected_account
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} button_id_list - button_id_list
 * @property {string} node_type_id - node_type_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} node_type - node_type
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - widget_view_mode
 * @property {string} previous_node_name - previous_node_name
 * @property {string} input_type - input_type
 * @property {string} intent_id - intent_id
 * @property {string} mapping_product - mapping_product
 * @property {GUID} bot_id - bot_id
 * @property {string} message_text - message_text
 * @property {string} button_name_list - button_name_list
 * @property {string} context_uuid - context_uuid
 * @property {string} referral - referral
 * @property {GUID} message_id - message_id
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {string} user_intent - user_intent
 * @property {string} user_response_type - user_response_type
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {number} sites_count - sites_count
 * @property {string} parent_url - parent_url
 * @return {LogObject<chatbotDisplayWarningParams>} LogObject<chatbotDisplayWarningParams>
 */
export function chatbotDisplayWarning(params) {
    return { evid: 1106, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotDragWidget' event (evid: 1108)
 *
 * Event description: The event is triggered whenever a user drags the widget
 *
 * @param {chatbotDragWidgetParams} params - The parameters for this event
 * @property {string} node_name - node_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - mapping_url
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - widget_view_mode
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} current_page_name - current_page_name
 * @property {string} old_position - old_position
 * @property {string} mapping_product - mapping_product
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} new_position - new_position
 * @property {string} orig_page_name - orig_page_name
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - placement
 * @property {string} referral - referral
 * @property {string} orig_platform - orig_platform
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - suggestion_id
 * @property {string} widget_state - widget_state
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {GUID} msid - msid
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotDragWidgetParams>} LogObject<chatbotDragWidgetParams>
 */
export function chatbotDragWidget(params) {
    return { evid: 1108, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotLoadTooltip' event (evid: 1115)
 *
 * Event description: The user is shown a tooltip near the chatbot widget
 *
 * @param {chatbotLoadTooltipParams} params - The parameters for this event
 * @property {string} node_name - node_name
 * @property {string} tooltip_name - tooltip_name
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} node_type_id - node_type_id
 * @property {string} context_area - context_area
 * @property {string} mapping_url - mapping_url
 * @property {string} node_type - node_type
 * @property {string} node_id - node_id
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} current_page_name - current_page_name
 * @property {string} referral_info - referral_info
 * @property {string} mapping_product - mapping_product
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - orig_page_name
 * @property {string} tooltip_text - tooltip_text
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - placement
 * @property {string} referral - referral
 * @property {string} orig_platform - orig_platform
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - suggestion_id
 * @property {boolean} is_onetime_tooltip - is_onetime_tooltip
 * @property {string} widget_state - widget_state
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {GUID} msid - msid
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotLoadTooltipParams>} LogObject<chatbotLoadTooltipParams>
 */
export function chatbotLoadTooltip(params) {
    return { evid: 1115, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotClickTooltip' event (evid: 1116)
 *
 * Event description: The chatbot widget is opened after the user clicks on a tooltip
 *
 * @param {chatbotClickTooltipParams} params - The parameters for this event
 * @property {string} tooltip_name - tooltip_name
 * @property {string} session_id - session_id
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} current_page_name - current_page_name
 * @property {string} referral_info - referral_info
 * @property {string} orig_page_name - orig_page_name
 * @property {string} tooltip_text - tooltip_text
 * @property {string} placement - placement
 * @property {string} referral - referral
 * @property {string} orig_platform - orig_platform
 * @property {string} user_experience - user_experience
 * @property {string} suggestion_id - suggestion_id
 * @property {boolean} is_onetime_tooltip - is_onetime_tooltip
 * @property {string} widget_state - widget_state
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {GUID} msid - msid
 * @property {string} chatbot_state - chatbot_state
 * @return {LogObject<chatbotClickTooltipParams>} LogObject<chatbotClickTooltipParams>
 */
export function chatbotClickTooltip(params) {
    return { evid: 1116, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotCloseTooltip' event (evid: 1117)
 *
 * Event description: The user closes a chatbot tooltip
 *
 * @param {chatbotCloseTooltipParams} params - The parameters for this event
 * @property {string} tooltip_name - tooltip_name
 * @property {string} session_id - session_id
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} current_page_name - current_page_name
 * @property {string} referral_info - referral_info
 * @property {string} orig_page_name - orig_page_name
 * @property {string} tooltip_text - tooltip_text
 * @property {string} placement - placement
 * @property {string} referral - referral
 * @property {string} orig_platform - orig_platform
 * @property {string} user_experience - user_experience
 * @property {string} suggestion_id - suggestion_id
 * @property {boolean} is_onetime_tooltip - is_onetime_tooltip
 * @property {string} widget_state - widget_state
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {GUID} msid - msid
 * @property {string} chatbot_state - chatbot_state
 * @return {LogObject<chatbotCloseTooltipParams>} LogObject<chatbotCloseTooltipParams>
 */
export function chatbotCloseTooltip(params) {
    return { evid: 1117, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetHeaderButtonClick' event (evid: 1122)
 *
 * Event description: Fires when the user clicks one of these options in the widget header: resize, dock, minimize, undock.
 *
 * @param {widgetHeaderButtonClickParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {string} button_clicked - button_clicked
 * @property {string} lng - language
 * @property {number} context_page_numLevels - context_page_numlevels
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - previous_presented_state
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - widget_view_mode
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} current_presented_state - current_presented_state
 * @property {string} old_position - old_position
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} new_position - new_position
 * @property {string} orig_page_name - orig_page_name
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - last_conversation_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - placement
 * @property {string} orig_platform - orig_platform
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - suggestion_id
 * @property {string} category_id - category_id
 * @property {string} widget_state - widget_state
 * @property {string} lang - lang
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {string} solution_info - solution_info
 * @return {LogObject<widgetHeaderButtonClickParams>} LogObject<widgetHeaderButtonClickParams>
 */
export function widgetHeaderButtonClick(params) {
    return { evid: 1122, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotTooltipButtonClick' event (evid: 1125)
 *
 * Event description: Fires every time the user clicks on a button in the tooltip
 *
 * @param {chatbotTooltipButtonClickParams} params - The parameters for this event
 * @property {string} node_name - node_name
 * @property {string} tooltip_name - tooltip_name
 * @property {string} lng - language
 * @property {string} button_type - button_type
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {string} node_type_id - node_type_id
 * @property {string} button_type_id - button_type_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - mapping_url
 * @property {string} node_type - node_type
 * @property {string} node_id - node_id
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} current_presented_state - current_presented_state
 * @property {string} current_page_name - current_page_name
 * @property {string} button_name - button_name
 * @property {string} mapping_product - mapping_product
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - orig_page_name
 * @property {string} tooltip_text - tooltip_text
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - placement
 * @property {string} referral - referral
 * @property {string} orig_platform - orig_platform
 * @property {string} button_id - button_id
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - suggestion_id
 * @property {string} lang - lang
 * @property {GUID} msid - msid
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotTooltipButtonClickParams>} LogObject<chatbotTooltipButtonClickParams>
 */
export function chatbotTooltipButtonClick(params) {
    return { evid: 1125, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotStatusBannerStatusBannerShowed' event (evid: 1127)
 *
 * Event description: This event is triggered every time the banner is shown to users (meaning there is an incident / there was one in the past 10 minutes)
 *
 * @param {chatbotStatusBannerStatusBannerShowedParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} incident_state - incident_state
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} incident_name - incident_name
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {string} incident_severity - incident_severity
 * @property {string} parent_url - parent_url
 * @return {LogObject<chatbotStatusBannerStatusBannerShowedParams>} LogObject<chatbotStatusBannerStatusBannerShowedParams>
 */
export function chatbotStatusBannerStatusBannerShowed(params) {
    return { evid: 1127, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotStatusBannerStatusBannerClicked' event (evid: 1128)
 *
 * Event description: This event is triggered every time the banner is clicked on by a user
 *
 * @param {chatbotStatusBannerStatusBannerClickedParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} incident_state - incident_state
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} incident_name - incident_name
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {string} incident_severity - incident_severity
 * @property {string} parent_url - parent_url
 * @return {LogObject<chatbotStatusBannerStatusBannerClickedParams>} LogObject<chatbotStatusBannerStatusBannerClickedParams>
 */
export function chatbotStatusBannerStatusBannerClicked(params) {
    return { evid: 1128, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotStatusBannerStatusBannerDismissed' event (evid: 1129)
 *
 * Event description: This event is triggered every time the banner is dismissed by a user (clicked x)
 *
 * @param {chatbotStatusBannerStatusBannerDismissedParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} incident_state - incident_state
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} incident_name - incident_name
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {string} incident_severity - incident_severity
 * @property {string} parent_url - parent_url
 * @return {LogObject<chatbotStatusBannerStatusBannerDismissedParams>} LogObject<chatbotStatusBannerStatusBannerDismissedParams>
 */
export function chatbotStatusBannerStatusBannerDismissed(params) {
    return { evid: 1129, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantParticipantMessage' event (evid: 1140)
 *
 * Event description: This event fires every time a message from the user/expert triggers a request to the model
 *
 * @param {aiAssistantParticipantMessageParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} participant_type - participant_type
 * @property {string} session_id - session_id
 * @property {string} platform_name - platform_name
 * @property {GUID} operation_id - operation_id
 * @property {GUID} participant_id - participant_id
 * @property {string} content - content
 * @property {string} conversation_id - conversation_id
 * @property {GUID} platform_id - platform_id
 * @return {LogObject<aiAssistantParticipantMessageParams>} LogObject<aiAssistantParticipantMessageParams>
 */
export function aiAssistantParticipantMessage(params) {
    return { evid: 1140, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantAiAgentProcedureStage' event (evid: 1141)
 *
 * Event description: This event fires every time a model triggers a thought and/or an action
 *
 * @param {aiAssistantAiAgentProcedureStageParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} participant_type - participant_type
 * @property {string} content_action_input - content_action_input
 * @property {string} session_id - session_id
 * @property {GUID} procedure_id - procedure_id
 * @property {string} platform_name - platform_name
 * @property {string} content_thought - content_thought
 * @property {string} content_action - content_action
 * @property {string} model_version - model_version
 * @property {GUID} operation_id - operation_id
 * @property {GUID} participant_id - participant_id
 * @property {string} participant_name - participant_name
 * @property {string} conversation_id - conversation_id
 * @property {GUID} platform_id - platform_id
 * @return {LogObject<aiAssistantAiAgentProcedureStageParams>} LogObject<aiAssistantAiAgentProcedureStageParams>
 */
export function aiAssistantAiAgentProcedureStage(params) {
    return { evid: 1141, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantAiAgentResponse' event (evid: 1142)
 *
 * Event description: This event fires every time a response is triggered by a model, by the number of responses
 *
 * @param {aiAssistantAiAgentResponseParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} alternatives - alternatives
 * @property {string} participant_type - participant_type
 * @property {string} session_id - session_id
 * @property {GUID} procedure_id - procedure_id
 * @property {string} platform_name - platform_name
 * @property {string} model_version - model_version
 * @property {GUID} operation_id - operation_id
 * @property {GUID} participant_id - participant_id
 * @property {string} content - content
 * @property {string} participant_name - participant_name
 * @property {string} conversation_id - conversation_id
 * @property {GUID} platform_id - platform_id
 * @property {string} chosen_alternative - chosen_alternative
 * @return {LogObject<aiAssistantAiAgentResponseParams>} LogObject<aiAssistantAiAgentResponseParams>
 */
export function aiAssistantAiAgentResponse(params) {
    return { evid: 1142, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantFinalRequestOutput' event (evid: 1143)
 *
 * Event description: This event fires every time the inquiry comes to a conclusion - either a final response to the user or a fallback that occurred to one of the models or to the inquiry itself
 *
 * @param {aiAssistantFinalRequestOutputParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} alternatives - alternatives
 * @property {string} participant_type - participant_type
 * @property {string} final_output_destination - final_output_destination
 * @property {string} triggered_by_type - triggered_by_type
 * @property {string} session_id - session_id
 * @property {string} platform_name - platform_name
 * @property {string} final_output_reason - final_output_reason
 * @property {string} final_output_type - final_output_type
 * @property {string} model_version - model_version
 * @property {GUID} operation_id - operation_id
 * @property {GUID} participant_id - participant_id
 * @property {string} content - content
 * @property {GUID} response_id - response_id
 * @property {string} triggered_by - triggered_by
 * @property {string} participant_name - participant_name
 * @property {string} conversation_id - conversation_id
 * @property {GUID} platform_id - platform_id
 * @property {string} chosen_alternative - chosen_alternative
 * @return {LogObject<aiAssistantFinalRequestOutputParams>} LogObject<aiAssistantFinalRequestOutputParams>
 */
export function aiAssistantFinalRequestOutput(params) {
    return { evid: 1143, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantParticipantFeedback' event (evid: 1144)
 *
 * Event description: This event fires every time feedback (of each type) is given from the user/expert to a response
 *
 * @param {aiAssistantParticipantFeedbackParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} participant_type - participant_type
 * @property {string} feedback_type - feedback_type
 * @property {string} session_id - session_id
 * @property {number} feedback_answer_level - feedback_answer_level
 * @property {string} platform_name - platform_name
 * @property {string} feedback_question - feedback_question
 * @property {GUID} operation_id - operation_id
 * @property {GUID} participant_id - participant_id
 * @property {string} content - content
 * @property {GUID} response_id - response_id
 * @property {string} feedback_answer_type - feedback_answer_type
 * @property {string} conversation_id - conversation_id
 * @property {GUID} platform_id - platform_id
 * @property {string} chosen_alternative - chosen_alternative
 * @return {LogObject<aiAssistantParticipantFeedbackParams>} LogObject<aiAssistantParticipantFeedbackParams>
 */
export function aiAssistantParticipantFeedback(params) {
    return { evid: 1144, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserWasEligibleForCallback' event (evid: 1150)
 *
 * Event description: New Scheduler Indicates what was the decision on the eligibility of a user for a scheduled callback, in terms of the number of previously scheduled callbacks. If the user has more the 5 scheduled callbacks, the option for a callback is rejected
 *
 * @param {schedulerUserWasEligibleForCallbackParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {string} user_intent - user_intent
 * @property {boolean} eligible_for_callback - eligible_for_callback
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {string} parent_url - parent_url
 * @return {LogObject<schedulerUserWasEligibleForCallbackParams>} LogObject<schedulerUserWasEligibleForCallbackParams>
 */
export function schedulerUserWasEligibleForCallback(params) {
    return { evid: 1150, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserSearchedADifferentMonth' event (evid: 1151)
 *
 * Event description: New Scheduler This event should fire every time the user clicks on one of the left/right arrows that enable searching for different months
 *
 * @param {schedulerUserSearchedADifferentMonthParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {string} parent_url - parent_url
 * @return {LogObject<schedulerUserSearchedADifferentMonthParams>} LogObject<schedulerUserSearchedADifferentMonthParams>
 */
export function schedulerUserSearchedADifferentMonth(params) {
    return { evid: 1151, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserChoosesADay' event (evid: 1152)
 *
 * Event description: New Scheduler This event is triggered every time the user clicks on a day in the calendar
 *
 * @param {schedulerUserChoosesADayParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} info - info
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {string} parent_url - parent_url
 * @return {LogObject<schedulerUserChoosesADayParams>} LogObject<schedulerUserChoosesADayParams>
 */
export function schedulerUserChoosesADay(params) {
    return { evid: 1152, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserClickedOnASlot' event (evid: 1153)
 *
 * Event description: New Scheduler This event is triggered every time the user clicks on a slot
 *
 * @param {schedulerUserClickedOnASlotParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} info - info
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {string} parent_url - parent_url
 * @return {LogObject<schedulerUserClickedOnASlotParams>} LogObject<schedulerUserClickedOnASlotParams>
 */
export function schedulerUserClickedOnASlot(params) {
    return { evid: 1153, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserSubmittedScheduledCallbackRequest' event (evid: 1154)
 *
 * Event description: New Scheduler This event is triggered when a request for scheduling a callback is sent by a user (not only by clicking the button)
 *
 * @param {schedulerUserSubmittedScheduledCallbackRequestParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} parent_url - parent_url
 * @return {LogObject<schedulerUserSubmittedScheduledCallbackRequestParams>} LogObject<schedulerUserSubmittedScheduledCallbackRequestParams>
 */
export function schedulerUserSubmittedScheduledCallbackRequest(params) {
    return { evid: 1154, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerScheduledCallbackSuccess' event (evid: 1155)
 *
 * Event description: New Scheduler This event is triggered when the request for scheduling a callback was approved by the system (callback was scheduled)
 *
 * @param {schedulerScheduledCallbackSuccessParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {GUID} scheduler_request_id - scheduler_request_id
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} parent_url - parent_url
 * @return {LogObject<schedulerScheduledCallbackSuccessParams>} LogObject<schedulerScheduledCallbackSuccessParams>
 */
export function schedulerScheduledCallbackSuccess(params) {
    return { evid: 1155, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserChoseToRescheduleACallback' event (evid: 1156)
 *
 * Event description: New Scheduler This event is triggered when a request for rescheduling a scheduled callback is sent by a user (not only by clicking the button)
 *
 * @param {schedulerUserChoseToRescheduleACallbackParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {GUID} scheduler_request_id - scheduler_request_id
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} parent_url - parent_url
 * @return {LogObject<schedulerUserChoseToRescheduleACallbackParams>} LogObject<schedulerUserChoseToRescheduleACallbackParams>
 */
export function schedulerUserChoseToRescheduleACallback(params) {
    return { evid: 1156, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserChoseToCancelACallback' event (evid: 1157)
 *
 * Event description: New Scheduler This event is triggered when a request for canceling a scheduled callback is sent by a user (not only by clicking the button)
 *
 * @param {schedulerUserChoseToCancelACallbackParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {GUID} scheduler_request_id - scheduler_request_id
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} parent_url - parent_url
 * @return {LogObject<schedulerUserChoseToCancelACallbackParams>} LogObject<schedulerUserChoseToCancelACallbackParams>
 */
export function schedulerUserChoseToCancelACallback(params) {
    return { evid: 1157, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerCancelScheduledCallback' event (evid: 1158)
 *
 * Event description: New Scheduler This event is triggered when the request for canceling the scheduled callback was approved by the system (the scheduled callback was canceled)
 *
 * @param {schedulerCancelScheduledCallbackParams} params - The parameters for this event
 * @property {string} session_id - session_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} mapping_url - mapping_url
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} local_time_zone - local_time_zone
 * @property {string} mapping_product - mapping_product
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} main_option_name - main_option_name
 * @property {GUID} scheduler_request_id - scheduler_request_id
 * @property {string} user_intent - user_intent
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} chatbot_state - chatbot_state
 * @property {DateTime} callback_datetime - callback_datetime
 * @property {string} parent_url - parent_url
 * @return {LogObject<schedulerCancelScheduledCallbackParams>} LogObject<schedulerCancelScheduledCallbackParams>
 */
export function schedulerCancelScheduledCallback(params) {
    return { evid: 1158, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'breadcrumbsScroll' event (evid: 1161)
 *
 * Event description: Fires when the user scrolls the breadcrumbs left/right
 *
 * @param {breadcrumbsScrollParams} params - The parameters for this event
 * @property {string} scroll_direction - scroll_direction
 * @property {string} session_id - session_id
 * @property {boolean} is_chatbot_solution_click - is_chatbot_solution_click
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - previous_presented_state
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} current_presented_state - current_presented_state
 * @property {string} current_page_name - current_page_name
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - orig_page_name
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - last_conversation_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - referral
 * @property {string} orig_platform - orig_platform
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} percent_scrolled - percent_scrolled
 * @property {string} last_user_intent_id - last_user_intent_id
 * @property {GUID} msid - msid
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - last_chatbot_node_name
 * @property {string} context_msid - context_msid
 * @property {string} last_user_intent - last_user_intent
 * @property {string} last_chatbot_node_id - last_chatbot_node_id
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<breadcrumbsScrollParams>} LogObject<breadcrumbsScrollParams>
 */
export function breadcrumbsScroll(params) {
    return { evid: 1161, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetHeaderClick' event (evid: 1164)
 *
 * Event description: Fires when a user clicks an icon in the widget header
 *
 * @param {widgetHeaderClickParams} params - The parameters for this event
 * @property {string} button_clicked - button_clicked
 * @property {string} session_id - session_id
 * @property {boolean} is_chatbot_solution_click - is_chatbot_solution_click
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - previous_presented_state
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} current_presented_state - current_presented_state
 * @property {string} current_page_name - current_page_name
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - orig_page_name
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - last_conversation_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - referral
 * @property {string} orig_platform - orig_platform
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} clicked_value - clicked_value
 * @property {string} last_user_intent_id - last_user_intent_id
 * @property {GUID} msid - msid
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - last_chatbot_node_name
 * @property {string} context_msid - context_msid
 * @property {string} last_user_intent - last_user_intent
 * @property {string} last_chatbot_node_id - last_chatbot_node_id
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<widgetHeaderClickParams>} LogObject<widgetHeaderClickParams>
 */
export function widgetHeaderClick(params) {
    return { evid: 1164, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'channelAvailabilityChatbot' event (evid: 1165)
 *
 * Event description: before offering the user relevant live channels, receive from the API if there are experts not offline, and the queue in business hours
 *
 * @param {channelAvailabilityChatbotParams} params - The parameters for this event
 * @property {string} phone_availability - phone_availability
 * @property {string} chat_reason - chat_reason
 * @property {string} phone_reason - phone_reason
 * @property {GUID} user_id - user_id
 * @property {GUID} topic_id - topic_id
 * @property {string} chat_availability - chat_availability
 * @property {string} lang - lang
 * @property {string} conversation_id - conversation_id
 * @property {string} request_id - request_id of the API
 * @return {LogObject<channelAvailabilityChatbotParams>} LogObject<channelAvailabilityChatbotParams>
 */
export function channelAvailabilityChatbot(params) {
    return { evid: 1165, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'askChooseAProduct' event (evid: 1500)
 *
 * Event description: Choose a product in the first step inside ASK app in the ticket page
 *
 * @param {askChooseAProductParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} ask_url - ask_url
 * @property {string} productName - product_name
 * @property {string} ticket_url - ticket_url
 * @return {LogObject<askChooseAProductParams>} LogObject<askChooseAProductParams>
 */
export function askChooseAProduct(params) {
    return { evid: 1500, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customersPortalClickedOnSiteUrlMainTable' event (evid: 3501)
 *
 * Event description: Sent when a user clicks on a site URL in the main table of the Customer Portal
 *
 * @param {customersPortalClickedOnSiteUrlMainTableParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {Url} url - url
 * @property {GUID} current_site_value - current_site_value
 * @property {GUID} uuid - uuid
 * @return {LogObject<customersPortalClickedOnSiteUrlMainTableParams>} LogObject<customersPortalClickedOnSiteUrlMainTableParams>
 */
export function customersPortalClickedOnSiteUrlMainTable(params) {
    return { evid: 3501, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customersPortalUpdateTicketsSiteModelOpened' event (evid: 3502)
 *
 * Event description: Sent when a user clicks to edit/add a site to a ticket and the modal window is open, in the main table of the Customer Portal
 *
 * @param {customersPortalUpdateTicketsSiteModelOpenedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} current_site_value - current_site_value
 * @property {GUID} uuid - uuid
 * @return {LogObject<customersPortalUpdateTicketsSiteModelOpenedParams>} LogObject<customersPortalUpdateTicketsSiteModelOpenedParams>
 */
export function customersPortalUpdateTicketsSiteModelOpened(params) {
    return { evid: 3502, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customersPortalUpdatedTicketsSiteSaved' event (evid: 3503)
 *
 * Event description: Sent when a user saves a site for a ticket in the main table of the Customer Portal
 *
 * @param {customersPortalUpdatedTicketsSiteSavedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} current_site_value - current_site_value
 * @property {GUID} uuid - uuid
 * @property {GUID} previous_site_value - previous_site_value
 * @property {boolean} site_assigned_successfully - site_assigned_successfully
 * @return {LogObject<customersPortalUpdatedTicketsSiteSavedParams>} LogObject<customersPortalUpdatedTicketsSiteSavedParams>
 */
export function customersPortalUpdatedTicketsSiteSaved(params) {
    return { evid: 3503, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneySearchTask' event (evid: 4032)
 *
 * Event description: When a user clicks on the search button or presses 'enter' on the keyboard to search for a task in the tasks tab, he will get a result or error. This event will reflect the result of the search.
 *
 * @param {userJourneySearchTaskParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} referrer_platform_name - referrer_platform_name
 * @property {string} tab - tab
 * @property {string} search_error - search_error
 * @property {number} num_of_tasks - num_of_tasks
 * @property {GUID} uuid - uuid
 * @property {string} filter_by - filter_by
 * @property {string} view_type - view_type
 * @property {string} search_result_name - search_result_name
 * @property {string} search_value - search_value
 * @property {string} bo_uuid - bo_uuid
 * @property {string} search_result_id - search_result_id
 * @property {boolean} has_result - has_result
 * @property {GUID} userId - user_id
 * @property {GUID} msid - msid
 * @property {GUID} agent_id - agent_id
 * @return {LogObject<userJourneySearchTaskParams>} LogObject<userJourneySearchTaskParams>
 */
export function userJourneySearchTask(params) {
    return { evid: 4032, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiClientPostUserSuggestionEvent' event (evid: 4061)
 *
 * Event description: When a USP client post User Suggestion Event to the User Success Platform through an API
 *
 * @param {uspApiClientPostUserSuggestionEventParams} params - The parameters for this event
 * @property {string} event_type_name - event_type_name
 * @property {GUID} api_client_id - api_client_id
 * @property {GUID} snapshot_id - usp_snapshot_id
 * @property {GUID} meta_site_id - msid
 * @property {GUID} user_id - user_id
 * @property {GUID} suggestion_id - suggestion_id
 * @property {GUID} flow_id - flow_id
 * @return {LogObject<uspApiClientPostUserSuggestionEventParams>} LogObject<uspApiClientPostUserSuggestionEventParams>
 */
export function uspApiClientPostUserSuggestionEvent(params) {
    return { evid: 4061, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiFailedToValidateSomeSuggestionsFromDealerSchema' event (evid: 4071)
 *
 * Event description: When the USP failed to validate some of the suggestions from the Dealer due to required fields' value and skip them
 *
 * @param {uspApiFailedToValidateSomeSuggestionsFromDealerSchemaParams} params - The parameters for this event
 * @property {GUID} api_client_id - api_client_id
 * @property {GUID} meta_site_id - msid
 * @property {GUID} user_id - user_id
 * @property {string} issues - issues
 * @return {LogObject<uspApiFailedToValidateSomeSuggestionsFromDealerSchemaParams>} LogObject<uspApiFailedToValidateSomeSuggestionsFromDealerSchemaParams>
 */
export function uspApiFailedToValidateSomeSuggestionsFromDealerSchema(params) {
    return { evid: 4071, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiClientRequestSuggestions' event (evid: 4072)
 *
 * Event description: When a USP client makes an API request to the User Success Platform to get suggestions
 *
 * @param {uspApiClientRequestSuggestionsParams} params - The parameters for this event
 * @property {string} state_trigger - state_trigger
 * @property {string} request_language - request_language
 * @property {GUID} api_client_id - api_client_id
 * @property {boolean} state_active - state_active
 * @property {GUID} meta_site_id - msid
 * @property {GUID} user_id - user_id
 * @property {string} paging - paging
 * @property {GUID} flow_id - flow_id
 * @return {LogObject<uspApiClientRequestSuggestionsParams>} LogObject<uspApiClientRequestSuggestionsParams>
 */
export function uspApiClientRequestSuggestions(params) {
    return { evid: 4072, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiClientRequestSuggestionsReturnSuccessfully' event (evid: 4073)
 *
 * Event description: When the User Success Platform successfully returns a client's API request for suggestions
 *
 * @param {uspApiClientRequestSuggestionsReturnSuccessfullyParams} params - The parameters for this event
 * @property {string} suggestions_carousel_fields - suggestions_carousel_fields
 * @property {GUID} api_client_id - api_client_id
 * @property {GUID} snapshot_id - usp_snapshot_id
 * @property {GUID} meta_site_id - msid
 * @property {string} suggestions - suggestions
 * @property {GUID} user_id - user_id
 * @property {string} api_client_config - api_client_config
 * @property {GUID} flow_id - flow_id
 * @property {string} reason_for_empty_list - reason_for_empty_list
 * @return {LogObject<uspApiClientRequestSuggestionsReturnSuccessfullyParams>} LogObject<uspApiClientRequestSuggestionsReturnSuccessfullyParams>
 */
export function uspApiClientRequestSuggestionsReturnSuccessfully(params) {
    return { evid: 4073, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiClientRequestSpecificSuggestion' event (evid: 4075)
 *
 * Event description: When a USP client makes an API request to the User Success Platform to get a specific suggestion
 *
 * @param {uspApiClientRequestSpecificSuggestionParams} params - The parameters for this event
 * @property {string} request_language - request_language
 * @property {GUID} api_client_id - api_client_id
 * @property {GUID} meta_site_id - msid
 * @property {GUID} user_id - user_id
 * @property {GUID} suggestion_id - suggestion_id
 * @property {GUID} flow_id - flow_id
 * @return {LogObject<uspApiClientRequestSpecificSuggestionParams>} LogObject<uspApiClientRequestSpecificSuggestionParams>
 */
export function uspApiClientRequestSpecificSuggestion(params) {
    return { evid: 4075, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiClientRequestSpecificSuggestionReturnSuccessfully' event (evid: 4076)
 *
 * Event description: When the User Success Platform successfully returns a client's API request for a specific suggestion
 *
 * @param {uspApiClientRequestSpecificSuggestionReturnSuccessfullyParams} params - The parameters for this event
 * @property {GUID} api_client_id - api_client_id
 * @property {GUID} snapshot_id - usp_snapshot_id
 * @property {GUID} meta_site_id - msid
 * @property {GUID} user_id - user_id
 * @property {string} suggestion_carousel_fields - suggestion_carousel_fields
 * @property {string} suggestion - suggestion
 * @property {GUID} flow_id - flow_id
 * @return {LogObject<uspApiClientRequestSpecificSuggestionReturnSuccessfullyParams>} LogObject<uspApiClientRequestSpecificSuggestionReturnSuccessfullyParams>
 */
export function uspApiClientRequestSpecificSuggestionReturnSuccessfully(params) {
    return { evid: 4076, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'potentialSurveyWebhookTriggered' event (evid: 4201)
 *
 * Event description: Webhook triggered when a call is completed (status = completed), or chat ended or ticket status has changed to "closed" or "solved"
 *
 * Payload to include the Ticket object fields (same as in the tickets webhooks) and the call object.
 *
 * @param {potentialSurveyWebhookTriggeredParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - chat_status
 * @property {string} interaction_type - interaction_type
 * @property {string} call_type - call_type
 * @property {GUID} uuid - uuid
 * @property {number} num_user_batch_messages - num_user_batch_messages
 * @property {number} ticket_last_status - ticket_last_status
 * @property {string} interaction_id - interaction_id
 * @property {string} user_timezone - user_timezone
 * @property {number} call_status - call_status
 * @return {LogObject<potentialSurveyWebhookTriggeredParams>} LogObject<potentialSurveyWebhookTriggeredParams>
 */
export function potentialSurveyWebhookTriggered(params) {
    return { evid: 4201, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'potentialSurvey' event (evid: 4205)
 *
 * Event description: eligible interaction for survey
 *
 * @param {potentialSurveyParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - chat_status
 * @property {string} interaction_type - interaction_type
 * @property {string} occurrence_id - occurrence_id
 * @property {string} call_type - call_type
 * @property {GUID} uuid - uuid
 * @property {number} num_user_batch_messages - num_user_batch_messages
 * @property {number} ticket_last_status - ticket_last_status
 * @property {string} interaction_id - interaction_id
 * @property {GUID} mail_guid - mail_guid
 * @property {string} user_timezone - user_timezone
 * @property {number} call_status - call_status
 * @return {LogObject<potentialSurveyParams>} LogObject<potentialSurveyParams>
 */
export function potentialSurvey(params) {
    return { evid: 4205, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'interactionForwardMarketing' event (evid: 4206)
 *
 * Event description: forward to marketing
 *
 * @param {interactionForwardMarketingParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - chat_status
 * @property {string} interaction_type - interaction_type
 * @property {string} occurrence_id - occurrence_id
 * @property {string} call_type - call_type
 * @property {GUID} uuid - uuid
 * @property {number} num_user_batch_messages - num_user_batch_messages
 * @property {number} ticket_last_status - ticket_last_status
 * @property {string} interaction_id - interaction_id
 * @property {GUID} mail_guid - mail_guid
 * @property {string} user_timezone - user_timezone
 * @property {number} call_status - call_status
 * @return {LogObject<interactionForwardMarketingParams>} LogObject<interactionForwardMarketingParams>
 */
export function interactionForwardMarketing(params) {
    return { evid: 4206, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'surveySkippedOrAnswered' event (evid: 4207)
 *
 * Event description: Fired when a potential survey's ticket from Answers got filtered by the logic. This event reflecting the reason why the ticket was filtered.
 *
 * @param {surveySkippedOrAnsweredParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - chat_status
 * @property {string} interaction_type - interaction_type
 * @property {string} occurrence_id - occurrence_id
 * @property {string} call_type - call_type
 * @property {GUID} uuid - uuid
 * @property {number} num_user_batch_messages - num_user_batch_messages
 * @property {number} ticket_last_status - ticket_last_status
 * @property {string} reason - reason
 * @property {string} interaction_id - interaction_id
 * @property {string} user_timezone - user_timezone
 * @property {number} call_status - call_status
 * @return {LogObject<surveySkippedOrAnsweredParams>} LogObject<surveySkippedOrAnsweredParams>
 */
export function surveySkippedOrAnswered(params) {
    return { evid: 4207, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hidingOfChatbotSurvey' event (evid: 4208)
 *
 * Event description: After 2 hours from the moment the survey is available to the user in the chatbot, it will be hidden (for users who completed at least 1 question in the survey)
 * (Intended for bi complex field usage-recalculating and deleting interaction_id field)
 *
 * @param {hidingOfChatbotSurveyParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} interaction_type - interaction_type
 * @property {string} occurrence_id - occurrence_id
 * @property {GUID} uuid - uuid
 * @property {number} num_user_batch_messages - num_user_batch_messages
 * @property {number} ticket_last_status - ticket_last_status
 * @property {string} interaction_id - interaction_id
 * @property {string} user_timezone - user_timezone
 * @return {LogObject<hidingOfChatbotSurveyParams>} LogObject<hidingOfChatbotSurveyParams>
 */
export function hidingOfChatbotSurvey(params) {
    return { evid: 4208, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyName' event (evid: 5200)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @property {string} abc - abc
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 5200, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ims3DotIssueMenuClicked' event (evid: 7036)
 *
 * Event description: when an agent click the 3dots menu for a tagged issue from the issues window in wix answers
 *
 * @param {ims3DotIssueMenuClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} uuid - uuid
 * @property {string} issue_id - issue_id
 * @property {GUID} agent_id - agent_id
 * @return {LogObject<ims3DotIssueMenuClickedParams>} LogObject<ims3DotIssueMenuClickedParams>
 */
export function ims3DotIssueMenuClicked(params) {
    return { evid: 7036, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'jiraConnected' event (evid: 7303)
 *
 * Event description: Jira connector events
 *
 * @param {jiraConnectedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} agentEmail - agent_email
 * @property {GUID} userGuid - uuid
 * @property {string} jiraTicket - jira_ticket
 * @property {GUID} msid - msid
 * @return {LogObject<jiraConnectedParams>} LogObject<jiraConnectedParams>
 */
export function jiraConnected(params) {
    return { evid: 7303, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'compensationApplied' event (evid: 7304)
 *
 * Event description: Compensation applied from the compensation app, and a note was added in the User Manager backoffice
 *
 * @param {compensationAppliedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} refundCurrency - refund_currency
 * @property {string} agentEmail - agent_email
 * @property {string} extensionReason - extension_reason
 * @property {GUID} userGuid - uuid
 * @property {number} monthsAdded - months_added
 * @property {string} compensationType - compenation_type
 * @property {string} jiraTicket - jira_ticket
 * @property {GUID} msid - msid
 * @property {string} refundAmountString - refund_amount_string
 * @return {LogObject<compensationAppliedParams>} LogObject<compensationAppliedParams>
 */
export function compensationApplied(params) {
    return { evid: 7304, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'supportArticleClicked' event (evid: 7501)
 *
 * Event description: Support Article Clicked.
 *
 * @param {supportArticleClickedParams} params - The parameters for this event
 * @property {string} categoryId - category_id
 * @property {string} relatedCompanyName - related_company_name
 * @property {string} articleUrl - article_url
 * @property {string} clickDateTime - click_date_time
 * @property {string} articleTitle - article_title
 * @return {LogObject<supportArticleClickedParams>} LogObject<supportArticleClickedParams>
 */
export function supportArticleClicked(params) {
    return { evid: 7501, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'extensionClicked' event (evid: 7502)
 *
 * Event description: Event that is fired when the extension is clicked, includes:
 * 1. The location of the extension (dashboard or editor)
 * 2. what component is the current agent is on or the current location in the dashboard.
 * 3. time and date in which the event was fired.
 *
 * @param {extensionClickedParams} params - The parameters for this event
 * @property {string} escalationQueue - escalation_queue
 * @property {string} targetMetaSiteId - target_meta_site_id
 * @property {string} current_location - current_location
 * @property {string} component - component
 * @return {LogObject<extensionClickedParams>} LogObject<extensionClickedParams>
 */
export function extensionClicked(params) {
    return { evid: 7502, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackWidgetTicketCreationAttempt' event (evid: 7701)
 *
 * Event description: Triggers whenever a new ticket is created via the callback request widget
 *
 * @param {callbackWidgetTicketCreationAttemptParams} params - The parameters for this event
 * @property {GUID} source_ticket_id - source_ticket_id
 * @property {boolean} created_from_ticket - created_from_ticket
 * @property {GUID} agent_id - performing_agent_answers_id
 * @return {LogObject<callbackWidgetTicketCreationAttemptParams>} LogObject<callbackWidgetTicketCreationAttemptParams>
 */
export function callbackWidgetTicketCreationAttempt(params) {
    return { evid: 7701, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackWidgetTicketCreationSuccess' event (evid: 7702)
 *
 * Event description: Triggers whenever a new ticket is successfully created via the callback request widget
 *
 * @param {callbackWidgetTicketCreationSuccessParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} user_wix_uuid - user_wix_uuid
 * @property {GUID} queue_id - queue_id
 * @property {GUID} topic_id - topic_id
 * @property {GUID} assigned_group_id - assigned_group_id
 * @property {GUID} source_ticket_id - source_ticket_id
 * @property {boolean} created_from_ticket - created_from_ticket
 * @property {GUID} line_id - line_id
 * @property {GUID} created_ticket_id - created_ticket_id
 * @property {GUID} agent_id - performing_agent_answers_id
 * @return {LogObject<callbackWidgetTicketCreationSuccessParams>} LogObject<callbackWidgetTicketCreationSuccessParams>
 */
export function callbackWidgetTicketCreationSuccess(params) {
    return { evid: 7702, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackWidgetTicketCreationFailure' event (evid: 7703)
 *
 * Event description: Triggers whenever a new ticket fails to be created via the callback request widget
 *
 * @param {callbackWidgetTicketCreationFailureParams} params - The parameters for this event
 * @property {string} failure_reason - failure_reason
 * @property {GUID} user_wix_uuid - user_wix_uuid
 * @property {GUID} queue_id - queue_id
 * @property {GUID} assigned_group_id - assigned_group_id
 * @property {GUID} source_ticket_id - source_ticket_id
 * @property {boolean} created_from_ticket - created_from_ticket
 * @property {GUID} line_id - line_id
 * @property {GUID} created_ticket_id - created_ticket_id
 * @property {GUID} agent_id - performing_agent_answers_id
 * @return {LogObject<callbackWidgetTicketCreationFailureParams>} LogObject<callbackWidgetTicketCreationFailureParams>
 */
export function callbackWidgetTicketCreationFailure(params) {
    return { evid: 7703, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackWidgetOpenWidget' event (evid: 7704)
 *
 * Event description: Callback Widget - Open Widget.
 *
 * @param {callbackWidgetOpenWidgetParams} params - The parameters for this event
 * @property {boolean} opened_from_ticket - opened_from_ticket
 * @property {string} opened_from_ticket_language - opened_from_ticket_language
 * @property {GUID} performing_angent_answers_id - performing_angent_answers_id
 * @property {GUID} opened_from_ticket_id - opened_from_ticket_id
 * @return {LogObject<callbackWidgetOpenWidgetParams>} LogObject<callbackWidgetOpenWidgetParams>
 */
export function callbackWidgetOpenWidget(params) {
    return { evid: 7704, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'escalationFeedbackSubmitted' event (evid: 7900)
 *
 * Event description: Escalation feedback submitted from tool
 *
 * @param {escalationFeedbackSubmittedParams} params - The parameters for this event
 * @property {boolean} handledByQA - handled_by_qa
 * @property {boolean} knowledgeGap - knowledge_gap
 * @property {string} agentEmail - agent_email
 * @property {string} feedbackType - feedback_type
 * @property {GUID} noteId - internal_note_id
 * @property {string} ticketId - ticket_id
 * @property {boolean} cannotRecreate - cannot_recreate
 * @property {boolean} wrongGroup - wrong_group
 * @property {boolean} incompleteNote - incomplete_note
 * @property {boolean} isNecessary - is_necessary
 * @property {boolean} courtesyEsc - courtesy_esc
 * @property {boolean} lacksPermissionsOrTools - lacks_permissions_or_tools
 * @property {boolean} assignedByMistake - assigned_by_mistake
 * @property {string} groupName - group_name
 * @property {string} comment - comment
 * @property {string} reportingAgentEmail - reporting_agent_email
 * @property {boolean} lackOfTs - lack_of_ts
 * @return {LogObject<escalationFeedbackSubmittedParams>} LogObject<escalationFeedbackSubmittedParams>
 */
export function escalationFeedbackSubmitted(params) {
    return { evid: 7900, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'apiSchedulerCreateCallbackRequest' event (evid: 8001)
 *
 * Event description: create callback request
 *
 * @param {apiSchedulerCreateCallbackRequestParams} params - The parameters for this event
 * @property {GUID} requestid - requestid
 * @property {string} lang - lang
 * @property {DateTime} callback_datetime - callback_datetime
 * @return {LogObject<apiSchedulerCreateCallbackRequestParams>} LogObject<apiSchedulerCreateCallbackRequestParams>
 */
export function apiSchedulerCreateCallbackRequest(params) {
    return { evid: 8001, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'apiSchedulerCancelCallbackRequest' event (evid: 8002)
 *
 * Event description: cancel callback request
 *
 * @param {apiSchedulerCancelCallbackRequestParams} params - The parameters for this event
 * @property {GUID} requestid - requestid
 * @property {string} lang - lang
 * @property {DateTime} callback_datetime - callback_datetime
 * @return {LogObject<apiSchedulerCancelCallbackRequestParams>} LogObject<apiSchedulerCancelCallbackRequestParams>
 */
export function apiSchedulerCancelCallbackRequest(params) {
    return { evid: 8002, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'apiSchedulerModifyCallbackRequest' event (evid: 8003)
 *
 * Event description: modify callback request
 *
 * @param {apiSchedulerModifyCallbackRequestParams} params - The parameters for this event
 * @property {GUID} requestid - requestid
 * @property {string} lang - lang
 * @property {DateTime} callback_datetime - callback_datetime
 * @return {LogObject<apiSchedulerModifyCallbackRequestParams>} LogObject<apiSchedulerModifyCallbackRequestParams>
 */
export function apiSchedulerModifyCallbackRequest(params) {
    return { evid: 8003, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'apiSchedulerCreateRequestToAnswers' event (evid: 8004)
 *
 * Event description: create callback request
 *
 * @param {apiSchedulerCreateRequestToAnswersParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} userid - uuid
 * @property {GUID} interaction_id - interaction_id
 * @property {GUID} requestid - requestid
 * @property {string} lang - lang
 * @property {DateTime} callback_datetime - callback_datetime
 * @return {LogObject<apiSchedulerCreateRequestToAnswersParams>} LogObject<apiSchedulerCreateRequestToAnswersParams>
 */
export function apiSchedulerCreateRequestToAnswers(params) {
    return { evid: 8004, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpCenterPageClick' event (evid: 8201)
 *
 * Event description: Fired when a user clicks a link/button in an article/home/category page
 *
 * @param {helpCenterPageClickParams} params - The parameters for this event
 * @property {number} clicked_category_order - clicked_category_order
 * @property {string} clicked_text - clicked_text
 * @property {string} item_id - item_id
 * @property {string} tab - tab
 * @property {string} params - params
 * @property {string} filter_by - filter_by
 * @property {string} clicked_item_order - clicked_item_order
 * @property {string} clicked_item_type - clicked_item_type
 * @property {string} clicked_item_id - clicked_item_id
 * @property {boolean} is_page_content_click - is_page_content_click
 * @property {string} source_name - source_name
 * @property {string} sort_by - sort_by
 * @property {string} kb_lang - kb_lang
 * @property {number} category_order - category_order
 * @property {string} item_type - item_type
 * @property {string} kb_version - kb_version
 * @property {string} clicked_url - clicked_url
 * @return {LogObject<helpCenterPageClickParams>} LogObject<helpCenterPageClickParams>
 */
export function helpCenterPageClick(params) {
    return { evid: 8201, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pageError' event (evid: 8203)
 *
 * Event description: fired when an error is shown after a user clicked a link in one of the pages
 *
 * @param {pageErrorParams} params - The parameters for this event
 * @property {string} clicked_text - clicked_text
 * @property {string} item_id - item_id
 * @property {string} referral_url - referral_url
 * @property {string} error_origin - error_origin
 * @property {string} clicked_item_order - clicked_item_order
 * @property {string} source_name - source_name
 * @property {string} error_type_id - error_type_id
 * @property {string} kb_lang - kb_lang
 * @property {string} kb_version - kb_version
 * @property {string} error_type_description - error_type_description
 * @property {string} clicked_url - clicked_url
 * @return {LogObject<pageErrorParams>} LogObject<pageErrorParams>
 */
export function pageError(params) {
    return { evid: 8203, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sortAndFilter' event (evid: 8403)
 *
 * Event description: Fired when a user sorts/filters page view
 *
 * @param {sortAndFilterParams} params - The parameters for this event
 * @property {string} item_id - item_id
 * @property {string} tab - tab
 * @property {number} items_left - items_left
 * @property {string} filter_by - filter_by
 * @property {string} search_term_filter - search_term_filter
 * @property {string} source_name - source_name
 * @property {string} sort_by - sort_by
 * @property {string} kb_lang - kb_lang
 * @return {LogObject<sortAndFilterParams>} LogObject<sortAndFilterParams>
 */
export function sortAndFilter(params) {
    return { evid: 8403, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitWasItHelpfulForm' event (evid: 8404)
 *
 * Event description: fires when a user clicks submit on the feedback form
 *
 * @param {submitWasItHelpfulFormParams} params - The parameters for this event
 * @property {string} clicked_text - clicked_text
 * @property {GUID} item_id - item_id
 * @property {boolean} thumbs_up - thumbs_up
 * @property {string} feedback_details - feedback_details
 * @property {number} clicked_item_index - clicked_item_index
 * @property {string} presented_content - presented_content
 * @property {string} clicked_item_order - clicked_item_order
 * @property {string} source_name - source_name
 * @property {string} kb_lang - kb_lang
 * @property {string} free_text - free_text
 * @return {LogObject<submitWasItHelpfulFormParams>} LogObject<submitWasItHelpfulFormParams>
 */
export function submitWasItHelpfulForm(params) {
    return { evid: 8404, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpCenterBannerClick' event (evid: 8405)
 *
 * Event description: Fired when a user clicks a banner in the Help Center
 *
 * @param {helpCenterBannerClickParams} params - The parameters for this event
 * @property {string} clicked_text - clicked_text
 * @property {string} banner_text - action_text
 * @property {string} item_id - item_id
 * @property {string} banner_type - banner_type
 * @property {string} banner_name - banner_name
 * @property {string} clicked_item_type - clicked_item_type
 * @property {string} source_name - source_name
 * @property {boolean} is_resolved - is_resolved
 * @property {string} kb_lang - kb_lang
 * @property {string} item_type - item_type
 * @property {string} banner_language - banner_language
 * @property {string} clicked_url - clicked_url
 * @return {LogObject<helpCenterBannerClickParams>} LogObject<helpCenterBannerClickParams>
 */
export function helpCenterBannerClick(params) {
    return { evid: 8405, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpCenterBannerView' event (evid: 8406)
 *
 * Event description: Fired when the user enters a page in the KB that has a banner
 *
 * @param {helpCenterBannerViewParams} params - The parameters for this event
 * @property {string} banner_text - action_text
 * @property {string} item_id - item_id
 * @property {string} banner_type - banner_type
 * @property {string} banner_name - banner_name
 * @property {boolean} has_cta - has_cta
 * @property {string} source_name - source_name
 * @property {boolean} is_resolved - is_resolved
 * @property {string} kb_lang - kb_lang
 * @property {string} item_type - item_type
 * @property {string} banner_language - banner_language
 * @return {LogObject<helpCenterBannerViewParams>} LogObject<helpCenterBannerViewParams>
 */
export function helpCenterBannerView(params) {
    return { evid: 8406, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpCenterItemOnPageView' event (evid: 8407)
 *
 * Event description: fired when a certain item is visible on a KB page
 *
 * @param {helpCenterItemOnPageViewParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {string} item_version - item_version
 * @property {string} feedback_details - feedback_details
 * @property {string} item_name - item_name
 * @property {string} source_name - source_name
 * @property {string} kb_lang - kb_lang
 * @return {LogObject<helpCenterItemOnPageViewParams>} LogObject<helpCenterItemOnPageViewParams>
 */
export function helpCenterItemOnPageView(params) {
    return { evid: 8407, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'roadmapWishlistFormClick' event (evid: 8411)
 *
 * Event description: fires when a user clicks one of the buttons in the roadmap wishlist form
 *
 * @param {roadmapWishlistFormClickParams} params - The parameters for this event
 * @property {string} form_step - form_step
 * @property {string} chosen_alternative_resolution - chosen_alternative_resolution
 * @property {string} clicked_item_type - clicked_item_type
 * @property {string} source_name - source_name
 * @property {string} origin - origin
 * @property {string} feature_description - feature_description
 * @property {string} origin_url - origin_url
 * @property {string} feature_impact - feature_impact
 * @property {string} kb_lang - kb_lang
 * @property {string} product - product
 * @property {GUID} chosen_alternative_id - chosen_alternative_id
 * @property {number} output_distance - The score the alternative feature requests that was suggested got from the model
 * @property {string} output_distance_str - The score the alternative feature requests that was suggested got from the model
 * @return {LogObject<roadmapWishlistFormClickParams>} LogObject<roadmapWishlistFormClickParams>
 */
export function roadmapWishlistFormClick(params) {
    return { evid: 8411, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpCenterModals' event (evid: 8414)
 *
 * Event description: Fire when a user interacts with a modal in the Help Center
 *
 * @param {helpCenterModalsParams} params - The parameters for this event
 * @property {string} item_id - item_id
 * @property {string} screen_name - screen_name
 * @property {string} clicked_button_name - clicked_button_name
 * @property {string} modal_name - modal_name
 * @property {string} source_name - source_name
 * @property {string} kb_lang - kb_lang
 * @property {string} action_type - action_type
 * @return {LogObject<helpCenterModalsParams>} LogObject<helpCenterModalsParams>
 */
export function helpCenterModals(params) {
    return { evid: 8414, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ccOpenAiOutputReceived' event (evid: 8700)
 *
 * Event description: This event triggered after getting prompt result from 'Open AI'
 *
 * @param {ccOpenAiOutputReceivedParams} params - The parameters for this event
 * @property {number} token_output - token_output
 * @property {number} max_tokens - max_tokens
 * @property {number} top_p - top_p
 * @property {number} token_prompt - token_prompt
 * @property {number} prompt_length - prompt_length
 * @property {number} temperature - temperature
 * @property {string} feature_name - feature_name
 * @property {GUID} prompt_id - prompt_id
 * @property {string} model_type - model_type
 * @property {GUID} request_id - request_id
 * @property {string} model_name - model_name
 * @return {LogObject<ccOpenAiOutputReceivedParams>} LogObject<ccOpenAiOutputReceivedParams>
 */
export function ccOpenAiOutputReceived(params) {
    return { evid: 8700, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspSuggestionServiceFailedToMapRankingDataOnDataRetrievedFromSuccessParamsService' event (evid: 7700000)
 *
 * Event description: Error flow, when we failed to find success param from Success Params Service for data which we are passing as value to Rankings combinations.
 *
 * @param {uspSuggestionServiceFailedToMapRankingDataOnDataRetrievedFromSuccessParamsServiceParams} params - The parameters for this event
 * @property {string} issues - issues
 * @return {LogObject<uspSuggestionServiceFailedToMapRankingDataOnDataRetrievedFromSuccessParamsServiceParams>} LogObject<uspSuggestionServiceFailedToMapRankingDataOnDataRetrievedFromSuccessParamsServiceParams>
 */
export function uspSuggestionServiceFailedToMapRankingDataOnDataRetrievedFromSuccessParamsService(params) {
    return { evid: 7700000, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userCarePriorityDataApiRequestFailed' event (evid: 7700103)
 *
 * Event description: Fire when Customer Care squad 5 failed to return a client's API request for user's care priority data
 *
 * @param {userCarePriorityDataApiRequestFailedParams} params - The parameters for this event
 * @property {GUID} user_id - user_id
 * @property {string} failed_reason - failed_reason
 * @return {LogObject<userCarePriorityDataApiRequestFailedParams>} LogObject<userCarePriorityDataApiRequestFailedParams>
 */
export function userCarePriorityDataApiRequestFailed(params) {
    return { evid: 7700103, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openAiExpertAssistant' event (evid: 7700300)
 *
 * Event description: When the expert open the tab of the Ai assistant we want that action will be saved.
 *
 * @param {openAiExpertAssistantParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} user_id - uuid
 * @property {string} version - version
 * @return {LogObject<openAiExpertAssistantParams>} LogObject<openAiExpertAssistantParams>
 */
export function openAiExpertAssistant(params) {
    return { evid: 7700300, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersFromTheAiExpertAssistant' event (evid: 7700301)
 *
 * Event description: AI assistant answers expert's question.
 *
 * @param {answersFromTheAiExpertAssistantParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} expert_question - expert_question
 * @property {number} order_number - order_number
 * @property {GUID} user_id - uuid
 * @property {string} answer_of_ai - answer_of_ai
 * @property {string} version - version
 * @property {string} error_type - error_type
 * @property {GUID} request_id - request_id
 * @property {GUID} response_id - response_id
 * @property {string} sources - sources
 * @property {DateTime} request_time - request_time
 * @return {LogObject<answersFromTheAiExpertAssistantParams>} LogObject<answersFromTheAiExpertAssistantParams>
 */
export function answersFromTheAiExpertAssistant(params) {
    return { evid: 7700301, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTheAiAssistantFeedback' event (evid: 7700302)
 *
 * Event description: The feedback of the user that the Ai response to the expert
 *
 * @param {clickOnTheAiAssistantFeedbackParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {number} order_number - order_number
 * @property {string} feedback_details - feedback_details
 * @property {boolean} feedback_choice - feedback_choice
 * @property {GUID} user_id - uuid
 * @property {string} bubble_name - bubble_name
 * @property {string} answer_of_ai - answer_of_ai
 * @property {string} version - version
 * @property {string} feedback_text - feedback_text
 * @property {GUID} request_id - request_id
 * @property {GUID} response_id - response_id
 * @return {LogObject<clickOnTheAiAssistantFeedbackParams>} LogObject<clickOnTheAiAssistantFeedbackParams>
 */
export function clickOnTheAiAssistantFeedback(params) {
    return { evid: 7700302, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCopyAiExpertAssistantAnswer' event (evid: 7700303)
 *
 * Event description: Click to copy AI expert assistant answer
 *
 * @param {clickToCopyAiExpertAssistantAnswerParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} source - source
 * @property {number} order_number - order_number
 * @property {GUID} user_id - uuid
 * @property {string} answer_of_ai - answer_of_ai
 * @property {string} version - version
 * @property {GUID} request_id - request_id
 * @property {GUID} response_id - response_id
 * @return {LogObject<clickToCopyAiExpertAssistantAnswerParams>} LogObject<clickToCopyAiExpertAssistantAnswerParams>
 */
export function clickToCopyAiExpertAssistantAnswer(params) {
    return { evid: 7700303, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbArticlesBo' event (evid: 7700313)
 *
 * Event description: Fire when an action is performed in the KB article BO in Answers
 *
 * @param {kbArticlesBoParams} params - The parameters for this event
 * @property {GUID} article_id - The article for which the action was performed
 * @property {string} action - The action which was performed
 * @property {string} section_name - The section in the BO on which the action was performed
 * @property {string} params - The input parameters that were passed with the action
 * @property {GUID} user_answers_id - The Answers ID of the user that triggered the action
 * @return {LogObject<kbArticlesBoParams>} LogObject<kbArticlesBoParams>
 */
export function kbArticlesBo(params) {
    return { evid: 7700313, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiExpertAssistantOpenArticlesFromAi' event (evid: 7700318)
 *
 * Event description: This event send when you click on the article link from the answer of the AI
 *
 * @param {aiExpertAssistantOpenArticlesFromAiParams} params - The parameters for this event
 * @property {GUID} user_id - who is the expert that opened the Ai assistant
 * @property {string} article_id - the article_id
 * @property {GUID} ticket_id - The ticket Id where the ai got used
 * @property {GUID} request_id - the Id of the question
 * @property {GUID} response_id - the Id of the answer
 * @property {GUID} tenant_id - the article tenant_id
 * @property {DateTime} date_creted - the datetime of the click on the article
 * @property {number} order_number	 - the order of the article from the answer
 * @return {LogObject<aiExpertAssistantOpenArticlesFromAiParams>} LogObject<aiExpertAssistantOpenArticlesFromAiParams>
 */
export function aiExpertAssistantOpenArticlesFromAi(params) {
    return { evid: 7700318, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'careProfileServicesApiRequestFailed' event (evid: 7700503)
 *
 * Event description: Fire when the Care Profile Services of Customer Care failed to return a client's API request
 *
 * @param {careProfileServicesApiRequestFailedParams} params - The parameters for this event
 * @property {GUID} entity_id - entity_id
 * @property {string} failed_reason - failed_reason
 * @return {LogObject<careProfileServicesApiRequestFailedParams>} LogObject<careProfileServicesApiRequestFailedParams>
 */
export function careProfileServicesApiRequestFailed(params) {
    return { evid: 7700503, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hcSearchDropdownSourceSectionOnView' event (evid: 7700504)
 *
 * Event description: Fire every time a source section is visible for the user in the Help Center search dropdown
 *
 * @param {hcSearchDropdownSourceSectionOnViewParams} params - The parameters for this event
 * @property {string} source_name - name of the page the dropdown was opened on {article,roadmap,homepage}
 * @property {string} kb_lang - kb page language
 * @property {string} source_section_name - the name of the source section the user was exposed to
 * @property {string} search_session_id - Unique search session identifier
 * @return {LogObject<hcSearchDropdownSourceSectionOnViewParams>} LogObject<hcSearchDropdownSourceSectionOnViewParams>
 */
export function hcSearchDropdownSourceSectionOnView(params) {
    return { evid: 7700504, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userSubmittedASurvey' event (evid: 2)
 *
 * Event description: user submitted a survey.
 *
 * @param {userSubmittedASurveyParams} params - The parameters for this event
 * @property {DateTime} submitted - submitted
 * @property {string} rep_needs - rep_needs
 * @property {DateTime} contacted - date_contacted
 * @property {GUID} uuid - uuid
 * @property {string} rep_curt - rep_curt
 * @property {string} agent_name - agent_name
 * @property {string} country - country_code
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {string} rep_prompt - rep_prompt
 * @property {string} comment - comment
 * @property {number} clid - clid
 * @property {string} rep_help - rep_help
 * @property {string} province - region
 * @property {string} serv_sat - serv_sat
 * @property {string} rep_know - rep_know
 * @property {string} rep_effic - rep_effic
 * @property {string} wix_sat - wix_sat
 * @property {number} call_id - call_id
 * @return {LogObject<userSubmittedASurveyParams>} LogObject<userSubmittedASurveyParams>
 */
export function userSubmittedASurvey(params) {
    return { evid: 2, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'inboundCallLanguageSelected' event (evid: 4)
 *
 * Event description: The caller selected a language in the IVR
 *
 * @param {inboundCallLanguageSelectedParams} params - The parameters for this event
 * @property {string} customer_id - customer_id
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - clid
 * @property {string} lang - lang
 * @return {LogObject<inboundCallLanguageSelectedParams>} LogObject<inboundCallLanguageSelectedParams>
 */
export function inboundCallLanguageSelected(params) {
    return { evid: 4, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'inboundCallQueueSelected' event (evid: 5)
 *
 * Event description: The caller selected a specific issue/queue in the IVR
 *
 * @param {inboundCallQueueSelectedParams} params - The parameters for this event
 * @property {string} customer_id - customer_id
 * @property {string} queue - queue
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - clid
 * @property {string} lang - lang
 * @return {LogObject<inboundCallQueueSelectedParams>} LogObject<inboundCallQueueSelectedParams>
 */
export function inboundCallQueueSelected(params) {
    return { evid: 5, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scheduledCallUserContacted' event (evid: 6)
 *
 * Event description: User receives a callback
 *
 * @param {scheduledCallUserContactedParams} params - The parameters for this event
 * @property {string} customer_id - customer_id
 * @property {string} queue - queue
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - clid
 * @property {string} lang - lang
 * @return {LogObject<scheduledCallUserContactedParams>} LogObject<scheduledCallUserContactedParams>
 */
export function scheduledCallUserContacted(params) {
    return { evid: 6, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterLinesLogClosedManually' event (evid: 7)
 *
 * Event description: This event is fired when the Call Center lines are being toggled off during regular operation hours (due to high volume, system issues, holidays, etc.)
 *
 * @param {callCenterLinesLogClosedManuallyParams} params - The parameters for this event
 * @property {boolean} is_inbound - is_inbound
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {string} id - id
 * @property {string} lang - lang
 * @property {boolean} is_scheduler - is_scheduler
 * @property {string} closing_reason - closing_reason
 * @return {LogObject<callCenterLinesLogClosedManuallyParams>} LogObject<callCenterLinesLogClosedManuallyParams>
 */
export function callCenterLinesLogClosedManually(params) {
    return { evid: 7, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterLinesLogOpenedManually' event (evid: 8)
 *
 * Event description: This event is fired when the Call Center lines are being toggled on after being toggled off during regular operation hours (due to high volume, system issues, holidays, etc.)
 *
 * @param {callCenterLinesLogOpenedManuallyParams} params - The parameters for this event
 * @property {number} closing_duration - closing_duration
 * @property {boolean} is_inbound - is_inbound
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {string} id - id
 * @property {string} lang - lang
 * @property {boolean} is_scheduler - is_scheduler
 * @property {string} closing_reason - closing_reason
 * @return {LogObject<callCenterLinesLogOpenedManuallyParams>} LogObject<callCenterLinesLogOpenedManuallyParams>
 */
export function callCenterLinesLogOpenedManually(params) {
    return { evid: 8, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackMainFormOpened' event (evid: 101)
 *
 * Event description: callback -> main form opened.
 *
 * @param {callbackMainFormOpenedParams} params - The parameters for this event
 * @return {LogObject<callbackMainFormOpenedParams>} LogObject<callbackMainFormOpenedParams>
 */
export function callbackMainFormOpened(params) {
    return { evid: 101, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackLoginFormSkip' event (evid: 103)
 *
 * Event description: callback login form -> skip.
 *
 * @param {callbackLoginFormSkipParams} params - The parameters for this event
 * @return {LogObject<callbackLoginFormSkipParams>} LogObject<callbackLoginFormSkipParams>
 */
export function callbackLoginFormSkip(params) {
    return { evid: 103, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackByPhoneSubmit' event (evid: 113)
 *
 * Event description: callback by phone -> submit.
 *
 * @param {callbackByPhoneSubmitParams} params - The parameters for this event
 * @property {string} desc - dsc
 * @property {string} 'sub-cat' - subcat
 * @property {string} date - date
 * @property {string} timeslot - timeslot
 * @property {string} title - title
 * @property {string} cat - category
 * @property {boolean} has_attach - has_attach
 * @return {LogObject<callbackByPhoneSubmitParams>} LogObject<callbackByPhoneSubmitParams>
 */
export function callbackByPhoneSubmit(params) {
    return { evid: 113, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersTroubleshooterLinkSent' event (evid: 500)
 *
 * Event description: Indication we sent the link to the mobile app to the user who called our call center
 *
 * @param {answersTroubleshooterLinkSentParams} params - The parameters for this event
 * @property {boolean} lines_closed - lines_closed
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - clid
 * @return {LogObject<answersTroubleshooterLinkSentParams>} LogObject<answersTroubleshooterLinkSentParams>
 */
export function answersTroubleshooterLinkSent(params) {
    return { evid: 500, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickCallMe' event (evid: 501)
 *
 * Event description: user clicked on the link of the mobile app we sent him
 *
 * @param {clickCallMeParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - clid
 * @return {LogObject<clickCallMeParams>} LogObject<clickCallMeParams>
 */
export function clickCallMe(params) {
    return { evid: 501, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickCallMeResponse' event (evid: 502)
 *
 * Event description: user clicked an item in the mobile app we sent him
 *
 * @param {clickCallMeResponseParams} params - The parameters for this event
 * @property {string} item_id - item_id
 * @property {number} item_order - item_order
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {string} parent_item_id - parent_item_id
 * @property {string} item_name - item_name
 * @property {number} clid - clid
 * @property {string} parent_item_name - parent_item_name
 * @return {LogObject<clickCallMeResponseParams>} LogObject<clickCallMeResponseParams>
 */
export function clickCallMeResponse(params) {
    return { evid: 502, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'xClickReadMore' event (evid: 503)
 *
 * Event description: user clicked the read more link in an article item mobile app we sent him
 *
 * @param {xClickReadMoreParams} params - The parameters for this event
 * @property {number} item_order - item_order
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @return {LogObject<xClickReadMoreParams>} LogObject<xClickReadMoreParams>
 */
export function xClickReadMore(params) {
    return { evid: 503, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'listenToLiveCall' event (evid: 600)
 *
 * Event description: live call is being listened to by a user in wcc
 *
 * @param {listenToLiveCallParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @return {LogObject<listenToLiveCallParams>} LogObject<listenToLiveCallParams>
 */
export function listenToLiveCall(params) {
    return { evid: 600, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'listenToRecordedCall' event (evid: 601)
 *
 * Event description: recorded call is being listened to by a user in wcc
 *
 * @param {listenToRecordedCallParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @return {LogObject<listenToRecordedCallParams>} LogObject<listenToRecordedCallParams>
 */
export function listenToRecordedCall(params) {
    return { evid: 601, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sentimentalPoc' event (evid: 801)
 *
 * Event description: sentimental-poc.
 *
 * @param {sentimentalPocParams} params - The parameters for this event
 * @property {string} answers_call_id - answers_call_id
 * @property {string} sentiment_result - sentiment_result
 * @property {string} sentiment_score - sentiment_score
 * @return {LogObject<sentimentalPocParams>} LogObject<sentimentalPocParams>
 */
export function sentimentalPoc(params) {
    return { evid: 801, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sentimentalProjectResults' event (evid: 1000)
 *
 * Event description: Transcription and Sentiment analysis of support calls
 *
 * @param {sentimentalProjectResultsParams} params - The parameters for this event
 * @property {string} phase_configuration_display_name - phase_configuration_display_name
 * @property {string} job_id - job_id
 * @property {string} interaction_id - interaction_id
 * @property {string} sentiment_result - sentiment_result
 * @return {LogObject<sentimentalProjectResultsParams>} LogObject<sentimentalProjectResultsParams>
 */
export function sentimentalProjectResults(params) {
    return { evid: 1000, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sentimentalJobsTracker' event (evid: 1001)
 *
 * Event description: Transcription and Sentiment analysis of support calls
 *
 * @param {sentimentalJobsTrackerParams} params - The parameters for this event
 * @property {string} phase_configuration_display_name - phase_configuration_display_name
 * @property {string} job_id - job_id
 * @property {string} interaction_id - interaction_id
 * @property {string} job_status - job_status
 * @return {LogObject<sentimentalJobsTrackerParams>} LogObject<sentimentalJobsTrackerParams>
 */
export function sentimentalJobsTracker(params) {
    return { evid: 1001, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'omniChannelAndChannelDashboardsHoverTooltip' event (evid: 1)
 *
 * Event description: hover over tooltips in omni channel, chat dashboard and call center dashboard
 *
 * @param {omniChannelAndChannelDashboardsHoverTooltipParams} params - The parameters for this event
 * @property {string} locale - on which language was the action performed?
 * @property {GUID} group_id - on which group was the action performed?
 * @property {GUID} user_id - who performed the action?
 * @property {GUID} channel_id - on which channel was the action performed?
 * @property {string} dashboard - from which dashboard was the action performed? (omni channel, chat dashboard, call center dashboard)
 * @property {string} tooltip_name - on which tooltip was the action performed?
 * @return {LogObject<omniChannelAndChannelDashboardsHoverTooltipParams>} LogObject<omniChannelAndChannelDashboardsHoverTooltipParams>
 */
export function omniChannelAndChannelDashboardsHoverTooltip(params) {
    return { evid: 1, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnCancelEditAvailabilityModal' event (evid: 2)
 *
 * Event description: Users enter the availability modal but don't make any changes, and click Cancel
 *
 * @param {clickOnCancelEditAvailabilityModalParams} params - The parameters for this event
 * @property {GUID} group_id - on which group was the action performed?
 * @property {GUID} user_id - who performed the action?
 * @return {LogObject<clickOnCancelEditAvailabilityModalParams>} LogObject<clickOnCancelEditAvailabilityModalParams>
 */
export function clickOnCancelEditAvailabilityModal(params) {
    return { evid: 2, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnGoBackInTheEditAvailabilityModalAlert' event (evid: 3)
 *
 * Event description: The user made some changes in the channel availability modal and received an alert before saving, he should choose between "change availability" and go back,
 * and choose "go back" without making any changes
 *
 * @param {clickOnGoBackInTheEditAvailabilityModalAlertParams} params - The parameters for this event
 * @property {GUID} group_id - on which group was the action performed?
 * @property {GUID} user_id - who performed the action?
 * @property {string} change - changes that the user wanted to make
 * @return {LogObject<clickOnGoBackInTheEditAvailabilityModalAlertParams>} LogObject<clickOnGoBackInTheEditAvailabilityModalAlertParams>
 */
export function clickOnGoBackInTheEditAvailabilityModalAlert(params) {
    return { evid: 3, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnStatusPageBanner' event (evid: 44)
 *
 * Event description: Click on "Status Page" Banner
 *
 * @param {clickOnStatusPageBannerParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} client_id - client_id
 * @property {string} incident_name - incident_name
 * @property {GUID} user_id - uuid
 * @property {boolean} resolved - resolved
 * @return {LogObject<clickOnStatusPageBannerParams>} LogObject<clickOnStatusPageBannerParams>
 */
export function clickOnStatusPageBanner(params) {
    return { evid: 44, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpStartSignUpFlow' event (evid: 100)
 *
 * Event description: Click on one of the 'Get Started' buttons in wixanswers.com's homepage / 'Don't have an account? Sign Up here' on login first step (page 'Enter Your Wix Answers Domain')
 *
 * @param {marketingSignUpStartSignUpFlowParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {string} location - location
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {number} campaign_id - email_campaign_id
 * @return {LogObject<marketingSignUpStartSignUpFlowParams>} LogObject<marketingSignUpStartSignUpFlowParams>
 */
export function marketingSignUpStartSignUpFlow(params) {
    return { evid: 100, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpClickSignUpWithSso' event (evid: 101)
 *
 * Event description: Click on the "Signup with .." button on the first personal step of sign up flow
 *
 * @param {marketingSignUpClickSignUpWithSsoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {string} sso_type - sso_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {number} campaign_id - email_campaign_id
 * @return {LogObject<marketingSignUpClickSignUpWithSsoParams>} LogObject<marketingSignUpClickSignUpWithSsoParams>
 */
export function marketingSignUpClickSignUpWithSso(params) {
    return { evid: 101, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSubmitSignUpFirstStep' event (evid: 103)
 *
 * Event description: User attempt to submit the sign- up form.
 *
 * @param {marketingSignUpSubmitSignUpFirstStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {number} campaign_id - email_campaign_id
 * @return {LogObject<marketingSignUpSubmitSignUpFirstStepParams>} LogObject<marketingSignUpSubmitSignUpFirstStepParams>
 */
export function marketingSignUpSubmitSignUpFirstStep(params) {
    return { evid: 103, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpSuccessFirstStep' event (evid: 104)
 *
 * Event description: success on first step of the sign up flow
 *
 * @param {marketingSignUpSignUpSuccessFirstStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} wix_user_id - wix_user_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {GUID} wix_client_id - wix_client_id
 * @property {number} campaign_id - email_campaign_id
 * @return {LogObject<marketingSignUpSignUpSuccessFirstStepParams>} LogObject<marketingSignUpSignUpSuccessFirstStepParams>
 */
export function marketingSignUpSignUpSuccessFirstStep(params) {
    return { evid: 104, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpFailedFirstStep' event (evid: 105)
 *
 * Event description: User's first step of sign up failed
 *
 * @param {marketingSignUpSignUpFailedFirstStepParams} params - The parameters for this event
 * @property {string} errorReason - error_reason
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {string} error_reason - error_reason
 * @property {number} campaign_id - email_campaign_id
 * @return {LogObject<marketingSignUpSignUpFailedFirstStepParams>} LogObject<marketingSignUpSignUpFailedFirstStepParams>
 */
export function marketingSignUpSignUpFailedFirstStep(params) {
    return { evid: 105, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSubmitSignUpSecondStep' event (evid: 106)
 *
 * Event description: User sign up attempt on the second step of sign in flow of organization registartion
 *
 * @param {marketingSignUpSubmitSignUpSecondStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - subdomain
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {number} campaign_id - email_campaign_id
 * @return {LogObject<marketingSignUpSubmitSignUpSecondStepParams>} LogObject<marketingSignUpSubmitSignUpSecondStepParams>
 */
export function marketingSignUpSubmitSignUpSecondStep(params) {
    return { evid: 106, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpSuccessSecondStep' event (evid: 107)
 *
 * Event description: Click on the "Log In" button to start l````````````````````````````````````````````````````````````````````````````````````````````````````````````ogin form in wixanswers.com's homepage or from sign up the first step-
 *
 * @param {marketingSignUpSignUpSuccessSecondStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {string} location - location
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} wix_user_id - wix_user_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - subdomain
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {string} sign_up_method - sign_up_method
 * @property {GUID} wix_client_id - wix_client_id
 * @property {number} campaign_id - email_campaign_id
 * @property {Url} page_url - page_url
 * @return {LogObject<marketingSignUpSignUpSuccessSecondStepParams>} LogObject<marketingSignUpSignUpSuccessSecondStepParams>
 */
export function marketingSignUpSignUpSuccessSecondStep(params) {
    return { evid: 107, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpFailedSecondStep' event (evid: 108)
 *
 * Event description: User attempt to submit second sign up flow - add organization and URL
 *
 * @param {marketingSignUpSignUpFailedSecondStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - subdomain
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {string} error_reason - error_reason
 * @property {number} campaign_id - email_campaign_id
 * @return {LogObject<marketingSignUpSignUpFailedSecondStepParams>} LogObject<marketingSignUpSignUpFailedSecondStepParams>
 */
export function marketingSignUpSignUpFailedSecondStep(params) {
    return { evid: 108, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInSubmitPreLoginRedirectToAnswersUrl' event (evid: 109)
 *
 * Event description: User attempts to continue with his login first step - recognize tenant URL
 *
 * @param {marketingLogInSubmitPreLoginRedirectToAnswersUrlParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - subdomain
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {number} campaign_id - email_campaign_id
 * @return {LogObject<marketingLogInSubmitPreLoginRedirectToAnswersUrlParams>} LogObject<marketingLogInSubmitPreLoginRedirectToAnswersUrlParams>
 */
export function marketingLogInSubmitPreLoginRedirectToAnswersUrl(params) {
    return { evid: 109, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInPreLoginRedirectSuccess' event (evid: 110)
 *
 * Event description: User's Pre- login success - redirect tenant URL
 *
 * @param {marketingLogInPreLoginRedirectSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - subdomain
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {number} campaign_id - email_campaign_id
 * @return {LogObject<marketingLogInPreLoginRedirectSuccessParams>} LogObject<marketingLogInPreLoginRedirectSuccessParams>
 */
export function marketingLogInPreLoginRedirectSuccess(params) {
    return { evid: 110, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInPreLoginRedirectFailed' event (evid: 111)
 *
 * Event description: User's Pre- login - redirect tenant URL failed
 *
 * @param {marketingLogInPreLoginRedirectFailedParams} params - The parameters for this event
 * @property {string} errorReason - error_reason
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - subdomain
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {string} error_reason - error_reason
 * @property {number} campaign_id - email_campaign_id
 * @property {Url} page_url - page_url
 * @return {LogObject<marketingLogInPreLoginRedirectFailedParams>} LogObject<marketingLogInPreLoginRedirectFailedParams>
 */
export function marketingLogInPreLoginRedirectFailed(params) {
    return { evid: 111, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingPageView' event (evid: 113)
 *
 * Event description: Viewing a page in Answers Marketing Site.
 *
 * @param {marketingPageViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} utm_source - utm_source
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {GUID} session_id - session_id
 * @property {Url} referral_url - referral_url
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} wix_user_id - wix_user_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} marketing_id - marketing_id
 * @property {string} utm_campaign - utm_campaign
 * @property {GUID} wix_client_id - wix_client_id
 * @property {number} campaign_id - email_campaign_id
 * @property {Url} page_url - page_url
 * @return {LogObject<marketingPageViewParams>} LogObject<marketingPageViewParams>
 */
export function marketingPageView(params) {
    return { evid: 113, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInUserLoginAttempt' event (evid: 114)
 *
 * Event description: User attempt to sign in with mail or other login types on the second personal login step, after identifying his answers domain on the first step.
 *
 * @param {marketingLogInUserLoginAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - subdomain
 * @property {Url} page_url - page_url
 * @property {string} login_type - login_type
 * @return {LogObject<marketingLogInUserLoginAttemptParams>} LogObject<marketingLogInUserLoginAttemptParams>
 */
export function marketingLogInUserLoginAttempt(params) {
    return { evid: 114, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInSuccessUserLogin' event (evid: 115)
 *
 * Event description: User succeeds to sign in with mail or another login type on the second personal login step, after identifying his answers domain on the first step.
 *
 * @param {marketingLogInSuccessUserLoginParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {boolean} is_agent - is_agent
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - subdomain
 * @property {Url} page_url - page_url
 * @property {string} login_type - login_type
 * @return {LogObject<marketingLogInSuccessUserLoginParams>} LogObject<marketingLogInSuccessUserLoginParams>
 */
export function marketingLogInSuccessUserLogin(params) {
    return { evid: 115, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInFailedUserLogin' event (evid: 116)
 *
 * Event description: User failed to sign in with mail or other login types on the second personal login step, after identifying his answers domain on the first step.
 *
 * @param {marketingLogInFailedUserLoginParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - subdomain
 * @property {string} error_reason - error_reason
 * @property {Url} page_url - page_url
 * @property {string} login_type - login_type
 * @return {LogObject<marketingLogInFailedUserLoginParams>} LogObject<marketingLogInFailedUserLoginParams>
 */
export function marketingLogInFailedUserLogin(params) {
    return { evid: 116, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoWidgetWidgetLoaded' event (evid: 117)
 *
 * Event description: The widget is loaded and the user can see the 'Request Demo' widget.
 *
 * @param {marketingRequestDemoWidgetWidgetLoadedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - page_url
 * @return {LogObject<marketingRequestDemoWidgetWidgetLoadedParams>} LogObject<marketingRequestDemoWidgetWidgetLoadedParams>
 */
export function marketingRequestDemoWidgetWidgetLoaded(params) {
    return { evid: 117, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoWidgetOpenTheWidget' event (evid: 118)
 *
 * Event description: The user open the 'Request Demo' widget.
 *
 * @param {marketingRequestDemoWidgetOpenTheWidgetParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - page_url
 * @return {LogObject<marketingRequestDemoWidgetOpenTheWidgetParams>} LogObject<marketingRequestDemoWidgetOpenTheWidgetParams>
 */
export function marketingRequestDemoWidgetOpenTheWidget(params) {
    return { evid: 118, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoWidgetSubmitRequestDemo' event (evid: 119)
 *
 * Event description: The user fill all the inputs and submit the request to schedule a demo.
 *
 * @param {marketingRequestDemoWidgetSubmitRequestDemoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - page_url
 * @return {LogObject<marketingRequestDemoWidgetSubmitRequestDemoParams>} LogObject<marketingRequestDemoWidgetSubmitRequestDemoParams>
 */
export function marketingRequestDemoWidgetSubmitRequestDemo(params) {
    return { evid: 119, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingWatchAVideoPressOnButton' event (evid: 120)
 *
 * Event description: The user Click on "Watch a video" (a button on the first fold which will link to our YT video)
 *
 * @param {marketingWatchAVideoPressOnButtonParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - page_url
 * @return {LogObject<marketingWatchAVideoPressOnButtonParams>} LogObject<marketingWatchAVideoPressOnButtonParams>
 */
export function marketingWatchAVideoPressOnButton(params) {
    return { evid: 120, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLearnMorePressOnButton' event (evid: 121)
 *
 * Event description: The user Click on "Learn more" (a button which will be added below each Product on the home page, linking to the product's specific page)
 *
 * @param {marketingLearnMorePressOnButtonParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} section_name - section_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - page_url
 * @return {LogObject<marketingLearnMorePressOnButtonParams>} LogObject<marketingLearnMorePressOnButtonParams>
 */
export function marketingLearnMorePressOnButton(params) {
    return { evid: 121, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoFormSubmitRequestDemo' event (evid: 122)
 *
 * Event description: The user fill all the inputs and submit the request to schedule a demo.
 *
 * @param {marketingRequestDemoFormSubmitRequestDemoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - page_url
 * @return {LogObject<marketingRequestDemoFormSubmitRequestDemoParams>} LogObject<marketingRequestDemoFormSubmitRequestDemoParams>
 */
export function marketingRequestDemoFormSubmitRequestDemo(params) {
    return { evid: 122, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingCampaignView' event (evid: 124)
 *
 * Event description: The user view a campaign page.
 *
 * @param {marketingCampaignViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} campaign_name - campaign_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} campaign_id - campaign_id
 * @property {string} page_url - page_url
 * @return {LogObject<marketingCampaignViewParams>} LogObject<marketingCampaignViewParams>
 */
export function marketingCampaignView(params) {
    return { evid: 124, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingCampaignPageSubmitCampaignForm' event (evid: 125)
 *
 * Event description: The user submit the campaign form and send his details.
 *
 * @param {marketingCampaignPageSubmitCampaignFormParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} campaign_name - campaign_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} campaign_id - campaign_id
 * @property {string} page_url - page_url
 * @return {LogObject<marketingCampaignPageSubmitCampaignFormParams>} LogObject<marketingCampaignPageSubmitCampaignFormParams>
 */
export function marketingCampaignPageSubmitCampaignForm(params) {
    return { evid: 125, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingPageViewOnEditorMarketingPage' event (evid: 126)
 *
 * Event description: The user view an Answers page in editor marketing page.
 *
 * @param {marketingPageViewOnEditorMarketingPageParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} page_name - page_name
 * @property {string} page_url - page_url
 * @return {LogObject<marketingPageViewOnEditorMarketingPageParams>} LogObject<marketingPageViewOnEditorMarketingPageParams>
 */
export function marketingPageViewOnEditorMarketingPage(params) {
    return { evid: 126, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOnboardingGeneralQuestionsEvent' event (evid: 902)
 *
 * Event description: This is a general onboarding event. At first phase of the Onboarding dev process, this event will be used for reporting all actions in the "Questions" screen
 *
 * @param {appOnboardingGeneralQuestionsEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} params - params
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} type - type
 * @return {LogObject<appOnboardingGeneralQuestionsEventParams>} LogObject<appOnboardingGeneralQuestionsEventParams>
 */
export function appOnboardingGeneralQuestionsEvent(params) {
    return { evid: 902, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsThumbsDownASuggestedArticle' event (evid: 1003)
 *
 * Event description: Voting against a suggested article for a ticket
 *
 * @param {appTicketsThumbsDownASuggestedArticleParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} search_term - search_term
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @property {string} lang - lang
 * @property {string} order_location - order_location
 * @return {LogObject<appTicketsThumbsDownASuggestedArticleParams>} LogObject<appTicketsThumbsDownASuggestedArticleParams>
 */
export function appTicketsThumbsDownASuggestedArticle(params) {
    return { evid: 1003, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsPressButtonCreateTicket' event (evid: 1005)
 *
 * Event description: Press the button to + Create ticket
 *
 * @param {appTicketsPressButtonCreateTicketParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - lang
 * @return {LogObject<appTicketsPressButtonCreateTicketParams>} LogObject<appTicketsPressButtonCreateTicketParams>
 */
export function appTicketsPressButtonCreateTicket(params) {
    return { evid: 1005, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsCreateATicket' event (evid: 1006)
 *
 * Event description: create a ticket with all its details - click "Create ticket" blue button
 *
 * @param {appTicketsCreateATicketParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - lang
 * @return {LogObject<appTicketsCreateATicketParams>} LogObject<appTicketsCreateATicketParams>
 */
export function appTicketsCreateATicket(params) {
    return { evid: 1006, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTeamTeamMemberInvitationSentButtonClick' event (evid: 1203)
 *
 * Event description: Click on the "send" button after adding group members
 *
 * @param {appTeamTeamMemberInvitationSentButtonClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {number} count_admins - count_admins
 * @property {GUID} tenant_id - tenant_id
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} count_agents - count_agents
 * @property {string} lang - lang
 * @return {LogObject<appTeamTeamMemberInvitationSentButtonClickParams>} LogObject<appTeamTeamMemberInvitationSentButtonClickParams>
 */
export function appTeamTeamMemberInvitationSentButtonClick(params) {
    return { evid: 1203, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTeamAddNewGroupMember' event (evid: 1206)
 *
 * Event description: Selecting a group member after clicking the "+ New Team member" button
 *
 * @param {appTeamAddNewGroupMemberParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} source - source
 * @property {string} permission_level - permission_level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} group_name - group_name
 * @property {string} member_name - member_name
 * @property {string} lang - lang
 * @property {GUID} member_uuid - member_uuid
 * @return {LogObject<appTeamAddNewGroupMemberParams>} LogObject<appTeamAddNewGroupMemberParams>
 */
export function appTeamAddNewGroupMember(params) {
    return { evid: 1206, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appWasabiAdvancedReportsCreateNewReport' event (evid: 1331)
 *
 * Event description: User Created new report - 2 options: Reports view / duplicate
 * after clicking on 'Create Report'
 *
 * @param {appWasabiAdvancedReportsCreateNewReportParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} source_component - source
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reportName - report_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appWasabiAdvancedReportsCreateNewReportParams>} LogObject<appWasabiAdvancedReportsCreateNewReportParams>
 */
export function appWasabiAdvancedReportsCreateNewReport(params) {
    return { evid: 1331, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appWasabiAdvancedReportsDeleteReport' event (evid: 1332)
 *
 * Event description: User deleted an existing report (non standard report)
 * after clicking on 'Yes, Delete'
 *
 * @param {appWasabiAdvancedReportsDeleteReportParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reportName - report_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appWasabiAdvancedReportsDeleteReportParams>} LogObject<appWasabiAdvancedReportsDeleteReportParams>
 */
export function appWasabiAdvancedReportsDeleteReport(params) {
    return { evid: 1332, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingClickUpdatePaymentMethodModalLink' event (evid: 1459)
 *
 * Event description: Member clicks on the Update Payment Method link in the upper right corner of the Billing Page
 *
 * @param {appSettingsBillingClickUpdatePaymentMethodModalLinkParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appSettingsBillingClickUpdatePaymentMethodModalLinkParams>} LogObject<appSettingsBillingClickUpdatePaymentMethodModalLinkParams>
 */
export function appSettingsBillingClickUpdatePaymentMethodModalLink(params) {
    return { evid: 1459, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodAttempt' event (evid: 1460)
 *
 * Event description: Update Payment Method Attempt
 *
 * @param {appSettingsBillingUpdatePaymentMethodAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodAttemptParams>} LogObject<appSettingsBillingUpdatePaymentMethodAttemptParams>
 */
export function appSettingsBillingUpdatePaymentMethodAttempt(params) {
    return { evid: 1460, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodSuccess' event (evid: 1461)
 *
 * Event description: App (Settings) - Billing -  Update Payment Method Success.
 *
 * @param {appSettingsBillingUpdatePaymentMethodSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodSuccessParams>} LogObject<appSettingsBillingUpdatePaymentMethodSuccessParams>
 */
export function appSettingsBillingUpdatePaymentMethodSuccess(params) {
    return { evid: 1461, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodFail' event (evid: 1462)
 *
 * Event description: App (Settings) - Billing -  Update Payment Method Fail.
 *
 * @param {appSettingsBillingUpdatePaymentMethodFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodFailParams>} LogObject<appSettingsBillingUpdatePaymentMethodFailParams>
 */
export function appSettingsBillingUpdatePaymentMethodFail(params) {
    return { evid: 1462, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodModalPreviewRenderFail' event (evid: 1463)
 *
 * Event description: Update payment method modal preview fails to render
 *
 * @param {appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams>} LogObject<appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams>
 */
export function appSettingsBillingUpdatePaymentMethodModalPreviewRenderFail(params) {
    return { evid: 1463, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingPaymentMethodModalUseADifferentCardClick' event (evid: 1464)
 *
 * Event description: App (Settings) - Billing - Payment Method Modal - Use A Different Card Click.
 *
 * @param {appSettingsBillingPaymentMethodModalUseADifferentCardClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {boolean} is_checked - is_checked
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appSettingsBillingPaymentMethodModalUseADifferentCardClickParams>} LogObject<appSettingsBillingPaymentMethodModalUseADifferentCardClickParams>
 */
export function appSettingsBillingPaymentMethodModalUseADifferentCardClick(params) {
    return { evid: 1464, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingDownloadInvoiceFile' event (evid: 1465)
 *
 * Event description: Download Invoice file CTA in the invoice history list
 *
 * @param {appSettingsBillingDownloadInvoiceFileParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {number} invoice_amount - invoice_amount
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {DateTime} invoice_date - invoice_date
 * @return {LogObject<appSettingsBillingDownloadInvoiceFileParams>} LogObject<appSettingsBillingDownloadInvoiceFileParams>
 */
export function appSettingsBillingDownloadInvoiceFile(params) {
    return { evid: 1465, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerUserOpenedPp' event (evid: 1811)
 *
 * Event description: Answers PP - lightbox appears successfully.
 * First step - User select team size
 * Second Step -  User choose a plan and product.
 * Third step - User select subscription type.
 *
 * @param {appPremiumPackagePickerUserOpenedPpParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @return {LogObject<appPremiumPackagePickerUserOpenedPpParams>} LogObject<appPremiumPackagePickerUserOpenedPpParams>
 */
export function appPremiumPackagePickerUserOpenedPp(params) {
    return { evid: 1811, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerUserClosedPpLightBox' event (evid: 1812)
 *
 * Event description: Answers PP - Close lightbox on any step with closing method attribute: click on X button
 *
 * @param {appPremiumPackagePickerUserClosedPpLightBoxParams} params - The parameters for this event
 * @property {boolean} product_call_center - product_call_center
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} product_knowledge_base - product_knowledge_base
 * @property {boolean} product_chat - product_chat
 * @property {string} from_step - from_step
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} plan_type - plan_type
 * @property {string} origin - origin
 * @property {number} plan_price - plan_price
 * @property {string} team_size - team_size
 * @property {string} subscription_type - subscription_type
 * @property {boolean} product_ticketing - product_ticketing
 * @return {LogObject<appPremiumPackagePickerUserClosedPpLightBoxParams>} LogObject<appPremiumPackagePickerUserClosedPpLightBoxParams>
 */
export function appPremiumPackagePickerUserClosedPpLightBox(params) {
    return { evid: 1812, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerFirstStepUserSelectTeamSize' event (evid: 1813)
 *
 * Event description: Answers PP First step - User select team size (radio button) :
 * {2-5, 6-10, 11-20, 21-50, 51-100,100+ (-1)}
 * (All 'product' and 'plan' attributes will be NULL when the other steps are not exposed but not if they changed after advanced steps.)
 *
 * @param {appPremiumPackagePickerFirstStepUserSelectTeamSizeParams} params - The parameters for this event
 * @property {boolean} product_call_center - product_call_center
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} product_knowledge_base - product_knowledge_base
 * @property {boolean} product_chat - product_chat
 * @property {string} from_step - from_step
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} plan_type - plan_type
 * @property {string} origin - origin
 * @property {number} plan_price - plan_price
 * @property {string} team_size - team_size
 * @property {string} subscription_type - subscription_type
 * @property {boolean} product_ticketing - product_ticketing
 * @return {LogObject<appPremiumPackagePickerFirstStepUserSelectTeamSizeParams>} LogObject<appPremiumPackagePickerFirstStepUserSelectTeamSizeParams>
 */
export function appPremiumPackagePickerFirstStepUserSelectTeamSize(params) {
    return { evid: 1813, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepProductCheckboxChecked' event (evid: 1814)
 *
 * Event description: Answers PP - Second step: user checked on one of the products checkboxes : KB/ Ticketing(HD)/ Call center. (custom as plan type)
 * for example:
 * checked_product: Call center
 * product_call_center=1
 * product_ticketing =0
 * product_knowledge_base=0
 *
 * @param {appPremiumPackagePickerSecondStepProductCheckboxCheckedParams} params - The parameters for this event
 * @property {boolean} product_call_center - product_call_center
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} product_knowledge_base - product_knowledge_base
 * @property {boolean} product_chat - product_chat
 * @property {string} from_step - from_step
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} plan_type - plan_type
 * @property {string} origin - origin
 * @property {number} plan_price - plan_price
 * @property {string} team_size - team_size
 * @property {string} checked_product - checked_product
 * @property {string} subscription_type - subscription_type
 * @property {boolean} product_ticketing - product_ticketing
 * @return {LogObject<appPremiumPackagePickerSecondStepProductCheckboxCheckedParams>} LogObject<appPremiumPackagePickerSecondStepProductCheckboxCheckedParams>
 */
export function appPremiumPackagePickerSecondStepProductCheckboxChecked(params) {
    return { evid: 1814, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepUserUncheckedProduct' event (evid: 1815)
 *
 * Event description: Answers Package Picker - Second step - User unchecked product checkbox on Custom plan type: uncheck call center/uncheck knowledge base/uncheck ticketing.
 * for example:
 * product_call_center=0
 * product_ticketing =0
 * product_knowledge_base=0
 * and unchecked_product: Call center
 *
 * @param {appPremiumPackagePickerSecondStepUserUncheckedProductParams} params - The parameters for this event
 * @property {boolean} product_call_center - product_call_center
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} product_knowledge_base - product_knowledge_base
 * @property {boolean} product_chat - product_chat
 * @property {string} from_step - from_step
 * @property {string} unchecked_product - unchecked_product
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} plan_type - plan_type
 * @property {string} origin - origin
 * @property {number} plan_price - plan_price
 * @property {string} team_size - team_size
 * @property {string} subscription_type - subscription_type
 * @property {boolean} product_ticketing - product_ticketing
 * @return {LogObject<appPremiumPackagePickerSecondStepUserUncheckedProductParams>} LogObject<appPremiumPackagePickerSecondStepUserUncheckedProductParams>
 */
export function appPremiumPackagePickerSecondStepUserUncheckedProduct(params) {
    return { evid: 1815, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlan' event (evid: 1816)
 *
 * Event description: Answers PP Second step - User clicked on Unlimited plan select button or 3 products custom plan selected
 *
 * @param {appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams} params - The parameters for this event
 * @property {boolean} product_call_center - product_call_center
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} product_knowledge_base - product_knowledge_base
 * @property {boolean} product_chat - product_chat
 * @property {string} from_step - from_step
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} plan_type - plan_type
 * @property {string} origin - origin
 * @property {boolean} unlimited_selected - unlimited_selected
 * @property {number} plan_price - plan_price
 * @property {string} team_size - team_size
 * @property {string} subscription_type - subscription_type
 * @property {boolean} product_ticketing - product_ticketing
 * @return {LogObject<appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams>} LogObject<appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams>
 */
export function appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlan(params) {
    return { evid: 1816, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerThirdStepChooseSubscriptionCycle' event (evid: 1817)
 *
 * Event description: Answers PP Third step - Choose Answers subscription cycle:
 * Monthly / Yearly
 *
 * @param {appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams} params - The parameters for this event
 * @property {boolean} product_call_center - product_call_center
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} product_knowledge_base - product_knowledge_base
 * @property {boolean} product_chat - product_chat
 * @property {string} from_step - from_step
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} plan_type - plan_type
 * @property {string} origin - origin
 * @property {number} plan_price - plan_price
 * @property {string} team_size - team_size
 * @property {string} subscription_type - subscription_type
 * @property {boolean} product_ticketing - product_ticketing
 * @return {LogObject<appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams>} LogObject<appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams>
 */
export function appPremiumPackagePickerThirdStepChooseSubscriptionCycle(params) {
    return { evid: 1817, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerProceedToCheckoutClick' event (evid: 1818)
 *
 * Event description: Answers PP last step
 *
 * @param {appPremiumPackagePickerProceedToCheckoutClickParams} params - The parameters for this event
 * @property {boolean} product_call_center - product_call_center
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} product_knowledge_base - product_knowledge_base
 * @property {boolean} product_chat - product_chat
 * @property {string} from_step - from_step
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} plan_type - plan_type
 * @property {string} origin - origin
 * @property {number} plan_price - plan_price
 * @property {string} team_size - team_size
 * @property {string} subscription_type - subscription_type
 * @property {boolean} product_ticketing - product_ticketing
 * @return {LogObject<appPremiumPackagePickerProceedToCheckoutClickParams>} LogObject<appPremiumPackagePickerProceedToCheckoutClickParams>
 */
export function appPremiumPackagePickerProceedToCheckoutClick(params) {
    return { evid: 1818, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerUserClosedUpgradeSuccessLightBox' event (evid: 1819)
 *
 * Event description: Answers PP last step:  upgrade success lightbox closed.
 * Method is for user closing action: user click on okay button /click outside of the lightbox
 *
 * @param {appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams} params - The parameters for this event
 * @property {boolean} product_call_center - product_call_center
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} product_knowledge_base - product_knowledge_base
 * @property {boolean} product_chat - product_chat
 * @property {string} from_step - from_step
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} plan_type - plan_type
 * @property {string} origin - origin
 * @property {number} plan_price - plan_price
 * @property {string} team_size - team_size
 * @property {string} subscription_type - subscription_type
 * @property {boolean} product_ticketing - product_ticketing
 * @return {LogObject<appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams>} LogObject<appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams>
 */
export function appPremiumPackagePickerUserClosedUpgradeSuccessLightBox(params) {
    return { evid: 1819, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepContactUsClickOnLink' event (evid: 1820)
 *
 * Event description: Answers PP - Second step - Contact us user click on the contact link - vip@wixanswers.com mail after choosing  maximum num of agents (101+ agents)
 *
 * @param {appPremiumPackagePickerSecondStepContactUsClickOnLinkParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} from_step - from_step
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @return {LogObject<appPremiumPackagePickerSecondStepContactUsClickOnLinkParams>} LogObject<appPremiumPackagePickerSecondStepContactUsClickOnLinkParams>
 */
export function appPremiumPackagePickerSecondStepContactUsClickOnLink(params) {
    return { evid: 1820, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerLoadStarted' event (evid: 1821)
 *
 * Event description: User opens the Package Picker and it starts to load
 *
 * @param {appPremiumPackagePickerLoadStartedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @return {LogObject<appPremiumPackagePickerLoadStartedParams>} LogObject<appPremiumPackagePickerLoadStartedParams>
 */
export function appPremiumPackagePickerLoadStarted(params) {
    return { evid: 1821, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerLoadSuccess' event (evid: 1822)
 *
 * Event description: User opens the Package Picker and it loads successfully
 *
 * @param {appPremiumPackagePickerLoadSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {number} tts - total_loading_time
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @return {LogObject<appPremiumPackagePickerLoadSuccessParams>} LogObject<appPremiumPackagePickerLoadSuccessParams>
 */
export function appPremiumPackagePickerLoadSuccess(params) {
    return { evid: 1822, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerHoverOnPackage' event (evid: 1823)
 *
 * Event description: App (Premium) - Package Picker - Hover on Package.
 *
 * @param {appPremiumPackagePickerHoverOnPackageParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @return {LogObject<appPremiumPackagePickerHoverOnPackageParams>} LogObject<appPremiumPackagePickerHoverOnPackageParams>
 */
export function appPremiumPackagePickerHoverOnPackage(params) {
    return { evid: 1823, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSelectPackage' event (evid: 1824)
 *
 * Event description: User selects premium package - CTA click (Unlimited / Multi-Channel / Self-Service / Call Center)
 *
 * @param {appPremiumPackagePickerSelectPackageParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerSelectPackageParams>} LogObject<appPremiumPackagePickerSelectPackageParams>
 */
export function appPremiumPackagePickerSelectPackage(params) {
    return { evid: 1824, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSelectTeamSize' event (evid: 1825)
 *
 * Event description: User selects team size (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * @param {appPremiumPackagePickerSelectTeamSizeParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerSelectTeamSizeParams>} LogObject<appPremiumPackagePickerSelectTeamSizeParams>
 */
export function appPremiumPackagePickerSelectTeamSize(params) {
    return { evid: 1825, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSelectSubscriptionCycle' event (evid: 1826)
 *
 * Event description: User selects subscription cycle - the whole strip is clickable, not just radio button (Monthly / Yearly / 2 Years)
 *
 * @param {appPremiumPackagePickerSelectSubscriptionCycleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerSelectSubscriptionCycleParams>} LogObject<appPremiumPackagePickerSelectSubscriptionCycleParams>
 */
export function appPremiumPackagePickerSelectSubscriptionCycle(params) {
    return { evid: 1826, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerOrderPreviewRendered' event (evid: 1827)
 *
 * Event description: Order preview is rendered
 *
 * @param {appPremiumPackagePickerOrderPreviewRenderedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {number} tts - total_loading_time
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {GUID} preview_id - preview_id
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerOrderPreviewRenderedParams>} LogObject<appPremiumPackagePickerOrderPreviewRenderedParams>
 */
export function appPremiumPackagePickerOrderPreviewRendered(params) {
    return { evid: 1827, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerEnterpriseRequestCallback' event (evid: 1828)
 *
 * Event description: User requests callback (CTA button) after selecting the enterprise solution (50+), which opens the widget
 *
 * @param {appPremiumPackagePickerEnterpriseRequestCallbackParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerEnterpriseRequestCallbackParams>} LogObject<appPremiumPackagePickerEnterpriseRequestCallbackParams>
 */
export function appPremiumPackagePickerEnterpriseRequestCallback(params) {
    return { evid: 1828, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutAttempt' event (evid: 1829)
 *
 * Event description: User attempts to checkout (CTA button)
 *
 * @param {appPremiumPackagePickerCheckoutAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerCheckoutAttemptParams>} LogObject<appPremiumPackagePickerCheckoutAttemptParams>
 */
export function appPremiumPackagePickerCheckoutAttempt(params) {
    return { evid: 1829, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutSuccess' event (evid: 1830)
 *
 * Event description: User succeeds to checkout - Zuora iframe is rendered
 *
 * @param {appPremiumPackagePickerCheckoutSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {number} tts - total_loading_time
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerCheckoutSuccessParams>} LogObject<appPremiumPackagePickerCheckoutSuccessParams>
 */
export function appPremiumPackagePickerCheckoutSuccess(params) {
    return { evid: 1830, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutFail' event (evid: 1831)
 *
 * Event description: User fails to checkout - Zuora iframe cannot be rendered
 *
 * @param {appPremiumPackagePickerCheckoutFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerCheckoutFailParams>} LogObject<appPremiumPackagePickerCheckoutFailParams>
 */
export function appPremiumPackagePickerCheckoutFail(params) {
    return { evid: 1831, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseAttempt' event (evid: 1832)
 *
 * Event description: App (Premium) - Package Picker - Purchase Attempt.
 *
 * @param {appPremiumPackagePickerPurchaseAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerPurchaseAttemptParams>} LogObject<appPremiumPackagePickerPurchaseAttemptParams>
 */
export function appPremiumPackagePickerPurchaseAttempt(params) {
    return { evid: 1832, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseSuccess' event (evid: 1833)
 *
 * Event description: User succeeds to purchase
 *
 * @param {appPremiumPackagePickerPurchaseSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {number} tts - total_loading_time
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerPurchaseSuccessParams>} LogObject<appPremiumPackagePickerPurchaseSuccessParams>
 */
export function appPremiumPackagePickerPurchaseSuccess(params) {
    return { evid: 1833, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseFail' event (evid: 1834)
 *
 * Event description: User fails to purchase
 *
 * @param {appPremiumPackagePickerPurchaseFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerPurchaseFailParams>} LogObject<appPremiumPackagePickerPurchaseFailParams>
 */
export function appPremiumPackagePickerPurchaseFail(params) {
    return { evid: 1834, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseModalLinkClick' event (evid: 1835)
 *
 * Event description: User clicks link from modal after purchase success or fail
 *
 * @param {appPremiumPackagePickerPurchaseModalLinkClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {Url} link_name - link_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} modal_name - modal_name
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerPurchaseModalLinkClickParams>} LogObject<appPremiumPackagePickerPurchaseModalLinkClickParams>
 */
export function appPremiumPackagePickerPurchaseModalLinkClick(params) {
    return { evid: 1835, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerWhatsInsideHover' event (evid: 1836)
 *
 * Event description: User hovers on "What's Inside" - tip tool
 *
 * @param {appPremiumPackagePickerWhatsInsideHoverParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {number} from_step - from_step_num
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerWhatsInsideHoverParams>} LogObject<appPremiumPackagePickerWhatsInsideHoverParams>
 */
export function appPremiumPackagePickerWhatsInsideHover(params) {
    return { evid: 1836, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerGoBackToPreviousStep' event (evid: 1837)
 *
 * Event description: User clicks button to go back to previous page
 *
 * @param {appPremiumPackagePickerGoBackToPreviousStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {number} from_step - from_step_num
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerGoBackToPreviousStepParams>} LogObject<appPremiumPackagePickerGoBackToPreviousStepParams>
 */
export function appPremiumPackagePickerGoBackToPreviousStep(params) {
    return { evid: 1837, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPreviewRenderFail' event (evid: 1839)
 *
 * Event description: Order preview fails to render
 *
 * @param {appPremiumPackagePickerPreviewRenderFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {number} team_size - team_size_num
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerPreviewRenderFailParams>} LogObject<appPremiumPackagePickerPreviewRenderFailParams>
 */
export function appPremiumPackagePickerPreviewRenderFail(params) {
    return { evid: 1839, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksCreditIncentiveView' event (evid: 1853)
 *
 * Event description: An user views a call center credit incentive
 *
 * @param {appPremiumBlocksCreditIncentiveViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} feature - feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {boolean} is_eligible - is_eligible
 * @return {LogObject<appPremiumBlocksCreditIncentiveViewParams>} LogObject<appPremiumBlocksCreditIncentiveViewParams>
 */
export function appPremiumBlocksCreditIncentiveView(params) {
    return { evid: 1853, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksCreditIncentiveIncentiveCtaClick' event (evid: 1854)
 *
 * Event description: A user clicks on a CTA in a call center credit incentive
 *
 * @param {appPremiumBlocksCreditIncentiveIncentiveCtaClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} feature - feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {boolean} is_eligible - is_eligible
 * @return {LogObject<appPremiumBlocksCreditIncentiveIncentiveCtaClickParams>} LogObject<appPremiumBlocksCreditIncentiveIncentiveCtaClickParams>
 */
export function appPremiumBlocksCreditIncentiveIncentiveCtaClick(params) {
    return { evid: 1854, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksPremiumIncentiveContactUsClick' event (evid: 1855)
 *
 * Event description: A user clicks on the "Contact Us" button in a premium incentive of a blocked premium feature
 *
 * @param {appPremiumBlocksPremiumIncentiveContactUsClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} feature - feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {boolean} is_premium - is_premium
 * @property {boolean} is_eligible - is_eligible
 * @return {LogObject<appPremiumBlocksPremiumIncentiveContactUsClickParams>} LogObject<appPremiumBlocksPremiumIncentiveContactUsClickParams>
 */
export function appPremiumBlocksPremiumIncentiveContactUsClick(params) {
    return { evid: 1855, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsOpenCccModal' event (evid: 1861)
 *
 * Event description: Call Center Credits (CCC) modal lightbox appears successfully
 *
 * @param {appPremiumCcCreditsOpenCccModalParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {boolean} is_premium - is_premium
 * @property {string} current_balance - current_balance
 * @return {LogObject<appPremiumCcCreditsOpenCccModalParams>} LogObject<appPremiumCcCreditsOpenCccModalParams>
 */
export function appPremiumCcCreditsOpenCccModal(params) {
    return { evid: 1861, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCloseCccModal' event (evid: 1862)
 *
 * Event description: Call Center Credits (CCC) modal lightbox closed
 *
 * @param {appPremiumCcCreditsCloseCccModalParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {boolean} is_premium - is_premium
 * @property {string} current_balance - current_balance
 * @return {LogObject<appPremiumCcCreditsCloseCccModalParams>} LogObject<appPremiumCcCreditsCloseCccModalParams>
 */
export function appPremiumCcCreditsCloseCccModal(params) {
    return { evid: 1862, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsModalCtaClick' event (evid: 1863)
 *
 * Event description: User clicked on the Call Center Credits (CCC) modal CTA (to the premium plans PP or the credits PP)
 *
 * @param {appPremiumCcCreditsModalCtaClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {boolean} is_premium - is_premium
 * @property {string} current_balance - current_balance
 * @return {LogObject<appPremiumCcCreditsModalCtaClickParams>} LogObject<appPremiumCcCreditsModalCtaClickParams>
 */
export function appPremiumCcCreditsModalCtaClick(params) {
    return { evid: 1863, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsOpenPackagePicker' event (evid: 1864)
 *
 * Event description: Call Center Credits (CCC) Package Picker opened successfully.
 *
 * @param {appPremiumCcCreditsOpenPackagePickerParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {string} current_balance - current_balance
 * @return {LogObject<appPremiumCcCreditsOpenPackagePickerParams>} LogObject<appPremiumCcCreditsOpenPackagePickerParams>
 */
export function appPremiumCcCreditsOpenPackagePicker(params) {
    return { evid: 1864, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsSelectAmountForPurchase' event (evid: 1865)
 *
 * Event description: User selected the amount of call center credits for purchase
 *
 * @param {appPremiumCcCreditsSelectAmountForPurchaseParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} credits_amount - credits_amount
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {string} current_balance - current_balance
 * @return {LogObject<appPremiumCcCreditsSelectAmountForPurchaseParams>} LogObject<appPremiumCcCreditsSelectAmountForPurchaseParams>
 */
export function appPremiumCcCreditsSelectAmountForPurchase(params) {
    return { evid: 1865, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsClickOnCheckout' event (evid: 1866)
 *
 * Event description: User attempts to proceed to the call center credits checkout
 *
 * @param {appPremiumCcCreditsClickOnCheckoutParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} credits_amount - credits_amount
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} origin - origin
 * @property {string} current_balance - current_balance
 * @return {LogObject<appPremiumCcCreditsClickOnCheckoutParams>} LogObject<appPremiumCcCreditsClickOnCheckoutParams>
 */
export function appPremiumCcCreditsClickOnCheckout(params) {
    return { evid: 1866, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCreditPurchaseSuccessLb' event (evid: 1867)
 *
 * Event description: Call center credits purchase success lightbox appears
 *
 * @param {appPremiumCcCreditsCreditPurchaseSuccessLbParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumCcCreditsCreditPurchaseSuccessLbParams>} LogObject<appPremiumCcCreditsCreditPurchaseSuccessLbParams>
 */
export function appPremiumCcCreditsCreditPurchaseSuccessLb(params) {
    return { evid: 1867, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCreditPurchaseFailLb' event (evid: 1868)
 *
 * Event description: Call center credits purchase fail lightbox appears
 *
 * @param {appPremiumCcCreditsCreditPurchaseFailLbParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumCcCreditsCreditPurchaseFailLbParams>} LogObject<appPremiumCcCreditsCreditPurchaseFailLbParams>
 */
export function appPremiumCcCreditsCreditPurchaseFailLb(params) {
    return { evid: 1868, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralWelcomeLightboxView' event (evid: 1901)
 *
 * Event description: The Answers welcome lightbox was viewed by the user. Event avaiable since 2018-10-11
 *
 * @param {appGeneralWelcomeLightboxViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} type - type
 * @return {LogObject<appGeneralWelcomeLightboxViewParams>} LogObject<appGeneralWelcomeLightboxViewParams>
 */
export function appGeneralWelcomeLightboxView(params) {
    return { evid: 1901, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicWidgetSuggestedArticlesIssueResolved' event (evid: 2240)
 *
 * Event description: After Clicking on one of the suggested articles from inside a ticket submission (only in a widget!!), click on "Yes! my issues was resolved".
 *
 * @param {publicWidgetSuggestedArticlesIssueResolvedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} widget_id - widget_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} parent_name - parent_name
 * @property {string} widget_name - widget_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @property {string} parent_url - parent_url
 * @return {LogObject<publicWidgetSuggestedArticlesIssueResolvedParams>} LogObject<publicWidgetSuggestedArticlesIssueResolvedParams>
 */
export function publicWidgetSuggestedArticlesIssueResolved(params) {
    return { evid: 2240, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicWidgetSuggestedArticlesIWantToReport' event (evid: 2250)
 *
 * Event description: After Clicking on one of the suggested articles from inside a ticket submission (only in a widget!!), click on "No! I want to report my issue".
 *
 * @param {publicWidgetSuggestedArticlesIWantToReportParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} widget_id - widget_id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} parent_name - parent_name
 * @property {string} widget_name - widget_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @property {string} parent_url - parent_url
 * @return {LogObject<publicWidgetSuggestedArticlesIWantToReportParams>} LogObject<publicWidgetSuggestedArticlesIWantToReportParams>
 */
export function publicWidgetSuggestedArticlesIWantToReport(params) {
    return { evid: 2250, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicDidThisArticleHelpBannerLoaded' event (evid: 2531)
 *
 * Event description: The event is triggered when a "Did this article help?" banner is loaded while a user is viewing an article. (currently the only flow that should lead to this, is after a user clicks this article in "Article suggestions" section of "Ticket received" Email. (Ticket confirmation))
 *
 * @param {publicDidThisArticleHelpBannerLoadedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @return {LogObject<publicDidThisArticleHelpBannerLoadedParams>} LogObject<publicDidThisArticleHelpBannerLoadedParams>
 */
export function publicDidThisArticleHelpBannerLoaded(params) {
    return { evid: 2531, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicAUserClickOnDidThisArticleHelpBanner' event (evid: 2532)
 *
 * Event description: The event is triggered when a user click "Yes my issue is solved" or "No, I still need help" on "Did this article help?" banner while viewing this article. (currently the only flow that should allow it, is after a user clicks this article in "Article suggestions" section of "Ticket received" Email. (Ticket confirmation))
 *
 * @param {publicAUserClickOnDidThisArticleHelpBannerParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @property {boolean} help_or_not - help_or_not
 * @return {LogObject<publicAUserClickOnDidThisArticleHelpBannerParams>} LogObject<publicAUserClickOnDidThisArticleHelpBannerParams>
 */
export function publicAUserClickOnDidThisArticleHelpBanner(params) {
    return { evid: 2532, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicAccessibilityUserActivityInArticles' event (evid: 2540)
 *
 * Event description: Watching video, expand collapsible and clicking on external links in accessibility articles by article_id.
 *
 * @param {publicAccessibilityUserActivityInArticlesParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} category - category
 * @return {LogObject<publicAccessibilityUserActivityInArticlesParams>} LogObject<publicAccessibilityUserActivityInArticlesParams>
 */
export function publicAccessibilityUserActivityInArticles(params) {
    return { evid: 2540, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devIntegrationsWebhookCalledAttempt' event (evid: 3000)
 *
 * Event description: The server attempted to call a webhook of a certain integration on behalf of a tenant.
 *
 * @param {devIntegrationsWebhookCalledAttemptParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} webhook_type - webhook_type
 * @property {GUID} integration_id - integration_id
 * @property {number} attempt - attempt
 * @return {LogObject<devIntegrationsWebhookCalledAttemptParams>} LogObject<devIntegrationsWebhookCalledAttemptParams>
 */
export function devIntegrationsWebhookCalledAttempt(params) {
    return { evid: 3000, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devIntegrationsWebhookCalledSuccess' event (evid: 3001)
 *
 * Event description: The server successfully called a webhook of a certain integration on behalf of a tenant.
 *
 * @param {devIntegrationsWebhookCalledSuccessParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} webhook_type - webhook_type
 * @property {GUID} integration_id - integration_id
 * @property {number} attempt - attempt
 * @return {LogObject<devIntegrationsWebhookCalledSuccessParams>} LogObject<devIntegrationsWebhookCalledSuccessParams>
 */
export function devIntegrationsWebhookCalledSuccess(params) {
    return { evid: 3001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devIntegrationsWebhookCalledFail' event (evid: 3002)
 *
 * Event description: The server failed to call a webhook of a certain integration on behalf of a tenant.
 *
 * @param {devIntegrationsWebhookCalledFailParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {string} webhook_type - webhook_type
 * @property {GUID} integration_id - integration_id
 * @property {number} attempt - attempt
 * @return {LogObject<devIntegrationsWebhookCalledFailParams>} LogObject<devIntegrationsWebhookCalledFailParams>
 */
export function devIntegrationsWebhookCalledFail(params) {
    return { evid: 3002, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devApiKeysApiAccessByAnApiKeyFail' event (evid: 3012)
 *
 * Event description: An API key of a certain tenant failed to access an API.
 *
 * @param {devApiKeysApiAccessByAnApiKeyFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} error_class - error_class
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} key_id - key_id
 * @property {string} error_type - error_type
 * @property {string} api_end_point - api_end_point
 * @return {LogObject<devApiKeysApiAccessByAnApiKeyFailParams>} LogObject<devApiKeysApiAccessByAnApiKeyFailParams>
 */
export function devApiKeysApiAccessByAnApiKeyFail(params) {
    return { evid: 3012, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingFirstAnonymous' event (evid: 3100)
 *
 * Event description: First anonymous event in Wix Answers
 *
 * @param {marketingFirstAnonymousParams} params - The parameters for this event
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {string} last_referrer - last_referrer
 * @property {string} page_type - page_type
 * @property {Url} page_url - page_url
 * @return {LogObject<marketingFirstAnonymousParams>} LogObject<marketingFirstAnonymousParams>
 */
export function marketingFirstAnonymous(params) {
    return { evid: 3100, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingPageViewSrc77Evid3101' event (evid: 3101)
 *
 * Event description: Page view event in Wix Answers
 *
 * @param {marketingPageViewSrc77Evid3101Params} params - The parameters for this event
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {string} last_referrer - last_referrer
 * @property {string} page_type - page_type
 * @property {Url} page_url - page_url
 * @return {LogObject<marketingPageViewSrc77Evid3101Params>} LogObject<marketingPageViewSrc77Evid3101Params>
 */
export function marketingPageViewSrc77Evid3101(params) {
    return { evid: 3101, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingClick' event (evid: 3102)
 *
 * Event description: Click event in Wix Answers Marketing Site
 *
 * @param {marketingClickParams} params - The parameters for this event
 * @property {string} element_id - element_id
 * @property {string} element_name - element_name
 * @property {GUID} client_id - client_id
 * @property {string} link_to - link_to
 * @property {string} element_type - element_type
 * @property {string} element_label - element_label
 * @property {Url} page_url - page_url
 * @return {LogObject<marketingClickParams>} LogObject<marketingClickParams>
 */
export function marketingClick(params) {
    return { evid: 3102, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsLinkAnArticleToATicket' event (evid: 4001)
 *
 * Event description: Linking an article to a ticket. The uuid in this event id the ID of the user who linked the article.
 *
 * @param {appTicketsLinkAnArticleToATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_by_rule_engine - is_by_rule_engine
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} article_id - article_id
 * @return {LogObject<appTicketsLinkAnArticleToATicketParams>} LogObject<appTicketsLinkAnArticleToATicketParams>
 */
export function appTicketsLinkAnArticleToATicket(params) {
    return { evid: 4001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsRemoveARelatedArticleFromATicket' event (evid: 4002)
 *
 * Event description: Remove a related article from a ticket. The uuid in this event id the ID of the user who removed the article.
 *
 * @param {appTicketsRemoveARelatedArticleFromATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_by_rule_engine - is_by_rule_engine
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} article_id - article_id
 * @return {LogObject<appTicketsRemoveARelatedArticleFromATicketParams>} LogObject<appTicketsRemoveARelatedArticleFromATicketParams>
 */
export function appTicketsRemoveARelatedArticleFromATicket(params) {
    return { evid: 4002, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsMacroAddedToATicket' event (evid: 4003)
 *
 * Event description: Applying a "Macro" within a ticket. The uuid in this event is the ID of the user who applied the Macro.
 *
 * @param {appTicketsMacroAddedToATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} macro_description - macro_description
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} macro_id - macro_id
 * @property {string} actions - actions
 * @property {string} macro_name - macro_name
 * @return {LogObject<appTicketsMacroAddedToATicketParams>} LogObject<appTicketsMacroAddedToATicketParams>
 */
export function appTicketsMacroAddedToATicket(params) {
    return { evid: 4003, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOneInboxTicketsBrandChanged' event (evid: 4007)
 *
 * Event description: Ticket's brand changed or set (by agent - from the info panel)
 *
 * @param {appOneInboxTicketsBrandChangedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} new_brand_id - new_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} new_brand_name - new_brand_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} performed_by - performed_by
 * @property {string} locale - locale
 * @property {GUID} previous_brand_id - previous_brand_id
 * @return {LogObject<appOneInboxTicketsBrandChangedParams>} LogObject<appOneInboxTicketsBrandChangedParams>
 */
export function appOneInboxTicketsBrandChanged(params) {
    return { evid: 4007, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOneInboxTicketSnoozeStart' event (evid: 4008)
 *
 * Event description: A ticket has been snoozed by an Answers member or by the system (Automatic actions, Spotter, Macro). if snooze happens in bulk, the event will be triggered separately for every ticket.
 *
 * @param {appOneInboxTicketSnoozeStartParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} costumer_reply_unsnooze - costumer_reply_unsnooze
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {boolean} change_status_to_open - change_status_to_open
 * @property {GUID} macro_id - macro_id
 * @property {string} operator - operator
 * @property {boolean} send_notification - send_notification
 * @property {GUID} scenario_id - scenario_id
 * @property {DateTime} snooze_time - snooze_time
 * @return {LogObject<appOneInboxTicketSnoozeStartParams>} LogObject<appOneInboxTicketSnoozeStartParams>
 */
export function appOneInboxTicketSnoozeStart(params) {
    return { evid: 4008, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOneInboxTicketSnoozeUpdate' event (evid: 4010)
 *
 * Event description: A ticket snooze time has been updated
 *
 * @param {appOneInboxTicketSnoozeUpdateParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} costumer_reply_unsnooze - costumer_reply_unsnooze
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {boolean} change_status_to_open - change_status_to_open
 * @property {DateTime} snooze_time_after - snooze_time_after
 * @property {boolean} send_notification - send_notification
 * @property {DateTime} snooze_time_before - snooze_time_before
 * @return {LogObject<appOneInboxTicketSnoozeUpdateParams>} LogObject<appOneInboxTicketSnoozeUpdateParams>
 */
export function appOneInboxTicketSnoozeUpdate(params) {
    return { evid: 4010, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsAutomaticActionsTriggeredByRuleExecutor' event (evid: 4011)
 *
 * Event description: Will be triggered each time rule executor is applied on a specific ticket (rule executor is "going over" the automatic actions rules defined in the system and triggering actions accordingly on the ticket)
 *
 * @param {appTicketsAutomaticActionsTriggeredByRuleExecutorParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} total_execution_time - total_execution_time
 * @property {number} total_actions_triggered - total_triggered_actions
 * @property {number} total_rules_triggered - total_triggered_rules
 * @return {LogObject<appTicketsAutomaticActionsTriggeredByRuleExecutorParams>} LogObject<appTicketsAutomaticActionsTriggeredByRuleExecutorParams>
 */
export function appTicketsAutomaticActionsTriggeredByRuleExecutor(params) {
    return { evid: 4011, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOneInboxPrimaryTicketMerge' event (evid: 4013)
 *
 * Event description: 1 ticket or more has been merged to Primary ticket.
 *
 * @param {appOneInboxPrimaryTicketMergeParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {DateTime} ticket_creation_date - ticket_creation_date
 * @property {number} tickets_merged_count - tickets_merged_count
 * @property {string} articles - articles
 * @property {number} replies_count - replies_count
 * @property {GUID} client_id - client_id
 * @property {GUID} merge_id - merge_id
 * @property {GUID} user_id - uuid
 * @property {string} labels - labels
 * @property {GUID} ticket_creator_id - ticket_creator_id
 * @property {string} title - title
 * @return {LogObject<appOneInboxPrimaryTicketMergeParams>} LogObject<appOneInboxPrimaryTicketMergeParams>
 */
export function appOneInboxPrimaryTicketMerge(params) {
    return { evid: 4013, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOneInboxSecondaryTicketMerge' event (evid: 4014)
 *
 * Event description: A ticket has been merged as Secondary ticket to a primary ticket. if a few secondary tickets has been merged in bulk, this event will be fired for each one of them separately.
 *
 * @param {appOneInboxSecondaryTicketMergeParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {DateTime} ticket_creation_date - ticket_creation_date
 * @property {string} articles - articles
 * @property {number} replies_count - replies_count
 * @property {GUID} client_id - client_id
 * @property {GUID} merge_id - merge_id
 * @property {GUID} user_id - uuid
 * @property {string} labels - labels
 * @property {GUID} ticket_creator_id - ticket_creator_id
 * @property {string} title - title
 * @return {LogObject<appOneInboxSecondaryTicketMergeParams>} LogObject<appOneInboxSecondaryTicketMergeParams>
 */
export function appOneInboxSecondaryTicketMerge(params) {
    return { evid: 4014, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTeamAMemberHasBeenAddedToAGroup' event (evid: 4200)
 *
 * Event description: A member has been added to one of the tenant's groups. note that this action can be triggered from several action sources (settings > team members, Control room etc.)
 *
 * @param {appTeamAMemberHasBeenAddedToAGroupParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} group_name - group_name
 * @property {string} member_name - member_name
 * @property {GUID} member_id - member_id
 * @return {LogObject<appTeamAMemberHasBeenAddedToAGroupParams>} LogObject<appTeamAMemberHasBeenAddedToAGroupParams>
 */
export function appTeamAMemberHasBeenAddedToAGroup(params) {
    return { evid: 4200, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTeamAMemberHasBeenRemovedFromAGroup' event (evid: 4201)
 *
 * Event description: A member has been removed from one of the tenant's groups. note that this action can be triggered from several action sources (settings > team members, Control room etc.)
 *
 * @param {appTeamAMemberHasBeenRemovedFromAGroupParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} group_name - group_name
 * @property {string} member_name - member_name
 * @property {GUID} member_id - member_id
 * @return {LogObject<appTeamAMemberHasBeenRemovedFromAGroupParams>} LogObject<appTeamAMemberHasBeenRemovedFromAGroupParams>
 */
export function appTeamAMemberHasBeenRemovedFromAGroup(params) {
    return { evid: 4201, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsRegisterIntegrationAttempt' event (evid: 4400)
 *
 * Event description: The user is attempting to register (install) an integration on the tenant.
 *
 * @param {appSettingsIntegrationsRegisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<appSettingsIntegrationsRegisterIntegrationAttemptParams>} LogObject<appSettingsIntegrationsRegisterIntegrationAttemptParams>
 */
export function appSettingsIntegrationsRegisterIntegrationAttempt(params) {
    return { evid: 4400, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsRegisterIntegrationSuccess' event (evid: 4401)
 *
 * Event description: The user successfully registered (installed) an integration on the tenant.
 *
 * @param {appSettingsIntegrationsRegisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<appSettingsIntegrationsRegisterIntegrationSuccessParams>} LogObject<appSettingsIntegrationsRegisterIntegrationSuccessParams>
 */
export function appSettingsIntegrationsRegisterIntegrationSuccess(params) {
    return { evid: 4401, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsRegisterIntegrationFail' event (evid: 4402)
 *
 * Event description: The user failed to register (install) an integration on the tenant.
 *
 * @param {appSettingsIntegrationsRegisterIntegrationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<appSettingsIntegrationsRegisterIntegrationFailParams>} LogObject<appSettingsIntegrationsRegisterIntegrationFailParams>
 */
export function appSettingsIntegrationsRegisterIntegrationFail(params) {
    return { evid: 4402, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsUnregisterIntegrationAttempt' event (evid: 4403)
 *
 * Event description: The user is attempting to unregister (remove) an integration from the tenant.
 *
 * @param {appSettingsIntegrationsUnregisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<appSettingsIntegrationsUnregisterIntegrationAttemptParams>} LogObject<appSettingsIntegrationsUnregisterIntegrationAttemptParams>
 */
export function appSettingsIntegrationsUnregisterIntegrationAttempt(params) {
    return { evid: 4403, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsUnregisterIntegrationSuccess' event (evid: 4404)
 *
 * Event description: The user successfully unregistered (removed) an integration from the tenant.
 *
 * @param {appSettingsIntegrationsUnregisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<appSettingsIntegrationsUnregisterIntegrationSuccessParams>} LogObject<appSettingsIntegrationsUnregisterIntegrationSuccessParams>
 */
export function appSettingsIntegrationsUnregisterIntegrationSuccess(params) {
    return { evid: 4404, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsUnregisterIntegrationFail' event (evid: 4405)
 *
 * Event description: The user failed to unregister (remove) an integration from the tenant.
 *
 * @param {appSettingsIntegrationsUnregisterIntegrationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<appSettingsIntegrationsUnregisterIntegrationFailParams>} LogObject<appSettingsIntegrationsUnregisterIntegrationFailParams>
 */
export function appSettingsIntegrationsUnregisterIntegrationFail(params) {
    return { evid: 4405, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsMacrosMacroCreated' event (evid: 4406)
 *
 * Event description: Macro has been created in the system
 *
 * @param {appSettingsMacrosMacroCreatedParams} params - The parameters for this event
 * @property {string} macro_description - macro_description
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} macro_id - macro_id
 * @property {string} actions - actions
 * @property {string} macro_name - macro_name
 * @return {LogObject<appSettingsMacrosMacroCreatedParams>} LogObject<appSettingsMacrosMacroCreatedParams>
 */
export function appSettingsMacrosMacroCreated(params) {
    return { evid: 4406, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsMacrosMacroEdited' event (evid: 4407)
 *
 * Event description: Macros has been edited
 *
 * @param {appSettingsMacrosMacroEditedParams} params - The parameters for this event
 * @property {string} macro_description - macro_description
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} macro_id - macro_id
 * @property {string} actions - actions
 * @property {string} macro_name - macro_name
 * @return {LogObject<appSettingsMacrosMacroEditedParams>} LogObject<appSettingsMacrosMacroEditedParams>
 */
export function appSettingsMacrosMacroEdited(params) {
    return { evid: 4407, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsMacrosMacroDeleted' event (evid: 4408)
 *
 * Event description: Macros has been deleted
 *
 * @param {appSettingsMacrosMacroDeletedParams} params - The parameters for this event
 * @property {string} macro_description - macro_description
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} macro_id - macro_id
 * @property {string} actions - actions
 * @property {string} macro_name - macro_name
 * @return {LogObject<appSettingsMacrosMacroDeletedParams>} LogObject<appSettingsMacrosMacroDeletedParams>
 */
export function appSettingsMacrosMacroDeleted(params) {
    return { evid: 4408, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsMacrosMacroActivateDeactivate' event (evid: 4409)
 *
 * Event description: Macros has been activate or deactivate
 *
 * @param {appSettingsMacrosMacroActivateDeactivateParams} params - The parameters for this event
 * @property {string} macro_description - macro_description
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {boolean} status_type - status_type
 * @property {GUID} user_id - uuid
 * @property {GUID} macro_id - macro_id
 * @property {string} actions - actions
 * @property {string} macro_name - macro_name
 * @return {LogObject<appSettingsMacrosMacroActivateDeactivateParams>} LogObject<appSettingsMacrosMacroActivateDeactivateParams>
 */
export function appSettingsMacrosMacroActivateDeactivate(params) {
    return { evid: 4409, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterWaitingInQueueNoAgentsSettingsChange' event (evid: 4410)
 *
 * Event description: Call Center "Waiting in Queue When there is no agents” Queue settings of a specific queue has been changed
 *
 * @param {appSettingsCallCenterWaitingInQueueNoAgentsSettingsChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} action_name - action_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {string} locale - locale
 * @property {string} play_type_name - play_type_name
 * @property {string} queue_name - queue_name
 * @return {LogObject<appSettingsCallCenterWaitingInQueueNoAgentsSettingsChangeParams>} LogObject<appSettingsCallCenterWaitingInQueueNoAgentsSettingsChangeParams>
 */
export function appSettingsCallCenterWaitingInQueueNoAgentsSettingsChange(params) {
    return { evid: 4410, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterQueueBusinessHoursChange' event (evid: 4411)
 *
 * Event description: Queue Business hours settings has been changed
 *
 * @param {appSettingsCallCenterQueueBusinessHoursChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} action_name - action_name
 * @property {boolean} is_custom - is_custom
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {string} locale - locale
 * @property {string} play_type_name - play_type_name
 * @property {string} business_hours - business_hours
 * @property {string} queue_name - queue_name
 * @return {LogObject<appSettingsCallCenterQueueBusinessHoursChangeParams>} LogObject<appSettingsCallCenterQueueBusinessHoursChangeParams>
 */
export function appSettingsCallCenterQueueBusinessHoursChange(params) {
    return { evid: 4411, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterWaitingInQueueWaitingAndHoldSettingsChange' event (evid: 4412)
 *
 * Event description: Call Center "Waiting and Hold” Queue settings of a specific queue has been changed
 *
 * @param {appSettingsCallCenterWaitingInQueueWaitingAndHoldSettingsChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} queue_wait_offers_thresholds - queue_wait_offers_thresholds
 * @property {boolean} is_suggest_offer_options_enabled - is_suggest_offer_options_enabled
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {string} locale - locale
 * @property {string} play_type_name - play_type_name
 * @property {string} queue_wait_offer_options - queue_wait_offer_options
 * @property {string} queue_name - queue_name
 * @return {LogObject<appSettingsCallCenterWaitingInQueueWaitingAndHoldSettingsChangeParams>} LogObject<appSettingsCallCenterWaitingInQueueWaitingAndHoldSettingsChangeParams>
 */
export function appSettingsCallCenterWaitingInQueueWaitingAndHoldSettingsChange(params) {
    return { evid: 4412, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsRolesRoleCreated' event (evid: 4413)
 *
 * Event description: A new role has been created in Answers App.
 *
 * @param {appSettingsRolesRoleCreatedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} permissions - permissions
 * @property {GUID} role_id - role_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} role_name - role_name
 * @return {LogObject<appSettingsRolesRoleCreatedParams>} LogObject<appSettingsRolesRoleCreatedParams>
 */
export function appSettingsRolesRoleCreated(params) {
    return { evid: 4413, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsRolesRoleChanged' event (evid: 4414)
 *
 * Event description: A role has been changed in Answers App.
 *
 * @param {appSettingsRolesRoleChangedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} role_id - role_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} permissions_before - permissions_before
 * @property {string} permissions_after - permissions_after
 * @return {LogObject<appSettingsRolesRoleChangedParams>} LogObject<appSettingsRolesRoleChangedParams>
 */
export function appSettingsRolesRoleChanged(params) {
    return { evid: 4414, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsRolesRoleHasBeenDeleted' event (evid: 4415)
 *
 * Event description: A role has been deleted from Answers App.
 *
 * @param {appSettingsRolesRoleHasBeenDeletedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} role_id - role_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appSettingsRolesRoleHasBeenDeletedParams>} LogObject<appSettingsRolesRoleHasBeenDeletedParams>
 */
export function appSettingsRolesRoleHasBeenDeleted(params) {
    return { evid: 4415, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsRolesTeamMemberRoleHasBeenChanged' event (evid: 4416)
 *
 * Event description: A team member role has been changed in Answers
 *
 * @param {appSettingsRolesTeamMemberRoleHasBeenChangedParams} params - The parameters for this event
 * @property {GUID} role_id_before - role_id_before
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} role_id_after - role_id_after
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} source_page - source_page
 * @return {LogObject<appSettingsRolesTeamMemberRoleHasBeenChangedParams>} LogObject<appSettingsRolesTeamMemberRoleHasBeenChangedParams>
 */
export function appSettingsRolesTeamMemberRoleHasBeenChanged(params) {
    return { evid: 4416, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterANewTeamMemberHasBeenAssignedToQueue' event (evid: 4417)
 *
 * Event description: A new team member has been assigned to get priority in a specific queue. (In calls, if there is more than one agent available, the agent whose queue priority is the highest will be prioritized to get the call)
 *
 * @param {appSettingsCallCenterANewTeamMemberHasBeenAssignedToQueueParams} params - The parameters for this event
 * @property {number} priority - priority
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {GUID} assigned_user_id - assigned_user_id
 * @return {LogObject<appSettingsCallCenterANewTeamMemberHasBeenAssignedToQueueParams>} LogObject<appSettingsCallCenterANewTeamMemberHasBeenAssignedToQueueParams>
 */
export function appSettingsCallCenterANewTeamMemberHasBeenAssignedToQueue(params) {
    return { evid: 4417, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterATeamMemberPriorityInQueueHasBeenChanged' event (evid: 4418)
 *
 * Event description: The priority of a member who is assigned to a queue has been changed. (In calls, if there is more than one agent available, the agent whose queue priority is the highest will be prioritised to get the call)
 *
 * @param {appSettingsCallCenterATeamMemberPriorityInQueueHasBeenChangedParams} params - The parameters for this event
 * @property {number} priority - priority
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {GUID} assigned_user_id - assigned_user_id
 * @return {LogObject<appSettingsCallCenterATeamMemberPriorityInQueueHasBeenChangedParams>} LogObject<appSettingsCallCenterATeamMemberPriorityInQueueHasBeenChangedParams>
 */
export function appSettingsCallCenterATeamMemberPriorityInQueueHasBeenChanged(params) {
    return { evid: 4418, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterATeamMemberHasBeenRemovedUnassignedFromQueue' event (evid: 4419)
 *
 * Event description: A member who was assigned to a queue has been removed from being assigned to this queue and therefore will no longer be prioritized in this queue. (In calls, if there is more than one agent available, the agent whose queue priority is the highest will be prioritized to get the call)
 *
 * @param {appSettingsCallCenterATeamMemberHasBeenRemovedUnassignedFromQueueParams} params - The parameters for this event
 * @property {GUID} assigned_member_id - assigned_member_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {GUID} assigned_user_id - assigned_user_id
 * @return {LogObject<appSettingsCallCenterATeamMemberHasBeenRemovedUnassignedFromQueueParams>} LogObject<appSettingsCallCenterATeamMemberHasBeenRemovedUnassignedFromQueueParams>
 */
export function appSettingsCallCenterATeamMemberHasBeenRemovedUnassignedFromQueue(params) {
    return { evid: 4419, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsWidgetLiveChatSettingsChange' event (evid: 4420)
 *
 * Event description: Widget Live Chat Settings has been updated - this event will be triggered whenever there is a change in one of the Widget's Live Chat Settings
 *
 * @param {appSettingsWidgetLiveChatSettingsChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} widget_id - widget_id
 * @property {string} settings_before - settings_before
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {string} settings_after - settings_after
 * @return {LogObject<appSettingsWidgetLiveChatSettingsChangeParams>} LogObject<appSettingsWidgetLiveChatSettingsChangeParams>
 */
export function appSettingsWidgetLiveChatSettingsChange(params) {
    return { evid: 4420, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyEnabledDisabledByLanguage' event (evid: 4421)
 *
 * Event description: A language has been enabled or disabled from sending a survey (change is done by a toggle)
 *
 * @param {appSettingsCsatSurveyEnabledDisabledByLanguageParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {boolean} survey_enabled - survey_enabled
 * @return {LogObject<appSettingsCsatSurveyEnabledDisabledByLanguageParams>} LogObject<appSettingsCsatSurveyEnabledDisabledByLanguageParams>
 */
export function appSettingsCsatSurveyEnabledDisabledByLanguage(params) {
    return { evid: 4421, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyEnabledDisabledByChannel' event (evid: 4422)
 *
 * Event description: A channel has been enabled or disabled from sending a survey (change is done by a toggle)
 *
 * @param {appSettingsCsatSurveyEnabledDisabledByChannelParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} channel_enabled - channel_enabled
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {string} csat_channel - csat_channel
 * @return {LogObject<appSettingsCsatSurveyEnabledDisabledByChannelParams>} LogObject<appSettingsCsatSurveyEnabledDisabledByChannelParams>
 */
export function appSettingsCsatSurveyEnabledDisabledByChannel(params) {
    return { evid: 4422, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyContentChange' event (evid: 4423)
 *
 * Event description: A content of a survey has been changed
 *
 * @param {appSettingsCsatSurveyContentChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} response_data - response_data
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {string} survey_title - survey_title
 * @property {string} thank_you_message - thank_you_message
 * @property {boolean} comment_option - comment_option
 * @return {LogObject<appSettingsCsatSurveyContentChangeParams>} LogObject<appSettingsCsatSurveyContentChangeParams>
 */
export function appSettingsCsatSurveyContentChange(params) {
    return { evid: 4423, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyDelayTimeChange' event (evid: 4424)
 *
 * Event description: The time that should pass from the moment the ticket status had changed to ‘Solved’ and until the survey is sent has been changed
 *
 * @param {appSettingsCsatSurveyDelayTimeChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {number} delay_after - delay_after
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} delay_before - delay_before
 * @return {LogObject<appSettingsCsatSurveyDelayTimeChangeParams>} LogObject<appSettingsCsatSurveyDelayTimeChangeParams>
 */
export function appSettingsCsatSurveyDelayTimeChange(params) {
    return { evid: 4424, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyThrottlingTimeChange' event (evid: 4425)
 *
 * Event description: The time that should pass from the moment a customer had submitted the survey and before a new survey can be sent for the same ticket has been changed
 *
 * @param {appSettingsCsatSurveyThrottlingTimeChangeParams} params - The parameters for this event
 * @property {number} time_after - time_after
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} time_before - time_before
 * @return {LogObject<appSettingsCsatSurveyThrottlingTimeChangeParams>} LogObject<appSettingsCsatSurveyThrottlingTimeChangeParams>
 */
export function appSettingsCsatSurveyThrottlingTimeChange(params) {
    return { evid: 4425, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyInvitationMessageChange' event (evid: 4427)
 *
 * Event description: Survey invitation message of one of the relevant channels (currently Facebook or Whatsapp) has been changed
 *
 * @param {appSettingsCsatSurveyInvitationMessageChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {string} invitation_message_before - invitation_message_before
 * @property {string} invitation_message_after - invitation_message_after
 * @property {string} csat_channel - csat_channel
 * @return {LogObject<appSettingsCsatSurveyInvitationMessageChangeParams>} LogObject<appSettingsCsatSurveyInvitationMessageChangeParams>
 */
export function appSettingsCsatSurveyInvitationMessageChange(params) {
    return { evid: 4427, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSlaPolicyCreate' event (evid: 4428)
 *
 * Event description: A new SLA policy has been created
 *
 * @param {appSettingsSlaPolicyCreateParams} params - The parameters for this event
 * @property {string} policy_activity_hours - policy_activity_hours
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} policy_id - policy_id
 * @property {string} ticket_create_conditions - ticket_create_conditions
 * @property {string} policy_time_targets - policy_time_targets
 * @property {GUID} client_id - client_id
 * @property {string} time_zone_type - time_zone_type
 * @property {GUID} user_id - uuid
 * @property {string} triggers - triggers
 * @property {boolean} is_reset_resolution_time - user_resolution_reset
 * @property {string} policy_name - policy_name
 * @property {string} policy_description - policy_description
 * @property {string} breach_rules - breach_rules
 * @property {string} ticket_assign_conditions - ticket_assign_conditions
 * @property {boolean} is_reset_first_reply_time - time_targets_reset
 * @return {LogObject<appSettingsSlaPolicyCreateParams>} LogObject<appSettingsSlaPolicyCreateParams>
 */
export function appSettingsSlaPolicyCreate(params) {
    return { evid: 4428, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSlaPolicyUpdate' event (evid: 4429)
 *
 * Event description: SLA policy has been updated
 *
 * @param {appSettingsSlaPolicyUpdateParams} params - The parameters for this event
 * @property {string} policy_activity_hours - policy_activity_hours
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} policy_id - policy_id
 * @property {string} ticket_create_conditions - ticket_create_conditions
 * @property {string} policy_time_targets - policy_time_targets
 * @property {GUID} client_id - client_id
 * @property {string} time_zone_type - time_zone_type
 * @property {GUID} user_id - uuid
 * @property {string} triggers - triggers
 * @property {boolean} is_reset_resolution_time - is_reset_resolution_time
 * @property {string} policy_name - policy_name
 * @property {string} policy_description - policy_description
 * @property {string} breach_rules - breach_rules
 * @property {string} ticket_assign_conditions - ticket_assign_conditions
 * @property {boolean} is_reset_first_reply_time - is_reset_first_reply_time
 * @return {LogObject<appSettingsSlaPolicyUpdateParams>} LogObject<appSettingsSlaPolicyUpdateParams>
 */
export function appSettingsSlaPolicyUpdate(params) {
    return { evid: 4429, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSlaPolicyDelete' event (evid: 4430)
 *
 * Event description: SLA policy has been deleted
 *
 * @param {appSettingsSlaPolicyDeleteParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} policy_id - policy_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} policy_name - policy_name
 * @property {string} policy_description - policy_description
 * @return {LogObject<appSettingsSlaPolicyDeleteParams>} LogObject<appSettingsSlaPolicyDeleteParams>
 */
export function appSettingsSlaPolicyDelete(params) {
    return { evid: 4430, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSlaPolicyActivatedOrDeactivated' event (evid: 4431)
 *
 * Event description: SLA policy has been activated or deactivated
 *
 * @param {appSettingsSlaPolicyActivatedOrDeactivatedParams} params - The parameters for this event
 * @property {boolean} is_active - is_active
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} policy_id - policy_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} policy_name - policy_name
 * @property {string} policy_description - policy_description
 * @return {LogObject<appSettingsSlaPolicyActivatedOrDeactivatedParams>} LogObject<appSettingsSlaPolicyActivatedOrDeactivatedParams>
 */
export function appSettingsSlaPolicyActivatedOrDeactivated(params) {
    return { evid: 4431, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsAutoRoutingChannelsEnabled' event (evid: 4432)
 *
 * Event description: The user enabled auto-routing for a specific channel
 *
 * @param {appSettingsAutoRoutingChannelsEnabledParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel_name - channel_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} channel_id - channel_id
 * @return {LogObject<appSettingsAutoRoutingChannelsEnabledParams>} LogObject<appSettingsAutoRoutingChannelsEnabledParams>
 */
export function appSettingsAutoRoutingChannelsEnabled(params) {
    return { evid: 4432, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsAutoRoutingChannelDisabled' event (evid: 4433)
 *
 * Event description: The user disabled auto-routing for a specific channel
 *
 * @param {appSettingsAutoRoutingChannelDisabledParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel_name - channel_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} channel_id - channel_id
 * @return {LogObject<appSettingsAutoRoutingChannelDisabledParams>} LogObject<appSettingsAutoRoutingChannelDisabledParams>
 */
export function appSettingsAutoRoutingChannelDisabled(params) {
    return { evid: 4433, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsAutoRoutingGroupAdded' event (evid: 4434)
 *
 * Event description: App (Settings) - Auto Routing - Group Added.
 *
 * @param {appSettingsAutoRoutingGroupAddedParams} params - The parameters for this event
 * @property {string} method - method
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appSettingsAutoRoutingGroupAddedParams>} LogObject<appSettingsAutoRoutingGroupAddedParams>
 */
export function appSettingsAutoRoutingGroupAdded(params) {
    return { evid: 4434, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsAutoRoutingGroupRemoved' event (evid: 4435)
 *
 * Event description: App (Settings) - Auto Routing - Group Removed.
 *
 * @param {appSettingsAutoRoutingGroupRemovedParams} params - The parameters for this event
 * @property {string} method - method
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appSettingsAutoRoutingGroupRemovedParams>} LogObject<appSettingsAutoRoutingGroupRemovedParams>
 */
export function appSettingsAutoRoutingGroupRemoved(params) {
    return { evid: 4435, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSpotterScenarioCreate' event (evid: 4436)
 *
 * Event description: A Spotter Scenario has been created
 *
 * @param {appSettingsSpotterScenarioCreateParams} params - The parameters for this event
 * @property {number} recipe_type - recipe_type
 * @property {GUID} tenant_id - tenant_id
 * @property {string} display_name - display_name
 * @property {GUID} role_id - role_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} actions_data - actions_data
 * @property {string} conditions_data - conditions_data
 * @property {string} triggers_data - triggers_data
 * @property {GUID} recipe_id - recipe_id
 * @return {LogObject<appSettingsSpotterScenarioCreateParams>} LogObject<appSettingsSpotterScenarioCreateParams>
 */
export function appSettingsSpotterScenarioCreate(params) {
    return { evid: 4436, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSpotterScenarioUpdate' event (evid: 4437)
 *
 * Event description: A Spotter Scenario has been updated
 *
 * @param {appSettingsSpotterScenarioUpdateParams} params - The parameters for this event
 * @property {number} recipe_type - recipe_type
 * @property {GUID} tenant_id - tenant_id
 * @property {string} triggers_data_after - triggers_data_after
 * @property {string} triggers_data_before - triggers_data_before
 * @property {string} conditions_data_after - conditions_data_after
 * @property {GUID} role_id - role_id
 * @property {string} conditions_data_before - conditions_data_before
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} actions_data_before - actions_data_before
 * @property {string} actions_data - actions_data
 * @property {string} actions_data_after - actions_data_after
 * @property {string} conditions_data - conditions_data
 * @property {string} triggers_data - triggers_data
 * @property {GUID} recipe_id - recipe_id
 * @return {LogObject<appSettingsSpotterScenarioUpdateParams>} LogObject<appSettingsSpotterScenarioUpdateParams>
 */
export function appSettingsSpotterScenarioUpdate(params) {
    return { evid: 4437, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsActivateDeactivateLineForCallCenterOrSms' event (evid: 4441)
 *
 * Event description: A line has been activated or deactivated for Incoming or Outgoing traffic  (or both) for Call Center or SMS
 *
 * @param {appSettingsActivateDeactivateLineForCallCenterOrSmsParams} params - The parameters for this event
 * @property {string} line_name - line_name
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {boolean} is_sms_capable - is_sms_capable
 * @property {boolean} is_default_sms - is_default_sms
 * @property {boolean} outbound_enabled - outbound_enabled
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} line_id - line_id
 * @property {boolean} inbound_enabled - inbound_enabled
 * @property {boolean} is_default_call_center - is_default_call_center
 * @return {LogObject<appSettingsActivateDeactivateLineForCallCenterOrSmsParams>} LogObject<appSettingsActivateDeactivateLineForCallCenterOrSmsParams>
 */
export function appSettingsActivateDeactivateLineForCallCenterOrSms(params) {
    return { evid: 4441, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsLineAdded' event (evid: 4442)
 *
 * Event description: A line has been added to Answers account
 *
 * @param {appSettingsLineAddedParams} params - The parameters for this event
 * @property {string} line_name - line_name
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_sms_capable - is_sms_capable
 * @property {string} line_country - line_country
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} line_description - line_description
 * @property {string} line_number - line_number
 * @property {GUID} line_id - line_id
 * @property {boolean} is_default_call_center - is_default_call_center
 * @return {LogObject<appSettingsLineAddedParams>} LogObject<appSettingsLineAddedParams>
 */
export function appSettingsLineAdded(params) {
    return { evid: 4442, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsLineBusinessHoursChange' event (evid: 4443)
 *
 * Event description: A line business hours has been changed
 *
 * @param {appSettingsLineBusinessHoursChangeParams} params - The parameters for this event
 * @property {string} line_name - line_name
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_sms_capable - is_sms_capable
 * @property {boolean} is_default_sms - is_default_sms
 * @property {GUID} client_id - client_id
 * @property {string} after_business_hours - after_business_hours
 * @property {GUID} user_id - uuid
 * @property {GUID} line_id - line_id
 * @property {boolean} is_default_call_center - is_default_call_center
 * @property {string} before_business_hours - before_business_hours
 * @return {LogObject<appSettingsLineBusinessHoursChangeParams>} LogObject<appSettingsLineBusinessHoursChangeParams>
 */
export function appSettingsLineBusinessHoursChange(params) {
    return { evid: 4443, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsLineDelete' event (evid: 4444)
 *
 * Event description: A line has been removed (deleted) from Answers account
 *
 * @param {appSettingsLineDeleteParams} params - The parameters for this event
 * @property {string} line_name - line_name
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} line_id - line_id
 * @return {LogObject<appSettingsLineDeleteParams>} LogObject<appSettingsLineDeleteParams>
 */
export function appSettingsLineDelete(params) {
    return { evid: 4444, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsLineDowntimesChange' event (evid: 4445)
 *
 * Event description: A line Downtimes hours has been changed
 *
 * @param {appSettingsLineDowntimesChangeParams} params - The parameters for this event
 * @property {string} line_name - line_name
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_sms_capable - is_sms_capable
 * @property {string} before_downtimes - before_downtimes
 * @property {boolean} is_default_sms - is_default_sms
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} after_downtimes - after_downtimes
 * @property {GUID} line_id - line_id
 * @property {boolean} is_default_call_center - is_default_call_center
 * @return {LogObject<appSettingsLineDowntimesChangeParams>} LogObject<appSettingsLineDowntimesChangeParams>
 */
export function appSettingsLineDowntimesChange(params) {
    return { evid: 4445, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleCreated' event (evid: 4446)
 *
 * Event description: New schedule created
 *
 * @param {appSettingsScheduleCreatedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - id
 * @property {string} settings - settings
 * @return {LogObject<appSettingsScheduleCreatedParams>} LogObject<appSettingsScheduleCreatedParams>
 */
export function appSettingsScheduleCreated(params) {
    return { evid: 4446, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleDeleted' event (evid: 4447)
 *
 * Event description: A schedule was deleted
 *
 * @param {appSettingsScheduleDeletedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - id
 * @return {LogObject<appSettingsScheduleDeletedParams>} LogObject<appSettingsScheduleDeletedParams>
 */
export function appSettingsScheduleDeleted(params) {
    return { evid: 4447, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleUpdated' event (evid: 4448)
 *
 * Event description: A schedule was updated
 *
 * @param {appSettingsScheduleUpdatedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - id
 * @property {string} settings - settings
 * @return {LogObject<appSettingsScheduleUpdatedParams>} LogObject<appSettingsScheduleUpdatedParams>
 */
export function appSettingsScheduleUpdated(params) {
    return { evid: 4448, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleDownTimeCreated' event (evid: 4449)
 *
 * Event description: Schedule Down Time created
 *
 * @param {appSettingsScheduleDownTimeCreatedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - subscription_id
 * @property {string} schedule_id - schedule_id
 * @property {string} settings - settings
 * @return {LogObject<appSettingsScheduleDownTimeCreatedParams>} LogObject<appSettingsScheduleDownTimeCreatedParams>
 */
export function appSettingsScheduleDownTimeCreated(params) {
    return { evid: 4449, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleDownTimeDeleted' event (evid: 4450)
 *
 * Event description: Schedule Down Time deleted
 *
 * @param {appSettingsScheduleDownTimeDeletedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - id
 * @property {string} schedule_id - schedule_id
 * @return {LogObject<appSettingsScheduleDownTimeDeletedParams>} LogObject<appSettingsScheduleDownTimeDeletedParams>
 */
export function appSettingsScheduleDownTimeDeleted(params) {
    return { evid: 4450, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleDownTimeUpdated' event (evid: 4451)
 *
 * Event description: Schedule Down Time updated
 *
 * @param {appSettingsScheduleDownTimeUpdatedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - id
 * @property {string} schedule_id - schedule_id
 * @property {string} settings - settings
 * @return {LogObject<appSettingsScheduleDownTimeUpdatedParams>} LogObject<appSettingsScheduleDownTimeUpdatedParams>
 */
export function appSettingsScheduleDownTimeUpdated(params) {
    return { evid: 4451, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterCallStarted' event (evid: 4500)
 *
 * Event description: Event is fired when a call in Answers has started (both user and agent are connected to the call).
 * The user_id or client_id in this event is the id of the user (not the agent).
 *
 * @param {appCallCenterCallStartedParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} phone_number - phone_number
 * @property {string} queue - queue
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @return {LogObject<appCallCenterCallStartedParams>} LogObject<appCallCenterCallStartedParams>
 */
export function appCallCenterCallStarted(params) {
    return { evid: 4500, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterCallParticipantJoined' event (evid: 4511)
 *
 * Event description: A participant (user/agent) joined a call.
 * Possible join methods are:
 * 1. Primary - The first agent and/or first user of the call
 * 2. An additional agent or user that was invited
 * 3. An agent who's only listening to the call
 *  If the call was answered, it will have exactly one primary agent and one primary user. All additional participants will have other join methods.
 *  If the call wasn't answered by the recipient, it will only have one primary participant (the participant who initiated the call).
 *
 * @param {appCallCenterCallParticipantJoinedParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_agent - is_agent
 * @property {string} topicId - topic_id
 * @property {GUID} client_id - client_id
 * @property {string} join_method - join_method
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @return {LogObject<appCallCenterCallParticipantJoinedParams>} LogObject<appCallCenterCallParticipantJoinedParams>
 */
export function appCallCenterCallParticipantJoined(params) {
    return { evid: 4511, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterCallParticipantLeft' event (evid: 4512)
 *
 * Event description: A participant Left a call.
 *
 * A participant may leave a call using one of the following methods:
 * 1. The participant left the call
 * 2. The participant ended the call
 * 3. Other participant ended the call - Agent (the other participant is an agent)
 * 4. Other participant ended the call - User (the other participant is a user) .                                  join_method can be fetched via the 4511 event. In this event it will return as NULL
 *
 * @param {appCallCenterCallParticipantLeftParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_agent - is_agent
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {GUID} topic_id - topic_id
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @return {LogObject<appCallCenterCallParticipantLeftParams>} LogObject<appCallCenterCallParticipantLeftParams>
 */
export function appCallCenterCallParticipantLeft(params) {
    return { evid: 4512, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentIsReservedToACallSuccess' event (evid: 4514)
 *
 * Event description: The agent joined the call after being reserved by the system.
 *
 * @param {appCallCenterAgentIsReservedToACallSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} callid - callid
 * @property {boolean} agent_is_callback_delay - agent_is_callback_delay
 * @property {string} type - type
 * @return {LogObject<appCallCenterAgentIsReservedToACallSuccessParams>} LogObject<appCallCenterAgentIsReservedToACallSuccessParams>
 */
export function appCallCenterAgentIsReservedToACallSuccess(params) {
    return { evid: 4514, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentIsReservedToACallFail' event (evid: 4515)
 *
 * Event description: The agent didn't join the call after being reserved by the system.
 *
 * @param {appCallCenterAgentIsReservedToACallFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} callid - callid
 * @property {boolean} agent_is_callback_delay - agent_is_callback_delay
 * @property {string} type - type
 * @return {LogObject<appCallCenterAgentIsReservedToACallFailParams>} LogObject<appCallCenterAgentIsReservedToACallFailParams>
 */
export function appCallCenterAgentIsReservedToACallFail(params) {
    return { evid: 4515, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentIsInvitedToACallAttempt' event (evid: 4516)
 *
 * Event description: An agent is invited to a call by another agent. The user_id in this event is the id of the invited agent.
 *
 * @param {appCallCenterAgentIsInvitedToACallAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @property {GUID} inviting_agent - inviting_agent
 * @return {LogObject<appCallCenterAgentIsInvitedToACallAttemptParams>} LogObject<appCallCenterAgentIsInvitedToACallAttemptParams>
 */
export function appCallCenterAgentIsInvitedToACallAttempt(params) {
    return { evid: 4516, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentIsInvitedToACallSuccess' event (evid: 4517)
 *
 * Event description: The agent joined the call after being invited by another agent. The user_id in this event is the id of the invited agent.
 *
 * @param {appCallCenterAgentIsInvitedToACallSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @return {LogObject<appCallCenterAgentIsInvitedToACallSuccessParams>} LogObject<appCallCenterAgentIsInvitedToACallSuccessParams>
 */
export function appCallCenterAgentIsInvitedToACallSuccess(params) {
    return { evid: 4517, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentIsInvitedToACallFail' event (evid: 4518)
 *
 * Event description: The agent didn't join the call after being invited by another agent. The user_id in this event is the id of the invited agent.
 *
 * @param {appCallCenterAgentIsInvitedToACallFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @return {LogObject<appCallCenterAgentIsInvitedToACallFailParams>} LogObject<appCallCenterAgentIsInvitedToACallFailParams>
 */
export function appCallCenterAgentIsInvitedToACallFail(params) {
    return { evid: 4518, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentPutTheUserOnHold' event (evid: 4519)
 *
 * Event description: An agent put the user on hold during the call. The user_id (uuid) in this event is the id of the agent.
 *
 * @param {appCallCenterAgentPutTheUserOnHoldParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @return {LogObject<appCallCenterAgentPutTheUserOnHoldParams>} LogObject<appCallCenterAgentPutTheUserOnHoldParams>
 */
export function appCallCenterAgentPutTheUserOnHold(params) {
    return { evid: 4519, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentPutTheUserOffHold' event (evid: 4520)
 *
 * Event description: An agent put the user off hold, back to the call. The user_id (uuid) in this event is the id of the agent.
 *
 * @param {appCallCenterAgentPutTheUserOffHoldParams} params - The parameters for this event
 * @property {number} duration - duration
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @return {LogObject<appCallCenterAgentPutTheUserOffHoldParams>} LogObject<appCallCenterAgentPutTheUserOffHoldParams>
 */
export function appCallCenterAgentPutTheUserOffHold(params) {
    return { evid: 4520, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterCallParticipantAdditionRequest' event (evid: 4521)
 *
 * Event description: Answers is asking Twilio to add a participant to the conference. The request is being sent with a time limit for that participant, based on the remaining credit in the account
 *
 * @param {appCallCenterCallParticipantAdditionRequestParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @property {number} duration_limit - duration_limit
 * @return {LogObject<appCallCenterCallParticipantAdditionRequestParams>} LogObject<appCallCenterCallParticipantAdditionRequestParams>
 */
export function appCallCenterCallParticipantAdditionRequest(params) {
    return { evid: 4521, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAddingAgentFromAnotherQueueTransfer' event (evid: 4522)
 *
 * Event description: this event will be triggered when an agent is in a call and need to transfer the call to another agent from another queue.
 *
 * @param {appCallCenterAddingAgentFromAnotherQueueTransferParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} invited_userid - invited_uuid
 * @property {GUID} transferred_queue_id - transferred_queue_id
 * @property {string} call_type - call_type
 * @property {GUID} transferred_group_id - transferred_group_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {GUID} topic_id - topic_id
 * @property {number} transfer_type - transfer_type
 * @property {number} processing_time - processing_time
 * @property {GUID} callid - callid
 * @return {LogObject<appCallCenterAddingAgentFromAnotherQueueTransferParams>} LogObject<appCallCenterAddingAgentFromAnotherQueueTransferParams>
 */
export function appCallCenterAddingAgentFromAnotherQueueTransfer(params) {
    return { evid: 4522, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterTwilioCallAttempt' event (evid: 4523)
 *
 * Event description: Every call in CC is comprised of two calls, from Twilio to the agent and from Twilio to the user. This is when Twilio attempts to call the user/agent.
 *
 * @param {appCallCenterTwilioCallAttemptParams} params - The parameters for this event
 * @property {string} twilio_reservation_id - twilio_reservation_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_agent - is_agent
 * @property {string} phone_country_code - phone_country_code
 * @property {string} twilio_call_sid - twilio_call_sid
 * @property {string} call_type - call_type
 * @property {string} agent_location_id - agent_location_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} auto_routing_assignment_id - auto_routing_assignment_id
 * @property {GUID} callid - callid
 * @return {LogObject<appCallCenterTwilioCallAttemptParams>} LogObject<appCallCenterTwilioCallAttemptParams>
 */
export function appCallCenterTwilioCallAttempt(params) {
    return { evid: 4523, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterTwilioCallWasAnswered' event (evid: 4524)
 *
 * Event description: Every call in CC is comprised of two calls, from Twilio to the agent and from Twilio to the user. This event is for when Twilio call was answered by user/agent.
 *
 * @param {appCallCenterTwilioCallWasAnsweredParams} params - The parameters for this event
 * @property {string} twilio_reservation_id - twilio_reservation_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_agent - is_agent
 * @property {string} phone_country_code - phone_country_code
 * @property {string} twilio_call_sid - twilio_call_sid
 * @property {string} call_type - call_type
 * @property {string} agent_location_id - agent_location_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} auto_routing_assignment_id - auto_routing_assignment_id
 * @property {GUID} callid - callid
 * @return {LogObject<appCallCenterTwilioCallWasAnsweredParams>} LogObject<appCallCenterTwilioCallWasAnsweredParams>
 */
export function appCallCenterTwilioCallWasAnswered(params) {
    return { evid: 4524, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterTwilioCallResolution' event (evid: 4525)
 *
 * Event description: App (Call Center) - Twilio Call Resolution.
 *
 * @param {appCallCenterTwilioCallResolutionParams} params - The parameters for this event
 * @property {string} twilio_reservation_id - twilio_reservation_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_agent - is_agent
 * @property {string} phone_country_code - phone_country_code
 * @property {string} twilio_call_sid - twilio_call_sid
 * @property {string} call_type - call_type
 * @property {string} agent_location_id - agent_location_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} twilio_call_status - twilio_call_status
 * @property {number} call_duration - call_duration
 * @property {number} callcenter_agent_status - callcenter_agent_status
 * @property {number} twilio_callcenter_agent_status - twilio_callcenter_agent_status
 * @property {GUID} auto_routing_assignment_id - auto_routing_assignment_id
 * @property {GUID} callid - callid
 * @return {LogObject<appCallCenterTwilioCallResolutionParams>} LogObject<appCallCenterTwilioCallResolutionParams>
 */
export function appCallCenterTwilioCallResolution(params) {
    return { evid: 4525, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appChatChatRestarted' event (evid: 4600)
 *
 * Event description: A closed chat was restarted by the user
 *
 * @param {appChatChatRestartedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appChatChatRestartedParams>} LogObject<appChatChatRestartedParams>
 */
export function appChatChatRestarted(params) {
    return { evid: 4600, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutRequestAttempt' event (evid: 4800)
 *
 * Event description: User requested to move from the package picker to the purchase page
 *
 * @param {appPremiumPackagePickerCheckoutRequestAttemptParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumPackagePickerCheckoutRequestAttemptParams>} LogObject<appPremiumPackagePickerCheckoutRequestAttemptParams>
 */
export function appPremiumPackagePickerCheckoutRequestAttempt(params) {
    return { evid: 4800, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutRequestSuccess' event (evid: 4801)
 *
 * Event description: The user is redirected from the package picker to the purchase page
 *
 * @param {appPremiumPackagePickerCheckoutRequestSuccessParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumPackagePickerCheckoutRequestSuccessParams>} LogObject<appPremiumPackagePickerCheckoutRequestSuccessParams>
 */
export function appPremiumPackagePickerCheckoutRequestSuccess(params) {
    return { evid: 4801, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutRequestFail' event (evid: 4802)
 *
 * Event description: User request to move from the package picker to the purchase page was rejected
 *
 * @param {appPremiumPackagePickerCheckoutRequestFailParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumPackagePickerCheckoutRequestFailParams>} LogObject<appPremiumPackagePickerCheckoutRequestFailParams>
 */
export function appPremiumPackagePickerCheckoutRequestFail(params) {
    return { evid: 4802, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPremiumProductCreation' event (evid: 4803)
 *
 * Event description: A premium product was delivered to a tenant (was added to the tenant_products table) after payment accepted in SBS. UUID in this event is the ID of the user who ordered the product.
 *
 * @param {appPremiumPremiumProductCreationParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} feature - feature
 * @property {GUID} product_guid - product_guid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} team_size - team_size
 * @property {GUID} subscription_id - subscription_id
 * @return {LogObject<appPremiumPremiumProductCreationParams>} LogObject<appPremiumPremiumProductCreationParams>
 */
export function appPremiumPremiumProductCreation(params) {
    return { evid: 4803, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPremiumProductCancellation' event (evid: 4804)
 *
 * Event description: A premium product was cancelled. UUID in this event is the tenant ID.
 *
 * @param {appPremiumPremiumProductCancellationParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} feature - feature
 * @property {GUID} product_guid - product_guid
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {string} team_size - team_size
 * @property {GUID} subscription_id - subscription_id
 * @return {LogObject<appPremiumPremiumProductCancellationParams>} LogObject<appPremiumPremiumProductCancellationParams>
 */
export function appPremiumPremiumProductCancellation(params) {
    return { evid: 4804, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumProductSubscriptionRenewalSuccess' event (evid: 4805)
 *
 * Event description: A premium product's subscription was renewed. UUID in this event is the tenant ID.
 *
 * @param {appPremiumProductSubscriptionRenewalSuccessParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} feature - feature
 * @property {GUID} product_guid - product_guid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} team_size - team_size
 * @property {GUID} subscription_id - subscription_id
 * @property {DateTime} expiry_date - expiry_date
 * @return {LogObject<appPremiumProductSubscriptionRenewalSuccessParams>} LogObject<appPremiumProductSubscriptionRenewalSuccessParams>
 */
export function appPremiumProductSubscriptionRenewalSuccess(params) {
    return { evid: 4805, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumProductSubscriptionRenewalFail' event (evid: 4806)
 *
 * Event description: SBS wasn't able to renew the subscription of a premium product. UUID in this event is the tenant ID.
 *
 * @param {appPremiumProductSubscriptionRenewalFailParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} feature - feature
 * @property {GUID} product_guid - product_guid
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {string} team_size - team_size
 * @property {GUID} subscription_id - subscription_id
 * @return {LogObject<appPremiumProductSubscriptionRenewalFailParams>} LogObject<appPremiumProductSubscriptionRenewalFailParams>
 */
export function appPremiumProductSubscriptionRenewalFail(params) {
    return { evid: 4806, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumProductAutoRenewOn' event (evid: 4807)
 *
 * Event description: Tenant's auto-renewal status was toggled on. UUID in this event is the tenant ID.
 *
 * @param {appPremiumProductAutoRenewOnParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} feature - feature
 * @property {GUID} product_guid - product_guid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} team_size - team_size
 * @property {GUID} subscription_id - subscription_id
 * @return {LogObject<appPremiumProductAutoRenewOnParams>} LogObject<appPremiumProductAutoRenewOnParams>
 */
export function appPremiumProductAutoRenewOn(params) {
    return { evid: 4807, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumProductAutoRenewOff' event (evid: 4808)
 *
 * Event description: Tenant's auto-renewal status was toggled off. UUID in this event is the tenant ID.
 *
 * @param {appPremiumProductAutoRenewOffParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} feature - feature
 * @property {GUID} product_guid - product_guid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} team_size - team_size
 * @property {GUID} subscription_id - subscription_id
 * @return {LogObject<appPremiumProductAutoRenewOffParams>} LogObject<appPremiumProductAutoRenewOffParams>
 */
export function appPremiumProductAutoRenewOff(params) {
    return { evid: 4808, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumOverrideTeamSize' event (evid: 4809)
 *
 * Event description: Answers team overridden the team size of a premium product. UUID in this event is the Answers User ID of the person (from Answers team) who made the override
 *
 * @param {appPremiumOverrideTeamSizeParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} override_team_size - override_team_size
 * @property {string} feature - feature
 * @property {GUID} product_guid - product_guid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} team_size - team_size
 * @property {GUID} subscription_id - subscription_id
 * @return {LogObject<appPremiumOverrideTeamSizeParams>} LogObject<appPremiumOverrideTeamSizeParams>
 */
export function appPremiumOverrideTeamSize(params) {
    return { evid: 4809, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumOverrideProductExpiryDate' event (evid: 4810)
 *
 * Event description: Answers team overridden the expiry date of a premium product. UUID in this event is the Answers User ID of the person (from Answers team) who made the override
 *
 * @param {appPremiumOverrideProductExpiryDateParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} feature - feature
 * @property {GUID} product_guid - product_guid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} team_size - team_size
 * @property {GUID} subscription_id - subscription_id
 * @property {DateTime} expiry_date - expiry_date
 * @return {LogObject<appPremiumOverrideProductExpiryDateParams>} LogObject<appPremiumOverrideProductExpiryDateParams>
 */
export function appPremiumOverrideProductExpiryDate(params) {
    return { evid: 4810, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseAttemptSrc77Evid4811' event (evid: 4811)
 *
 * Event description: User requests to purchase a premium
 *
 * @param {appPremiumPackagePickerPurchaseAttemptSrc77Evid4811Params} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumPackagePickerPurchaseAttemptSrc77Evid4811Params>} LogObject<appPremiumPackagePickerPurchaseAttemptSrc77Evid4811Params>
 */
export function appPremiumPackagePickerPurchaseAttemptSrc77Evid4811(params) {
    return { evid: 4811, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseSuccessSrc77Evid4812' event (evid: 4812)
 *
 * Event description: User request to purchase a premium is accepted
 *
 * @param {appPremiumPackagePickerPurchaseSuccessSrc77Evid4812Params} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} package_id - package_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} team_size - team_size_num
 * @property {string} subscription_id - subscription_id
 * @property {string} payment_cycle - payment_cycle
 * @return {LogObject<appPremiumPackagePickerPurchaseSuccessSrc77Evid4812Params>} LogObject<appPremiumPackagePickerPurchaseSuccessSrc77Evid4812Params>
 */
export function appPremiumPackagePickerPurchaseSuccessSrc77Evid4812(params) {
    return { evid: 4812, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseFailSrc77Evid4813' event (evid: 4813)
 *
 * Event description: User request to purchase a premium is rejected
 *
 * @param {appPremiumPackagePickerPurchaseFailSrc77Evid4813Params} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumPackagePickerPurchaseFailSrc77Evid4813Params>} LogObject<appPremiumPackagePickerPurchaseFailSrc77Evid4813Params>
 */
export function appPremiumPackagePickerPurchaseFailSrc77Evid4813(params) {
    return { evid: 4813, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsPurchaseAttempt' event (evid: 4814)
 *
 * Event description: User requests to purchase CC credits
 *
 * @param {appPremiumCcCreditsPurchaseAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumCcCreditsPurchaseAttemptParams>} LogObject<appPremiumCcCreditsPurchaseAttemptParams>
 */
export function appPremiumCcCreditsPurchaseAttempt(params) {
    return { evid: 4814, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsPurchaseSuccess' event (evid: 4815)
 *
 * Event description: User request to purchase CC credits is accepted
 *
 * @param {appPremiumCcCreditsPurchaseSuccessParams} params - The parameters for this event
 * @property {number} new_balance - new_balance_num
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subscription_id - subscription_id
 * @property {number} current_balance - current_balance_num
 * @return {LogObject<appPremiumCcCreditsPurchaseSuccessParams>} LogObject<appPremiumCcCreditsPurchaseSuccessParams>
 */
export function appPremiumCcCreditsPurchaseSuccess(params) {
    return { evid: 4815, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsPurchaseFail' event (evid: 4816)
 *
 * Event description: User request to purchase CC credits is rejected
 *
 * @param {appPremiumCcCreditsPurchaseFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumCcCreditsPurchaseFailParams>} LogObject<appPremiumCcCreditsPurchaseFailParams>
 */
export function appPremiumCcCreditsPurchaseFail(params) {
    return { evid: 4816, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCheckoutRequestAttempt' event (evid: 4830)
 *
 * Event description: User requested to move from the call center credits package picker to the purchase page
 *
 * @param {appPremiumCcCreditsCheckoutRequestAttemptParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumCcCreditsCheckoutRequestAttemptParams>} LogObject<appPremiumCcCreditsCheckoutRequestAttemptParams>
 */
export function appPremiumCcCreditsCheckoutRequestAttempt(params) {
    return { evid: 4830, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCheckoutRequestSuccess' event (evid: 4831)
 *
 * Event description: The user is redirected from the call center credits package picker to the purchase page
 *
 * @param {appPremiumCcCreditsCheckoutRequestSuccessParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumCcCreditsCheckoutRequestSuccessParams>} LogObject<appPremiumCcCreditsCheckoutRequestSuccessParams>
 */
export function appPremiumCcCreditsCheckoutRequestSuccess(params) {
    return { evid: 4831, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCheckoutRequestFail' event (evid: 4832)
 *
 * Event description: User request to move from the call center credits package picker to the purchase page was rejected
 *
 * @param {appPremiumCcCreditsCheckoutRequestFailParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @return {LogObject<appPremiumCcCreditsCheckoutRequestFailParams>} LogObject<appPremiumCcCreditsCheckoutRequestFailParams>
 */
export function appPremiumCcCreditsCheckoutRequestFail(params) {
    return { evid: 4832, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCallCenterCreditsAddition' event (evid: 4833)
 *
 * Event description: Call center credits were added to a tenant's balance (was added to the accumulated_balance field in the call_center_balance table) after payment accepted in SBS. UUID in this event is the ID of the user who ordered the product.
 *
 * @param {appPremiumCallCenterCreditsAdditionParams} params - The parameters for this event
 * @property {GUID} purchase_id - purchase_id
 * @property {string} new_balance - new_balance
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} product_guid - product_guid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} current_balance - current_balance
 * @return {LogObject<appPremiumCallCenterCreditsAdditionParams>} LogObject<appPremiumCallCenterCreditsAdditionParams>
 */
export function appPremiumCallCenterCreditsAddition(params) {
    return { evid: 4833, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralAgentClickOnUnPermittedActionInAnswersApp' event (evid: 4900)
 *
 * Event description: An Answers member has been blocked from doing an un-permitted action. (based on this member roles and permissions)
 *
 * @param {appGeneralAgentClickOnUnPermittedActionInAnswersAppParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {number} required_permission_id - required_permission_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} required_permission_name - required_permission_name
 * @return {LogObject<appGeneralAgentClickOnUnPermittedActionInAnswersAppParams>} LogObject<appGeneralAgentClickOnUnPermittedActionInAnswersAppParams>
 */
export function appGeneralAgentClickOnUnPermittedActionInAnswersApp(params) {
    return { evid: 4900, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralBulkTicketsCreationSuccess' event (evid: 4904)
 *
 * Event description: Answers Member successfully created tickets in Bulk through one of the channels (currently it is possible through Email, SMS or Chat)
 *
 * @param {appGeneralBulkTicketsCreationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {GUID} bulk_id - bulk_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {number} messages_count - messages_count
 * @property {string} tickets_and_users_ids - tickets_and_users_ids
 * @return {LogObject<appGeneralBulkTicketsCreationSuccessParams>} LogObject<appGeneralBulkTicketsCreationSuccessParams>
 */
export function appGeneralBulkTicketsCreationSuccess(params) {
    return { evid: 4904, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'securityCheckUsagePerRoleInAnswers' event (evid: 4915)
 *
 * Event description: Event to check the usage per role in Answers.
 *
 * @param {securityCheckUsagePerRoleInAnswersParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_role_id - role_id
 * @property {number} endpoint_required_permission - endpoint_required_permission
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} endpoint - endpoint
 * @return {LogObject<securityCheckUsagePerRoleInAnswersParams>} LogObject<securityCheckUsagePerRoleInAnswersParams>
 */
export function securityCheckUsagePerRoleInAnswers(params) {
    return { evid: 4915, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersChatEvent' event (evid: 4926)
 *
 * Event description: Fires when elements are presented/clicked in the UI during a call in Answers
 *
 * @param {answersChatEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} element_name - element_name
 * @property {string} elementText - element_text
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} interaction_id - interaction_id
 * @property {string} interacted_element - interacted_element
 * @property {string} value - value
 * @property {string} action_type - action_type
 * @property {GUID} agent_id - agent_id
 * @return {LogObject<answersChatEventParams>} LogObject<answersChatEventParams>
 */
export function answersChatEvent(params) {
    return { evid: 4926, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersChatFlowUiEvents' event (evid: 4929)
 *
 * Event description: triggers when a user interacts with Chat elements in Answers
 *
 * @param {answersChatFlowUiEventsParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} sub_element - sub_element
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} interaction_id - interaction_id
 * @property {string} element - element
 * @property {number} chat_process_time - chat_process_time
 * @property {string} value - value
 * @property {string} action_type - action_type
 * @property {GUID} agent_id - agent_id
 * @return {LogObject<answersChatFlowUiEventsParams>} LogObject<answersChatFlowUiEventsParams>
 */
export function answersChatFlowUiEvents(params) {
    return { evid: 4929, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersWrapUpFlowUiEvents' event (evid: 4930)
 *
 * Event description: triggers when a user interacts with wrap up elements in Answers
 *
 * @param {answersWrapUpFlowUiEventsParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} type_of_interaction - type_of_interaction
 * @property {GUID} tenant_id - tenant_id
 * @property {string} sub_element - sub_element
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} interaction_id - interaction_id
 * @property {string} element - element
 * @property {number} processing_time - processing_time
 * @property {string} value - value
 * @property {string} action_type - action_type
 * @property {GUID} agent_id - agent_id
 * @return {LogObject<answersWrapUpFlowUiEventsParams>} LogObject<answersWrapUpFlowUiEventsParams>
 */
export function answersWrapUpFlowUiEvents(params) {
    return { evid: 4930, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicAttachmentSentWithATicket' event (evid: 5001)
 *
 * Event description: Event is being fired whenever an attached file is sent with a ticket or reply to a certain tenant.
 *
 * @param {publicAttachmentSentWithATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} reply_id - reply_guid
 * @property {Url} url - url
 * @property {number} file_size - file_size
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} attachment_status - attachment_status
 * @property {string} file_type - file_type
 * @return {LogObject<publicAttachmentSentWithATicketParams>} LogObject<publicAttachmentSentWithATicketParams>
 */
export function publicAttachmentSentWithATicket(params) {
    return { evid: 5001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallCreationAttempt' event (evid: 5002)
 *
 * Event description: Event is fired when the call initiator tries to create a call.
 *
 * For Outbound and Callback calls: The stage of the creation of the call in Answers and before the creation of it in Twilio.
 * For Inbound: The stage of the creation of the call in Twilio and before it is being accepted in Answers.
 *
 * @param {publicCallCreationAttemptParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} phone_number - phone_number
 * @property {string} queue - queue
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {string} type - type
 * @return {LogObject<publicCallCreationAttemptParams>} LogObject<publicCallCreationAttemptParams>
 */
export function publicCallCreationAttempt(params) {
    return { evid: 5002, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallCreationSuccess' event (evid: 5003)
 *
 * Event description: Event is fired when the call was successfully created but not yet started.
 *
 * For Outbound and Callback calls: The call was accepted in Twilio and Twilio dialed to the user
 * For Inbound: The call was accepted in Answers
 *
 * @param {publicCallCreationSuccessParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} phone_number - phone_number
 * @property {string} queue - queue
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @return {LogObject<publicCallCreationSuccessParams>} LogObject<publicCallCreationSuccessParams>
 */
export function publicCallCreationSuccess(params) {
    return { evid: 5003, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallCreationFail' event (evid: 5004)
 *
 * Event description: Event is fired when the call was not created.
 *
 * The user/client ID in this event is always of the user.
 *
 * @param {publicCallCreationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} phone_number - phone_number
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} callid - callid
 * @property {string} type - type
 * @return {LogObject<publicCallCreationFailParams>} LogObject<publicCallCreationFailParams>
 */
export function publicCallCreationFail(params) {
    return { evid: 5004, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicTicketCreationSuccess' event (evid: 5006)
 *
 * Event description: A new ticket was successfully created in Answers DB.
 *
 * @param {publicTicketCreationSuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @return {LogObject<publicTicketCreationSuccessParams>} LogObject<publicTicketCreationSuccessParams>
 */
export function publicTicketCreationSuccess(params) {
    return { evid: 5006, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicTicketCreationFail' event (evid: 5007)
 *
 * Event description: A request for a new ticket creation in Answers DB was denied.
 *
 * @param {publicTicketCreationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {string} subject - subject
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @return {LogObject<publicTicketCreationFailParams>} LogObject<publicTicketCreationFailParams>
 */
export function publicTicketCreationFail(params) {
    return { evid: 5007, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicReplyCreationFail' event (evid: 5010)
 *
 * Event description: A request for a new reply creation in Answers DB was denied.
 *
 * @param {publicReplyCreationFailParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {boolean} is_agent - is_agent
 * @property {boolean} is_by_rule_engine - is_by_rule_engine
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @return {LogObject<publicReplyCreationFailParams>} LogObject<publicReplyCreationFailParams>
 */
export function publicReplyCreationFail(params) {
    return { evid: 5010, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallTransferFromQueueToVoicemailPerUserRequest' event (evid: 5012)
 *
 * Event description: This event is triggered when a user is transferred from his current queue to a voicemail per his request.
 *
 * @param {publicCallTransferFromQueueToVoicemailPerUserRequestParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} call_type - call_type
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {number} processing_time - processing_time
 * @property {GUID} callid - callid
 * @return {LogObject<publicCallTransferFromQueueToVoicemailPerUserRequestParams>} LogObject<publicCallTransferFromQueueToVoicemailPerUserRequestParams>
 */
export function publicCallTransferFromQueueToVoicemailPerUserRequest(params) {
    return { evid: 5012, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallbackRequestFromAQueueByAUser' event (evid: 5013)
 *
 * Event description: Public - Callback request from a queue by a user.
 *
 * @param {publicCallbackRequestFromAQueueByAUserParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} call_type - call_type
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {number} processing_time - processing_time
 * @property {GUID} callid - callid
 * @return {LogObject<publicCallbackRequestFromAQueueByAUserParams>} LogObject<publicCallbackRequestFromAQueueByAUserParams>
 */
export function publicCallbackRequestFromAQueueByAUser(params) {
    return { evid: 5013, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallTransferBetweenQueuesPerUserRequest' event (evid: 5014)
 *
 * Event description: This event is triggered when a user is transferred from his current queue to another one per his request.
 *
 * @param {publicCallTransferBetweenQueuesPerUserRequestParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} source_queue_id - source_queue_id
 * @property {string} call_type - call_type
 * @property {GUID} uuid - uuid
 * @property {GUID} source_topic_id - source_topic_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} target_queue_id - target_queue_id
 * @property {number} processing_time - processing_time
 * @property {GUID} target_topic_id - target_topic_id
 * @property {GUID} callid - callid
 * @property {string} target_locale - target_locale
 * @property {string} source_locale - source_locale
 * @return {LogObject<publicCallTransferBetweenQueuesPerUserRequestParams>} LogObject<publicCallTransferBetweenQueuesPerUserRequestParams>
 */
export function publicCallTransferBetweenQueuesPerUserRequest(params) {
    return { evid: 5014, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicChatUserMessageAttempt' event (evid: 5015)
 *
 * Event description: A Public User attempted to send a new Chat message
 *
 * @param {publicChatUserMessageAttemptParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} chat_id - chat_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {GUID} userGuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} message_id - message_id
 * @return {LogObject<publicChatUserMessageAttemptParams>} LogObject<publicChatUserMessageAttemptParams>
 */
export function publicChatUserMessageAttempt(params) {
    return { evid: 5015, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicChatUserMessageSuccess' event (evid: 5016)
 *
 * Event description: A chat message was successfully sent by a public user
 *
 * @param {publicChatUserMessageSuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} message_id - message_id
 * @return {LogObject<publicChatUserMessageSuccessParams>} LogObject<publicChatUserMessageSuccessParams>
 */
export function publicChatUserMessageSuccess(params) {
    return { evid: 5016, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicChatUserMessageFailed' event (evid: 5017)
 *
 * Event description: Public user has failed to send a chat message
 *
 * @param {publicChatUserMessageFailedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} chat_id - chat_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} message_id - message_id
 * @return {LogObject<publicChatUserMessageFailedParams>} LogObject<publicChatUserMessageFailedParams>
 */
export function publicChatUserMessageFailed(params) {
    return { evid: 5017, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSurveyHasBeenSentByAUser' event (evid: 7001)
 *
 * Event description: A survey has been sent by a user to the system
 *
 * @param {publicSurveyHasBeenSentByAUserParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {string} comment_content - comment_content
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {number} rating - rating
 * @property {boolean} comment_option - comment_option
 * @property {GUID} survey_id - survey_id
 * @property {GUID} agent_id - agent_id
 * @return {LogObject<publicSurveyHasBeenSentByAUserParams>} LogObject<publicSurveyHasBeenSentByAUserParams>
 */
export function publicSurveyHasBeenSentByAUser(params) {
    return { evid: 7001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralRegisterIntegrationAttempt' event (evid: 9500)
 *
 * Event description: The user is attempting to register (install) an integration on the tenant.
 *
 * @param {integratorsGeneralRegisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralRegisterIntegrationAttemptParams>} LogObject<integratorsGeneralRegisterIntegrationAttemptParams>
 */
export function integratorsGeneralRegisterIntegrationAttempt(params) {
    return { evid: 9500, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralRegisterIntegrationSuccess' event (evid: 9501)
 *
 * Event description: The user successfully registered (installed) an integration on the tenant.
 *
 * @param {integratorsGeneralRegisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralRegisterIntegrationSuccessParams>} LogObject<integratorsGeneralRegisterIntegrationSuccessParams>
 */
export function integratorsGeneralRegisterIntegrationSuccess(params) {
    return { evid: 9501, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralUnregisterIntegrationAttempt' event (evid: 9503)
 *
 * Event description: The user is attempting to unregister (remove) an integration from the tenant.
 *
 * @param {integratorsGeneralUnregisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralUnregisterIntegrationAttemptParams>} LogObject<integratorsGeneralUnregisterIntegrationAttemptParams>
 */
export function integratorsGeneralUnregisterIntegrationAttempt(params) {
    return { evid: 9503, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralUnregisterIntegrationSuccess' event (evid: 9504)
 *
 * Event description: The user successfully unregistered (removed) an integration from the tenant.
 *
 * @param {integratorsGeneralUnregisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralUnregisterIntegrationSuccessParams>} LogObject<integratorsGeneralUnregisterIntegrationSuccessParams>
 */
export function integratorsGeneralUnregisterIntegrationSuccess(params) {
    return { evid: 9504, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralUnregisterIntegrationFail' event (evid: 9505)
 *
 * Event description: The user failed to unregister (remove) an integration from the tenant.
 *
 * @param {integratorsGeneralUnregisterIntegrationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralUnregisterIntegrationFailParams>} LogObject<integratorsGeneralUnregisterIntegrationFailParams>
 */
export function integratorsGeneralUnregisterIntegrationFail(params) {
    return { evid: 9505, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralSettingsRendered' event (evid: 9506)
 *
 * Event description: The settings page of the integration was rendered par user's request.
 *
 * @param {integratorsGeneralSettingsRenderedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @property {string} type - type
 * @return {LogObject<integratorsGeneralSettingsRenderedParams>} LogObject<integratorsGeneralSettingsRenderedParams>
 */
export function integratorsGeneralSettingsRendered(params) {
    return { evid: 9506, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralAuthFlowCompletionAttempt' event (evid: 9507)
 *
 * Event description: The user is attempting to complete the auth flow of an integration.
 *
 * @param {integratorsGeneralAuthFlowCompletionAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralAuthFlowCompletionAttemptParams>} LogObject<integratorsGeneralAuthFlowCompletionAttemptParams>
 */
export function integratorsGeneralAuthFlowCompletionAttempt(params) {
    return { evid: 9507, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralAuthFlowCompletionSuccess' event (evid: 9508)
 *
 * Event description: The user successfully completed the auth flow of an integration.
 *
 * @param {integratorsGeneralAuthFlowCompletionSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralAuthFlowCompletionSuccessParams>} LogObject<integratorsGeneralAuthFlowCompletionSuccessParams>
 */
export function integratorsGeneralAuthFlowCompletionSuccess(params) {
    return { evid: 9508, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralAuthFlowCompletionFail' event (evid: 9509)
 *
 * Event description: The user failed to complete the auth flow of an integration.
 *
 * @param {integratorsGeneralAuthFlowCompletionFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralAuthFlowCompletionFailParams>} LogObject<integratorsGeneralAuthFlowCompletionFailParams>
 */
export function integratorsGeneralAuthFlowCompletionFail(params) {
    return { evid: 9509, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralSaveSettingsAttempt' event (evid: 9510)
 *
 * Event description: The user is attempting to save the settings of an integration.
 *
 * @param {integratorsGeneralSaveSettingsAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralSaveSettingsAttemptParams>} LogObject<integratorsGeneralSaveSettingsAttemptParams>
 */
export function integratorsGeneralSaveSettingsAttempt(params) {
    return { evid: 9510, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralSaveSettingsSuccess' event (evid: 9511)
 *
 * Event description: The user successfully saved the settings of an integration.
 *
 * @param {integratorsGeneralSaveSettingsSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralSaveSettingsSuccessParams>} LogObject<integratorsGeneralSaveSettingsSuccessParams>
 */
export function integratorsGeneralSaveSettingsSuccess(params) {
    return { evid: 9511, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralTicketViewRendered' event (evid: 9513)
 *
 * Event description: Integration rendered the ticket view for a certain ticket.
 *
 * @param {integratorsGeneralTicketViewRenderedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsGeneralTicketViewRenderedParams>} LogObject<integratorsGeneralTicketViewRenderedParams>
 */
export function integratorsGeneralTicketViewRendered(params) {
    return { evid: 9513, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralWebhookCalledFail' event (evid: 9518)
 *
 * Event description: The integration failed to call a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsGeneralWebhookCalledFailParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reason - reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {string} webhook_type - webhook_type
 * @property {GUID} integration_id - integration_id
 * @property {number} attempt - attempt
 * @return {LogObject<integratorsGeneralWebhookCalledFailParams>} LogObject<integratorsGeneralWebhookCalledFailParams>
 */
export function integratorsGeneralWebhookCalledFail(params) {
    return { evid: 9518, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralFailedTokenValidation' event (evid: 9519)
 *
 * Event description: The integration failed to validate a token
 *
 * @param {integratorsGeneralFailedTokenValidationParams} params - The parameters for this event
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @property {Url} request_origin - request_origin
 * @return {LogObject<integratorsGeneralFailedTokenValidationParams>} LogObject<integratorsGeneralFailedTokenValidationParams>
 */
export function integratorsGeneralFailedTokenValidation(params) {
    return { evid: 9519, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callNoteCreatedByAiSummary' event (evid: 9525)
 *
 * Event description: Every time the AI summary sends a callnote, this event is sent.
 *
 * @param {callNoteCreatedByAiSummaryParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} closing_agent_id - closing_agent_id
 * @property {DateTime} start_summary_processing_time - start_summary_processing_time
 * @property {GUID} client_id - client_id
 * @property {DateTime} end_summary_processing_time - end_summary_processing_time
 * @property {GUID} user_id - uuid
 * @property {number} call_duration - call_duration
 * @property {GUID} call_id - call__id
 * @return {LogObject<callNoteCreatedByAiSummaryParams>} LogObject<callNoteCreatedByAiSummaryParams>
 */
export function callNoteCreatedByAiSummary(params) {
    return { evid: 9525, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'channelAvailability' event (evid: 9526)
 *
 * Event description: checks the availability result of the API
 *
 * @param {channelAvailabilityParams} params - The parameters for this event
 * @property {string} skill_ids - skill_ids
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {boolean} is_transfer - is_transfer
 * @property {string} availability_results - availability_results
 * @property {string} request_id - request_id of the API
 * @return {LogObject<channelAvailabilityParams>} LogObject<channelAvailabilityParams>
 */
export function channelAvailability(params) {
    return { evid: 9526, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicTicketHasBeenResolvedByAUser' event (evid: 9530)
 *
 * Event description: A ticket was resolved by a user.
 * (The only flow for it to happen at the moment is that the user is directed to the article after clicking it in "Article suggestions" section of "Ticket received" Email. (Ticket confirmation email))
 *
 * @param {publicTicketHasBeenResolvedByAUserParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @return {LogObject<publicTicketHasBeenResolvedByAUserParams>} LogObject<publicTicketHasBeenResolvedByAUserParams>
 */
export function publicTicketHasBeenResolvedByAUser(params) {
    return { evid: 9530, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsArticleSuggestionEmailRendered' event (evid: 9531)
 *
 * Event description: Article recommendation Email was rendered after a user submitted a ticket. When a ticket is submitted an AI article recommendation is generated and sent to the user attached to the ticket confirmation email. This event is not a guarantee that the email was in did delivered to the user.
 *
 * @param {integratorsArticleSuggestionEmailRenderedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - locale
 * @property {string} article_ids - article_ids
 * @return {LogObject<integratorsArticleSuggestionEmailRenderedParams>} LogObject<integratorsArticleSuggestionEmailRenderedParams>
 */
export function integratorsArticleSuggestionEmailRendered(params) {
    return { evid: 9531, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraRegisterIntegrationAttempt' event (evid: 9550)
 *
 * Event description: The user is attempting to register (install) an integration on the tenant.
 *
 * @param {integratorsJiraRegisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsJiraRegisterIntegrationAttemptParams>} LogObject<integratorsJiraRegisterIntegrationAttemptParams>
 */
export function integratorsJiraRegisterIntegrationAttempt(params) {
    return { evid: 9550, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraRegisterIntegrationSuccess' event (evid: 9551)
 *
 * Event description: The user successfully registered (installed) an integration on the tenant.
 *
 * @param {integratorsJiraRegisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsJiraRegisterIntegrationSuccessParams>} LogObject<integratorsJiraRegisterIntegrationSuccessParams>
 */
export function integratorsJiraRegisterIntegrationSuccess(params) {
    return { evid: 9551, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraRegisterIntegrationFail' event (evid: 9552)
 *
 * Event description: The user failed to register (install) an integration on the tenant.
 *
 * @param {integratorsJiraRegisterIntegrationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsJiraRegisterIntegrationFailParams>} LogObject<integratorsJiraRegisterIntegrationFailParams>
 */
export function integratorsJiraRegisterIntegrationFail(params) {
    return { evid: 9552, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraUnregisterIntegrationAttempt' event (evid: 9553)
 *
 * Event description: The user is attempting to unregister (remove) an integration from the tenant.
 *
 * @param {integratorsJiraUnregisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsJiraUnregisterIntegrationAttemptParams>} LogObject<integratorsJiraUnregisterIntegrationAttemptParams>
 */
export function integratorsJiraUnregisterIntegrationAttempt(params) {
    return { evid: 9553, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraUnregisterIntegrationSuccess' event (evid: 9554)
 *
 * Event description: The user successfully unregistered (removed) an integration from the tenant.
 *
 * @param {integratorsJiraUnregisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsJiraUnregisterIntegrationSuccessParams>} LogObject<integratorsJiraUnregisterIntegrationSuccessParams>
 */
export function integratorsJiraUnregisterIntegrationSuccess(params) {
    return { evid: 9554, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraSettingsRendered' event (evid: 9556)
 *
 * Event description: The settings page of the integration was rendered par user's request.
 *
 * @param {integratorsJiraSettingsRenderedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @property {string} type - type
 * @return {LogObject<integratorsJiraSettingsRenderedParams>} LogObject<integratorsJiraSettingsRenderedParams>
 */
export function integratorsJiraSettingsRendered(params) {
    return { evid: 9556, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraAuthFlowCompletionAttempt' event (evid: 9557)
 *
 * Event description: The user is attempting to complete the auth flow of an integration.
 *
 * @param {integratorsJiraAuthFlowCompletionAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsJiraAuthFlowCompletionAttemptParams>} LogObject<integratorsJiraAuthFlowCompletionAttemptParams>
 */
export function integratorsJiraAuthFlowCompletionAttempt(params) {
    return { evid: 9557, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraAuthFlowCompletionSuccess' event (evid: 9558)
 *
 * Event description: The user successfully completed the auth flow of an integration.
 *
 * @param {integratorsJiraAuthFlowCompletionSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsJiraAuthFlowCompletionSuccessParams>} LogObject<integratorsJiraAuthFlowCompletionSuccessParams>
 */
export function integratorsJiraAuthFlowCompletionSuccess(params) {
    return { evid: 9558, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraAuthFlowCompletionFail' event (evid: 9559)
 *
 * Event description: The user failed to complete the auth flow of an integration.
 *
 * @param {integratorsJiraAuthFlowCompletionFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsJiraAuthFlowCompletionFailParams>} LogObject<integratorsJiraAuthFlowCompletionFailParams>
 */
export function integratorsJiraAuthFlowCompletionFail(params) {
    return { evid: 9559, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraSaveSettingsAttempt' event (evid: 9560)
 *
 * Event description: The user is attempting to save the settings of an integration.
 *
 * @param {integratorsJiraSaveSettingsAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsJiraSaveSettingsAttemptParams>} LogObject<integratorsJiraSaveSettingsAttemptParams>
 */
export function integratorsJiraSaveSettingsAttempt(params) {
    return { evid: 9560, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraSaveSettingsSuccess' event (evid: 9561)
 *
 * Event description: The user successfully saved the settings of an integration.
 *
 * @param {integratorsJiraSaveSettingsSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsJiraSaveSettingsSuccessParams>} LogObject<integratorsJiraSaveSettingsSuccessParams>
 */
export function integratorsJiraSaveSettingsSuccess(params) {
    return { evid: 9561, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraFailedTokenValidation' event (evid: 9569)
 *
 * Event description: The integration failed to validate a token
 *
 * @param {integratorsJiraFailedTokenValidationParams} params - The parameters for this event
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @property {Url} request_origin - request_origin
 * @return {LogObject<integratorsJiraFailedTokenValidationParams>} LogObject<integratorsJiraFailedTokenValidationParams>
 */
export function integratorsJiraFailedTokenValidation(params) {
    return { evid: 9569, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraGeneralError' event (evid: 9570)
 *
 * Event description: The Jira integration returned an exception
 *
 * @param {integratorsJiraGeneralErrorParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reason - reason
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @property {string} error_type - error_type
 * @return {LogObject<integratorsJiraGeneralErrorParams>} LogObject<integratorsJiraGeneralErrorParams>
 */
export function integratorsJiraGeneralError(params) {
    return { evid: 9570, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceRegisterIntegrationAttempt' event (evid: 9600)
 *
 * Event description: The user is attempting to register (install) an integration on the tenant.
 *
 * @param {integratorsSalesforceRegisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceRegisterIntegrationAttemptParams>} LogObject<integratorsSalesforceRegisterIntegrationAttemptParams>
 */
export function integratorsSalesforceRegisterIntegrationAttempt(params) {
    return { evid: 9600, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceRegisterIntegrationSuccess' event (evid: 9601)
 *
 * Event description: The user successfully registered (installed) an integration on the tenant.
 *
 * @param {integratorsSalesforceRegisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceRegisterIntegrationSuccessParams>} LogObject<integratorsSalesforceRegisterIntegrationSuccessParams>
 */
export function integratorsSalesforceRegisterIntegrationSuccess(params) {
    return { evid: 9601, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceUnregisterIntegrationAttempt' event (evid: 9603)
 *
 * Event description: The user is attempting to unregister (remove) an integration from the tenant.
 *
 * @param {integratorsSalesforceUnregisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceUnregisterIntegrationAttemptParams>} LogObject<integratorsSalesforceUnregisterIntegrationAttemptParams>
 */
export function integratorsSalesforceUnregisterIntegrationAttempt(params) {
    return { evid: 9603, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceUnregisterIntegrationSuccess' event (evid: 9604)
 *
 * Event description: The user successfully unregistered (removed) an integration from the tenant.
 *
 * @param {integratorsSalesforceUnregisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceUnregisterIntegrationSuccessParams>} LogObject<integratorsSalesforceUnregisterIntegrationSuccessParams>
 */
export function integratorsSalesforceUnregisterIntegrationSuccess(params) {
    return { evid: 9604, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceUnregisterIntegrationFail' event (evid: 9605)
 *
 * Event description: The user failed to unregister (remove) an integration from the tenant.
 *
 * @param {integratorsSalesforceUnregisterIntegrationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reason - reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceUnregisterIntegrationFailParams>} LogObject<integratorsSalesforceUnregisterIntegrationFailParams>
 */
export function integratorsSalesforceUnregisterIntegrationFail(params) {
    return { evid: 9605, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceSettingsRendered' event (evid: 9606)
 *
 * Event description: The settings page of the integration was rendered par user's request.
 *
 * @param {integratorsSalesforceSettingsRenderedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @property {string} type - type
 * @return {LogObject<integratorsSalesforceSettingsRenderedParams>} LogObject<integratorsSalesforceSettingsRenderedParams>
 */
export function integratorsSalesforceSettingsRendered(params) {
    return { evid: 9606, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceAuthFlowCompletionAttempt' event (evid: 9607)
 *
 * Event description: The user is attempting to complete the auth flow of an integration.
 *
 * @param {integratorsSalesforceAuthFlowCompletionAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceAuthFlowCompletionAttemptParams>} LogObject<integratorsSalesforceAuthFlowCompletionAttemptParams>
 */
export function integratorsSalesforceAuthFlowCompletionAttempt(params) {
    return { evid: 9607, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceAuthFlowCompletionSuccess' event (evid: 9608)
 *
 * Event description: The user successfully completed the auth flow of an integration.
 *
 * @param {integratorsSalesforceAuthFlowCompletionSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceAuthFlowCompletionSuccessParams>} LogObject<integratorsSalesforceAuthFlowCompletionSuccessParams>
 */
export function integratorsSalesforceAuthFlowCompletionSuccess(params) {
    return { evid: 9608, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceAuthFlowCompletionFail' event (evid: 9609)
 *
 * Event description: The user failed to complete the auth flow of an integration.
 *
 * @param {integratorsSalesforceAuthFlowCompletionFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reason - reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceAuthFlowCompletionFailParams>} LogObject<integratorsSalesforceAuthFlowCompletionFailParams>
 */
export function integratorsSalesforceAuthFlowCompletionFail(params) {
    return { evid: 9609, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceSaveSettingsAttempt' event (evid: 9610)
 *
 * Event description: The user is attempting to save the settings of an integration.
 *
 * @param {integratorsSalesforceSaveSettingsAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceSaveSettingsAttemptParams>} LogObject<integratorsSalesforceSaveSettingsAttemptParams>
 */
export function integratorsSalesforceSaveSettingsAttempt(params) {
    return { evid: 9610, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceSaveSettingsSuccess' event (evid: 9611)
 *
 * Event description: The user successfully saved the settings of an integration.
 *
 * @param {integratorsSalesforceSaveSettingsSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceSaveSettingsSuccessParams>} LogObject<integratorsSalesforceSaveSettingsSuccessParams>
 */
export function integratorsSalesforceSaveSettingsSuccess(params) {
    return { evid: 9611, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceSaveSettingsFail' event (evid: 9612)
 *
 * Event description: The user failed to save the settings of an integration.
 *
 * @param {integratorsSalesforceSaveSettingsFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reason - reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceSaveSettingsFailParams>} LogObject<integratorsSalesforceSaveSettingsFailParams>
 */
export function integratorsSalesforceSaveSettingsFail(params) {
    return { evid: 9612, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceTicketViewRendered' event (evid: 9613)
 *
 * Event description: Integration rendered the ticket view for a certain ticket.
 *
 * @param {integratorsSalesforceTicketViewRenderedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @return {LogObject<integratorsSalesforceTicketViewRenderedParams>} LogObject<integratorsSalesforceTicketViewRenderedParams>
 */
export function integratorsSalesforceTicketViewRendered(params) {
    return { evid: 9613, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceWebhookCalledAttempt' event (evid: 9614)
 *
 * Event description: The integration attempted to call a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsSalesforceWebhookCalledAttemptParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {string} webhook_type - webhook_type
 * @property {GUID} integration_id - integration_id
 * @property {number} attempt - attempt
 * @return {LogObject<integratorsSalesforceWebhookCalledAttemptParams>} LogObject<integratorsSalesforceWebhookCalledAttemptParams>
 */
export function integratorsSalesforceWebhookCalledAttempt(params) {
    return { evid: 9614, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceWebhookCalledSuccess' event (evid: 9615)
 *
 * Event description: The integration successfully called a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsSalesforceWebhookCalledSuccessParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {string} webhook_type - webhook_type
 * @property {GUID} integration_id - integration_id
 * @property {number} attempt - attempt
 * @return {LogObject<integratorsSalesforceWebhookCalledSuccessParams>} LogObject<integratorsSalesforceWebhookCalledSuccessParams>
 */
export function integratorsSalesforceWebhookCalledSuccess(params) {
    return { evid: 9615, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceWebhookCalledFail' event (evid: 9616)
 *
 * Event description: The integration failed to call a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsSalesforceWebhookCalledFailParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} reason - reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {string} webhook_type - webhook_type
 * @property {GUID} integration_id - integration_id
 * @property {number} attempt - attempt
 * @return {LogObject<integratorsSalesforceWebhookCalledFailParams>} LogObject<integratorsSalesforceWebhookCalledFailParams>
 */
export function integratorsSalesforceWebhookCalledFail(params) {
    return { evid: 9616, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceFailedTokenValidation' event (evid: 9617)
 *
 * Event description: The integration failed to validate a token
 *
 * @param {integratorsSalesforceFailedTokenValidationParams} params - The parameters for this event
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - uuid
 * @property {GUID} integration_id - integration_id
 * @property {Url} request_origin - request_origin
 * @return {LogObject<integratorsSalesforceFailedTokenValidationParams>} LogObject<integratorsSalesforceFailedTokenValidationParams>
 */
export function integratorsSalesforceFailedTokenValidation(params) {
    return { evid: 9617, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onboardingSlackbotAlert' event (evid: 9800)
 *
 * Event description: The event is fired with all the details when a alert is sent to onboarding team slack channel after a tenant wrote in urgent/support channel
 *
 * @param {onboardingSlackbotAlertParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} alert_id - alert_id
 * @property {string} channel_name - channel_name
 * @property {string} reporter - reporter
 * @property {GUID} acknowledged_by_id - acknowledged_by_id
 * @property {string} alert_type - alert_type
 * @property {string} outcome - outcome
 * @property {string} bot_id - bot_id
 * @property {GUID} client_id - client_id
 * @property {DateTime} original_time - original_time
 * @property {GUID} user_id - uuid
 * @property {string} link - link
 * @property {DateTime} acknowledge_time - acknowledge_time
 * @return {LogObject<onboardingSlackbotAlertParams>} LogObject<onboardingSlackbotAlertParams>
 */
export function onboardingSlackbotAlert(params) {
    return { evid: 9800, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicChatbotStepReached' event (evid: 9900)
 *
 * Event description: Public (chatbot) - step reached.
 *
 * @param {publicChatbotStepReachedParams} params - The parameters for this event
 * @property {GUID} chatbot_flow_id - chatbot_flow_id
 * @property {string} chatbot_step_type - chatbot_step_type
 * @property {string} tenant_name - tenant_name
 * @property {GUID} sessionId - session_id
 * @property {string} chatbot_step_id - chatbot_step_id
 * @return {LogObject<publicChatbotStepReachedParams>} LogObject<publicChatbotStepReachedParams>
 */
export function publicChatbotStepReached(params) {
    return { evid: 9900, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketIsReadyForRouting' event (evid: 9904)
 *
 * Event description: New ticket was created or ticket was sent to revaluation flow. Triggers after gathering all information that needed for routing (about ticket, system state and recommendations).
 *
 * @param {ticketIsReadyForRoutingParams} params - The parameters for this event
 * @property {string} locale -  Language of the ticket
 * @property {string} skill_ids - List of topics and soft skills the ticket does require
 * @property {number} agent_active_tickets_num - Number of interactions chosen agent is currently processing
 * @property {string} agent_active_tickets_list - List of interactions chosen agent is currently processing
 * @property {number} agent_waiting_tickets_num - Number of interactions waiting in agent's personal queue
 * @property {string} agent_waiting_tickets_list - List of interactions waiting in agent's personal queue
 * @property {GUID} tenant_id - Answers account id
 * @property {GUID} ticket_id - Unique id of the ticket
 * @property {GUID} interaction_id - Unique interaction id
 * @property {string} channel_id - Id of channel
 * @property {GUID} group_id - id of the group
 * @property {string} interaction_proficiency - proficiency of ticket / interaction
 * @property {boolean} is_new_interaction - true if it's a new ticket to be sent to routing
 * @property {boolean} is_revaluation - true if ticket was sent to revaluation (ticket was updated, transfer, declined, agent status changed)
 * @property {number} priority_score - priority score
 * @property {GUID} wix_user_id - Wix user id (external)
 * @property {GUID} wix_user_account_id - Wix Account id (external)
 * @property {GUID} answers_user_id - Wix user id from Answers
 * @property {string} user_proficiency - Level of user's proficiency
 * @property {number} routing_version - version of model/policy used for routing
 * @property {number} agents_filtered_num - number of agents sent to the model or filtered by policy
 * @property {string} agents_filtered_list - List of agent that were considered as options for this interaction
 * @property {GUID} agent_id - Main candidate for routing
 * @property {boolean} agent_is_routing_ready - If candidate is in one of the statuses that allow to push tickets to their queue
 * @property {string} agent_proficiency - The level of agent proficiency
 * @property {string} agent_status - Agent status
 * @property {string} agent_call_center_status - Agent call center status
 * @property {string} agent_channels - List of channels agent is currently on
 * @property {string} agent_skill_ids - List of topic and soft skills that agent currently has
 * @property {string} agent_group_ids - List of groups agent is currently a part of
 * @property {number} agent_capacity - Max number of tickets agent can process in the same moment of time
 * @property {DateTime} agent_last_session_start_time - When was the last session start of the agent
 * @property {DateTime} agent_last_session_end_time - When was the last session end of the agent
 * @property {GUID} prediction_id - Unique id for each model prediction
 * @property {string} agent_custom_busy_status_id	 - custom busy status details
 * @property {string} reward - match reward (score)
 * @property {string} model_skill - skill recognised by model
 * @property {number} num_unknown_ranked_experts - out of top experts that model gives in response - how much it doesn't have personal stats on
 * @return {LogObject<ticketIsReadyForRoutingParams>} LogObject<ticketIsReadyForRoutingParams>
 */
export function ticketIsReadyForRouting(params) {
    return { evid: 9904, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'routingRecommendation' event (evid: 9905)
 *
 * Event description: Triggers after get recommendation from model - send batch of events for top recommendations (one event per recommended agent with common prediction_id for each model runs).
 *
 * @param {routingRecommendationParams} params - The parameters for this event
 * @property {number} agent_active_tickets_num - Number of interactions chosen agent is currently processing
 * @property {string} agent_active_tickets_list - List of interactions chosen agent is currently processing
 * @property {number} agent_waiting_tickets_num - Number of interactions waiting in agent's personal queue
 * @property {string} agent_waiting_tickets_list - List of interactions waiting in agent's personal queue
 * @property {GUID} tenant_id  - Answers account id
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} interaction_id - interaction id
 * @property {string} channel_id - channel
 * @property {GUID} agent_id - candidate for routing
 * @property {string} match_reward_details - rewards for each of the parameters, coefficients and exact predictions
 * @property {boolean} agent_is_routing_ready - If candidate is in one of the statuses that allow to push tickets to their queue
 * @property {string} agent_proficiency - The level of agent proficiency
 * @property {string} agent_status - Agent status
 * @property {string} agent_call_center_status - Agent call center status
 * @property {string} agent_channels - List of channels agent is currently on
 * @property {string} agent_skill_ids - List of topic and soft skills that agent currently has
 * @property {string} agent_group_ids - List of groups agent is currently a part of
 * @property {number} agent_capacity - Max number of tickets agent can process in the same moment of time
 * @property {DateTime} agent_last_session_start_time - When was the last session start of the agent
 * @property {DateTime} agent_last_session_end_time - When was the last session end of the agent
 * @property {GUID} predictionId - Unique id for each model prediction
 * @property {string} agent_custom_busy_status_id	 - custom busy status details
 * @property {string} agent_rank - rank of the agent according to the score
 * @property {string} reward - match reward (score)
 * @return {LogObject<routingRecommendationParams>} LogObject<routingRecommendationParams>
 */
export function routingRecommendation(params) {
    return { evid: 9905, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketFallbackToArPolicy' event (evid: 9907)
 *
 * Event description: Triggers in case of "red button" - when ticket is sent to our current flow (waiting list on the group level)
 *
 * @param {ticketFallbackToArPolicyParams} params - The parameters for this event
 * @property {string} locale -  Language of the ticket
 * @property {string} skill_ids - List of topics and soft skills the ticket does require
 * @property {GUID} tenant_id - Answers account id
 * @property {GUID} ticket_id - Unique id of the ticket
 * @property {GUID} interaction_id - Unique interaction id
 * @property {string} channel_id - Id of channel
 * @property {GUID} group_id - id of the group
 * @property {number} priority_score - priority score
 * @property {GUID} agent_id - Id of the last assigned agent
 * @property {string} user_proficiency - Level of user's proficiency
 * @return {LogObject<ticketFallbackToArPolicyParams>} LogObject<ticketFallbackToArPolicyParams>
 */
export function ticketFallbackToArPolicy(params) {
    return { evid: 9907, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoAiContentRephrase' event (evid: 9908)
 *
 * Event description: Fire when the AI content rephrase was activated in the article's back office
 *
 * @param {kbBoAiContentRephraseParams} params - The parameters for this event
 * @property {GUID} article_id - The article for which the action was performed
 * @property {string} params - The input parameters that were passed with the request for the rephrase service
 * @property {GUID} user_answers_id - The Answers ID of the user that triggered the action
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {string} article_language - The article language code for which the action was performed
 * @property {string} locale - The article language code for which the action was performed
 * @return {LogObject<kbBoAiContentRephraseParams>} LogObject<kbBoAiContentRephraseParams>
 */
export function kbBoAiContentRephrase(params) {
    return { evid: 9908, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'autoRoutingOnTicketLevel' event (evid: 10200)
 *
 * Event description: This event will be sent every time there is a routing attempt and the ticket is searching the relevant and available expert. NOTE: there are duplicates due to different hosts, you can add host field or remove the duplicates
 *
 * @param {autoRoutingOnTicketLevelParams} params - The parameters for this event
 * @property {string} skill_ids - skill_ids
 * @property {GUID} agentSelected - agent_selected_id
 * @property {GUID} ticket_id - ticket_id
 * @property {number} filtered - filtered_num
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel_id
 * @property {string} routingId - routing_id
 * @property {string} assignmentId - assignment_id
 * @property {boolean} isTicketMatch - is_ticket_match
 * @property {number} groupMembers - group_members_num
 * @property {number} candidates - candidates_num
 * @property {string} failedCandidates - failed_candidates
 * @property {GUID} interactionId - interaction_id
 * @property {DateTime} last_update_time - last_update_time
 * @property {string} groupId - group_id
 * @property {string} sortedSummary - sorted_summary
 * @property {boolean} isTransfer - is_transfer
 * @property {string} language - language_code
 * @property {GUID} userId - user_id
 * @return {LogObject<autoRoutingOnTicketLevelParams>} LogObject<autoRoutingOnTicketLevelParams>
 */
export function autoRoutingOnTicketLevel(params) {
    return { evid: 10200, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverAnswerToAutoRoutingTicket' event (evid: 10201)
 *
 * Event description: This event will be sent every time there is a routing attempt and the answer from the server if it's fails the routing attempt or not (for example if the same ticket is routed to more than one expert at the same routing attempt
 *
 * @param {serverAnswerToAutoRoutingTicketParams} params - The parameters for this event
 * @property {GUID} agentSelected - agent_selected_id
 * @property {string} routingId - routing_id
 * @property {string} ticketId - ticket_id
 * @property {number} statusId - status_id
 * @property {string} status - status_name
 * @property {boolean} isFailed - is_failed
 * @return {LogObject<serverAnswerToAutoRoutingTicketParams>} LogObject<serverAnswerToAutoRoutingTicketParams>
 */
export function serverAnswerToAutoRoutingTicket(params) {
    return { evid: 10201, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'autoRoutingOnTicketLevelArTenant' event (evid: 10301)
 *
 * Event description: This event will be sent every time there is a routing attempt and the ticket is searching the relevant and available expert. NOTE: there are duplicates due to different hosts, you can add host field or remove the duplicates
 *
 * @param {autoRoutingOnTicketLevelArTenantParams} params - The parameters for this event
 * @property {string} skill_ids - skill_ids
 * @property {GUID} agentSelected - agent_selected_id
 * @property {GUID} ticket_id - ticket_id
 * @property {number} filtered - filtered_num
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel_id
 * @property {string} routingId - routing_id
 * @property {string} assignmentId - assignment_id
 * @property {boolean} isTicketMatch - is_ticket_match
 * @property {number} groupMembers - group_members_num
 * @property {number} candidates - candidates_num
 * @property {string} failedCandidates - failed_candidates
 * @property {GUID} interactionId - interaction_id
 * @property {DateTime} last_update_time - last_update_time
 * @property {string} groupId - group_id
 * @property {string} sortedSummary - sorted_summary
 * @property {boolean} isTransfer - is_transfer
 * @property {string} language - language_code
 * @property {GUID} userId - user_id
 * @return {LogObject<autoRoutingOnTicketLevelArTenantParams>} LogObject<autoRoutingOnTicketLevelArTenantParams>
 */
export function autoRoutingOnTicketLevelArTenant(params) {
    return { evid: 10301, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'autoRoutingOnExpertLevelArTenant' event (evid: 10302)
 *
 * Event description: This event will be sent for tickets in the waiting list while the expert become available. NOTE: there are duplicates due to different hosts, you can add host field or remove the duplicates
 *
 * @param {autoRoutingOnExpertLevelArTenantParams} params - The parameters for this event
 * @property {string} sortedTicketsSummary - sorted_tickets_summary
 * @property {string} agentId - agent_id
 * @property {string} routingId - routing_id
 * @property {string} assignmentId - assignment_id
 * @property {string} failedTicketsSummary - failed_tickets_summary
 * @property {boolean} isTicketMatch - is_ticket_match
 * @property {GUID} interactionId - interaction_id
 * @property {string} ticketSelected - ticket_selected
 * @property {number} unassignedTicketsNum - unassigned_tickets_num
 * @property {string} agentSkillIds - agent_skill_ids
 * @property {string} pendingTickets - pending_tickets
 * @property {string} ticketSkillIds - ticket_skill_ids
 * @property {number} filteredTasks - filtered_tasks
 * @property {number} pendingTicketsNum - pending_tickets_num
 * @property {string} ticketGroupInfo - ticket_group_info
 * @property {string} unassignedTickets - unassigned_tickets
 * @property {string} channelId - channel_id
 * @return {LogObject<autoRoutingOnExpertLevelArTenantParams>} LogObject<autoRoutingOnExpertLevelArTenantParams>
 */
export function autoRoutingOnExpertLevelArTenant(params) {
    return { evid: 10302, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverAnswerToAutoRoutingExperts' event (evid: 10303)
 *
 * Event description: This event will be sent every time there is a routing attempt and the answer from the server if it's fails the routing attempt or not (for example if the same ticket is routed to more than one expert at the same routing attempt
 *
 * @param {serverAnswerToAutoRoutingExpertsParams} params - The parameters for this event
 * @property {GUID} agentSelected - agent_selected_id
 * @property {string} routingId - routing_id
 * @property {string} ticketSelected - ticket_selected
 * @property {number} statusId - status_id
 * @property {string} status - status_name
 * @property {boolean} isFailed - is_failed
 * @return {LogObject<serverAnswerToAutoRoutingExpertsParams>} LogObject<serverAnswerToAutoRoutingExpertsParams>
 */
export function serverAnswerToAutoRoutingExperts(params) {
    return { evid: 10303, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoContentComposer' event (evid: 10304)
 *
 * Event description: Fire when the KB writers interact with the AI Content Composer modal
 *
 * @param {kbBoContentComposerParams} params - The parameters for this event
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {GUID} user_answers_id - The Answers ID of the user that triggered the action
 * @property {GUID} article_id - The article for which the action was performed
 * @property {string} modal_name - {'content_generator' / 'content_rephraser'}
 * @property {string} action_type - {'load'/'click'}
 * @property {string} modal_step - {'add_parameters'/'options'}
 * @property {string} button_name - the name of the button the user clicked on
 * @property {string} params - The input parameters that the user added in the request for the generator service
 * @property {number} option_order - The order of the item that the user chose (from top to bottom)
 * @property {string} option_text - The text of the item the user chose
 * @property {string} article_language - The article language code for which the action was performed
 * @return {LogObject<kbBoContentComposerParams>} LogObject<kbBoContentComposerParams>
 */
export function kbBoContentComposer(params) {
    return { evid: 10304, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoWarningModal' event (evid: 10305)
 *
 * Event description: Fire when a warning/error/failed modal is loading inside the KB back office in Answers
 *
 * @param {kbBoWarningModalParams} params - The parameters for this event
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {GUID} user_answers_id - The Answers ID of the user that viewed the modal
 * @property {GUID} article_id - {optional} the article id for which the modal was opened for
 * @property {string} article_language - {optional} the article language code for which the modal was opened for
 * @property {string} warning_message_title - the text of the modal's title
 * @property {string} warning_message_sub_title - The text of the model's subtitle
 * @property {string} related_feature - the feature in the BO which the modal relates to
 * @property {string} modal_name - the modal unique name
 * @property {string} message_sub_title - The text of the model's subtitle
 * @property {string} message_title - the text of the modal's title
 * @return {LogObject<kbBoWarningModalParams>} LogObject<kbBoWarningModalParams>
 */
export function kbBoWarningModal(params) {
    return { evid: 10305, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoArticleAbTestStart' event (evid: 10307)
 *
 * Event description: Fire when a KB article AB test was started via the dedicated feature in the articles back office in Answers
 *
 * @param {kbBoArticleAbTestStartParams} params - The parameters for this event
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {GUID} user_answers_id - The Answers ID of the user that started the test
 * @property {GUID} article_id - The article ID for which the test was started
 * @property {string} article_language - The article language code for which the test was started
 * @property {string} experiment_id - The experiment ID in Petri of the test
 * @return {LogObject<kbBoArticleAbTestStartParams>} LogObject<kbBoArticleAbTestStartParams>
 */
export function kbBoArticleAbTestStart(params) {
    return { evid: 10307, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoArticleAbTestEnd' event (evid: 10309)
 *
 * Event description: Fire when a KB article AB test was ended via the dedicated feature in the articles back office in Answers
 *
 *
 * @param {kbBoArticleAbTestEndParams} params - The parameters for this event
 * @property {GUID} tenant_id	 - The tenant id in Answers
 * @property {GUID} user_answers_id	 - The Answers ID of the user that ended the test
 * @property {GUID} article_id - The article ID for which the test was ended
 * @property {string} article_language	 - The article language code for which the test was ended
 * @property {string} experiment_id - The experiment ID in Petri of the test
 * @property {string} published_version_2 - The article version that was opened to 100% after the test was ended {'A'/'B')
 * @return {LogObject<kbBoArticleAbTestEndParams>} LogObject<kbBoArticleAbTestEndParams>
 */
export function kbBoArticleAbTestEnd(params) {
    return { evid: 10309, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoAiContentGenerator' event (evid: 7700314)
 *
 * Event description: Fire when the AI content generator was activated in the article's back office
 *
 * @param {kbBoAiContentGeneratorParams} params - The parameters for this event
 * @property {GUID} article_id - The article for which the action was performed
 * @property {string} params - The input parameters that were passed with the request for the generator service
 * @property {GUID} user_answers_id - The Answers ID of the user that triggered the action
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {string} article_language - The article language code for which the action was performed
 * @property {string} locale - The article language code for which the action was performed
 * @return {LogObject<kbBoAiContentGeneratorParams>} LogObject<kbBoAiContentGeneratorParams>
 */
export function kbBoAiContentGenerator(params) {
    return { evid: 7700314, src: 77, endpoint: '', params };
}
//# sourceMappingURL=index.js.map